import { shallowRef as oe, watchEffect as Xt, readonly as je, ref as O, watch as I, customRef as et, getCurrentScope as La, onScopeDispose as uu, effectScope as Ia, getCurrentInstance as wt, provide as yi, inject as Kt, isRef as Pe, unref as ot, computed as C, reactive as ae, toRefs as br, toRef as Fa, onBeforeMount as lu, nextTick as Le, onBeforeUnmount as cu, onMounted as gi, onUnmounted as fu, isReactive as du, onUpdated as Ua, shallowReactive as wr, isReadonly as ni, onBeforeUpdate as pu, defineComponent as ri, h as Ui, TransitionGroup as hu, markRaw as vu, Fragment as mu, toValue as Lt } from "vue";
import { useRoute as bi, useRouter as wi } from "vue-router";
function Qh(e, t) {
  var n;
  const r = oe();
  return Xt(() => {
    r.value = e();
  }, {
    ...t,
    flush: (n = t == null ? void 0 : t.flush) != null ? n : "sync"
  }), je(r);
}
function za(e, t) {
  let n, r, o;
  const i = O(!0), a = () => {
    i.value = !0, o();
  };
  I(e, a, { flush: "sync" });
  const s = typeof t == "function" ? t : t.get, u = typeof t == "function" ? void 0 : t.set, l = et((f, d) => (r = f, o = d, {
    get() {
      return i.value && (n = s(), i.value = !1), r(), n;
    },
    set(y) {
      u == null || u(y);
    }
  }));
  return Object.isExtensible(l) && (l.trigger = a), l;
}
function V(e) {
  return La() ? (uu(e), !0) : !1;
}
function Te() {
  const e = /* @__PURE__ */ new Set(), t = (o) => {
    e.delete(o);
  };
  return {
    on: (o) => {
      e.add(o);
      const i = () => t(o);
      return V(i), {
        off: i
      };
    },
    off: t,
    trigger: (...o) => Promise.all(Array.from(e).map((i) => i(...o)))
  };
}
function qh(e) {
  let t = !1, n;
  const r = Ia(!0);
  return (...o) => (t || (n = r.run(() => e(...o)), t = !0), n);
}
const Gt = /* @__PURE__ */ new WeakMap(), yu = (e, t) => {
  var n;
  const r = (n = wt()) == null ? void 0 : n.proxy;
  if (r == null)
    throw new Error("provideLocal must be called in setup");
  Gt.has(r) || Gt.set(r, /* @__PURE__ */ Object.create(null));
  const o = Gt.get(r);
  o[e] = t, yi(e, t);
}, gu = (...e) => {
  var t;
  const n = e[0], r = (t = wt()) == null ? void 0 : t.proxy;
  if (r == null)
    throw new Error("injectLocal must be called in setup");
  return Gt.has(r) && n in Gt.get(r) ? Gt.get(r)[n] : Kt(...e);
};
function ev(e, t) {
  const n = (t == null ? void 0 : t.injectionKey) || Symbol("InjectionState");
  return [(...i) => {
    const a = e(...i);
    return yu(n, a), a;
  }, () => gu(n)];
}
function tv(e) {
  let t = 0, n, r;
  const o = () => {
    t -= 1, r && t <= 0 && (r.stop(), n = void 0, r = void 0);
  };
  return (...i) => (t += 1, n || (r = Ia(!0), n = r.run(() => e(...i))), V(o), n);
}
function bu(e, t, { enumerable: n = !1, unwrap: r = !0 } = {}) {
  for (const [o, i] of Object.entries(t))
    o !== "value" && (Pe(i) && r ? Object.defineProperty(e, o, {
      get() {
        return i.value;
      },
      set(a) {
        i.value = a;
      },
      enumerable: n
    }) : Object.defineProperty(e, o, { value: i, enumerable: n }));
  return e;
}
function nv(e, t) {
  return t == null ? ot(e) : ot(e)[t];
}
function rv(e) {
  return ot(e) != null;
}
function wu(e, t) {
  if (typeof Symbol < "u") {
    const n = { ...e };
    return Object.defineProperty(n, Symbol.iterator, {
      enumerable: !1,
      value() {
        let r = 0;
        return {
          next: () => ({
            value: t[r++],
            done: r > t.length
          })
        };
      }
    }), n;
  } else
    return Object.assign([...t], e);
}
function T(e) {
  return typeof e == "function" ? e() : ot(e);
}
const ov = T;
function Su(e, t) {
  const n = (t == null ? void 0 : t.computedGetter) === !1 ? ot : T;
  return function(...r) {
    return C(() => e.apply(this, r.map((o) => n(o))));
  };
}
function iv(e, t = {}) {
  let n = [], r;
  if (Array.isArray(t))
    n = t;
  else {
    r = t;
    const { includeOwnProperties: o = !0 } = t;
    n.push(...Object.keys(e)), o && n.push(...Object.getOwnPropertyNames(e));
  }
  return Object.fromEntries(
    n.map((o) => {
      const i = e[o];
      return [
        o,
        typeof i == "function" ? Su(i.bind(e), r) : i
      ];
    })
  );
}
function Pu(e) {
  if (!Pe(e))
    return ae(e);
  const t = new Proxy({}, {
    get(n, r, o) {
      return ot(Reflect.get(e.value, r, o));
    },
    set(n, r, o) {
      return Pe(e.value[r]) && !Pe(o) ? e.value[r].value = o : e.value[r] = o, !0;
    },
    deleteProperty(n, r) {
      return Reflect.deleteProperty(e.value, r);
    },
    has(n, r) {
      return Reflect.has(e.value, r);
    },
    ownKeys() {
      return Object.keys(e.value);
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    }
  });
  return ae(t);
}
function Ka(e) {
  return Pu(C(e));
}
function av(e, ...t) {
  const n = t.flat(), r = n[0];
  return Ka(() => Object.fromEntries(typeof r == "function" ? Object.entries(br(e)).filter(([o, i]) => !r(T(i), o)) : Object.entries(br(e)).filter((o) => !n.includes(o[0]))));
}
const xe = typeof window < "u" && typeof document < "u", xu = typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope, _u = (e) => typeof e < "u", Ga = (e) => e != null, sv = (e, ...t) => {
  e || console.warn(...t);
}, Ou = Object.prototype.toString, Cr = (e) => Ou.call(e) === "[object Object]", uv = () => Date.now(), Ht = () => +Date.now(), Ro = (e, t, n) => Math.min(n, Math.max(t, e)), re = () => {
}, lv = (e, t) => (e = Math.ceil(e), t = Math.floor(t), Math.floor(Math.random() * (t - e + 1)) + e), Eu = (e, t) => Object.prototype.hasOwnProperty.call(e, t), oi = /* @__PURE__ */ Tu();
function Tu() {
  var e, t;
  return xe && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Vt(e, t) {
  function n(...r) {
    return new Promise((o, i) => {
      Promise.resolve(e(() => t.apply(this, r), { fn: t, thisArg: this, args: r })).then(o).catch(i);
    });
  }
  return n;
}
const Dr = (e) => e();
function Si(e, t = {}) {
  let n, r, o = re;
  const i = (s) => {
    clearTimeout(s), o(), o = re;
  };
  return (s) => {
    const u = T(e), l = T(t.maxWait);
    return n && i(n), u <= 0 || l !== void 0 && l <= 0 ? (r && (i(r), r = null), Promise.resolve(s())) : new Promise((f, d) => {
      o = t.rejectOnCancel ? d : f, l && !r && (r = setTimeout(() => {
        n && i(n), r = null, f(s());
      }, l)), n = setTimeout(() => {
        r && i(r), r = null, f(s());
      }, u);
    });
  };
}
function Rr(e, t = !0, n = !0, r = !1) {
  let o = 0, i, a = !0, s = re, u;
  const l = () => {
    i && (clearTimeout(i), i = void 0, s(), s = re);
  };
  return (d) => {
    const y = T(e), v = Date.now() - o, p = () => u = d();
    return l(), y <= 0 ? (o = Date.now(), p()) : (v > y && (n || !a) ? (o = Date.now(), p()) : t && (u = new Promise((S, _) => {
      s = r ? _ : S, i = setTimeout(() => {
        o = Date.now(), a = !0, S(p()), l();
      }, Math.max(0, y - v));
    })), !n && !i && (i = setTimeout(() => a = !0, y)), a = !1, u);
  };
}
function Za(e = Dr) {
  const t = O(!0);
  function n() {
    t.value = !1;
  }
  function r() {
    t.value = !0;
  }
  const o = (...i) => {
    t.value && e(...i);
  };
  return { isActive: je(t), pause: n, resume: r, eventFilter: o };
}
const cv = {
  mounted: "mounted",
  updated: "updated",
  unmounted: "unmounted"
};
function Xa(e) {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}
const Au = /\B([A-Z])/g, fv = Xa((e) => e.replace(Au, "-$1").toLowerCase()), Mu = /-(\w)/g, ku = Xa((e) => e.replace(Mu, (t, n) => n ? n.toUpperCase() : ""));
function Sr(e, t = !1, n = "Timeout") {
  return new Promise((r, o) => {
    setTimeout(t ? () => o(n) : r, e);
  });
}
function Ha(e) {
  return e;
}
function ju(e) {
  let t;
  function n() {
    return t || (t = e()), t;
  }
  return n.reset = async () => {
    const r = t;
    t = void 0, r && await r;
  }, n;
}
function dv(e) {
  return e();
}
function Ba(e, ...t) {
  return t.some((n) => n in e);
}
function Cu(e, t) {
  var n;
  if (typeof e == "number")
    return e + t;
  const r = ((n = e.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : n[0]) || "", o = e.slice(r.length), i = Number.parseFloat(r) + t;
  return Number.isNaN(i) ? e : i + o;
}
function Du(e, t, n = !1) {
  return t.reduce((r, o) => (o in e && (!n || e[o] !== void 0) && (r[o] = e[o]), r), {});
}
function Ru(e, t, n = !1) {
  return Object.fromEntries(Object.entries(e).filter(([r, o]) => (!n || o !== void 0) && !t.includes(r)));
}
function Nu(e) {
  return Object.entries(e);
}
function Nr(e) {
  return e || wt();
}
function ve(...e) {
  if (e.length !== 1)
    return Fa(...e);
  const t = e[0];
  return typeof t == "function" ? je(et(() => ({ get: t, set: re }))) : O(t);
}
const pv = ve;
function hv(e, ...t) {
  const n = t.flat(), r = n[0];
  return Ka(() => Object.fromEntries(typeof r == "function" ? Object.entries(br(e)).filter(([o, i]) => r(T(i), o)) : n.map((o) => [o, ve(e, o)])));
}
function vv(e, t = 1e4) {
  return et((n, r) => {
    let o = T(e), i;
    const a = () => setTimeout(() => {
      o = T(e), r();
    }, T(t));
    return V(() => {
      clearTimeout(i);
    }), {
      get() {
        return n(), o;
      },
      set(s) {
        o = s, r(), clearTimeout(i), i = a();
      }
    };
  });
}
function Pi(e, t = 200, n = {}) {
  return Vt(
    Si(t, n),
    e
  );
}
function mv(e, t = 200, n = {}) {
  const r = O(e.value), o = Pi(() => {
    r.value = e.value;
  }, t, n);
  return I(e, () => o()), r;
}
function yv(e, t) {
  return C({
    get() {
      var n;
      return (n = e.value) != null ? n : t;
    },
    set(n) {
      e.value = n;
    }
  });
}
function Va(e, t = 200, n = !1, r = !0, o = !1) {
  return Vt(
    Rr(t, n, r, o),
    e
  );
}
function gv(e, t = 200, n = !0, r = !0) {
  if (t <= 0)
    return e;
  const o = O(e.value), i = Va(() => {
    o.value = e.value;
  }, t, n, r);
  return I(e, () => i()), o;
}
function Lu(e, t = {}) {
  let n = e, r, o;
  const i = et((y, v) => (r = y, o = v, {
    get() {
      return a();
    },
    set(p) {
      s(p);
    }
  }));
  function a(y = !0) {
    return y && r(), n;
  }
  function s(y, v = !0) {
    var p, S;
    if (y === n)
      return;
    const _ = n;
    ((p = t.onBeforeChange) == null ? void 0 : p.call(t, y, _)) !== !1 && (n = y, (S = t.onChanged) == null || S.call(t, y, _), v && o());
  }
  return bu(
    i,
    {
      get: a,
      set: s,
      untrackedGet: () => a(!1),
      silentSet: (y) => s(y, !1),
      peek: () => a(!1),
      lay: (y) => s(y, !1)
    },
    { enumerable: !0 }
  );
}
const bv = Lu;
function wv(...e) {
  if (e.length === 2) {
    const [t, n] = e;
    t.value = n;
  }
  if (e.length === 3) {
    const [t, n, r] = e;
    t[n] = r;
  }
}
function kn(e, t, n = {}) {
  const {
    eventFilter: r = Dr,
    ...o
  } = n;
  return I(
    e,
    Vt(
      r,
      t
    ),
    o
  );
}
function Pr(e, t, n = {}) {
  const {
    eventFilter: r,
    ...o
  } = n, { eventFilter: i, pause: a, resume: s, isActive: u } = Za(r);
  return { stop: kn(
    e,
    t,
    {
      ...o,
      eventFilter: i
    }
  ), pause: a, resume: s, isActive: u };
}
function zi(e, t, ...[n]) {
  const {
    flush: r = "sync",
    deep: o = !1,
    immediate: i = !0,
    direction: a = "both",
    transform: s = {}
  } = n || {}, u = [], l = "ltr" in s && s.ltr || ((y) => y), f = "rtl" in s && s.rtl || ((y) => y);
  return (a === "both" || a === "ltr") && u.push(Pr(
    e,
    (y) => {
      u.forEach((v) => v.pause()), t.value = l(y), u.forEach((v) => v.resume());
    },
    { flush: r, deep: o, immediate: i }
  )), (a === "both" || a === "rtl") && u.push(Pr(
    t,
    (y) => {
      u.forEach((v) => v.pause()), e.value = f(y), u.forEach((v) => v.resume());
    },
    { flush: r, deep: o, immediate: i }
  )), () => {
    u.forEach((y) => y.stop());
  };
}
function Sv(e, t, n = {}) {
  const {
    flush: r = "sync",
    deep: o = !1,
    immediate: i = !0
  } = n;
  return Array.isArray(t) || (t = [t]), I(
    e,
    (a) => t.forEach((s) => s.value = a),
    { flush: r, deep: o, immediate: i }
  );
}
function Wa(e, t = {}) {
  if (!Pe(e))
    return br(e);
  const n = Array.isArray(e.value) ? Array.from({ length: e.value.length }) : {};
  for (const r in e.value)
    n[r] = et(() => ({
      get() {
        return e.value[r];
      },
      set(o) {
        var i;
        if ((i = T(t.replaceRef)) != null ? i : !0)
          if (Array.isArray(e.value)) {
            const s = [...e.value];
            s[r] = o, e.value = s;
          } else {
            const s = { ...e.value, [r]: o };
            Object.setPrototypeOf(s, Object.getPrototypeOf(e.value)), e.value = s;
          }
        else
          e.value[r] = o;
      }
    }));
  return n;
}
function Pv(e, t = !0, n) {
  const r = Nr(n);
  r ? lu(e, r) : t ? e() : Le(e);
}
function Iu(e, t) {
  const n = Nr(t);
  n && cu(e, n);
}
function me(e, t = !0, n) {
  const r = Nr(n);
  r ? gi(e, r) : t ? e() : Le(e);
}
function Fu(e, t) {
  const n = Nr(t);
  n && fu(e, n);
}
function ii(e, t = !1) {
  function n(d, { flush: y = "sync", deep: v = !1, timeout: p, throwOnTimeout: S } = {}) {
    let _ = null;
    const b = [new Promise((h) => {
      _ = I(
        e,
        (m) => {
          d(m) !== t && (_ == null || _(), h(m));
        },
        {
          flush: y,
          deep: v,
          immediate: !0
        }
      );
    })];
    return p != null && b.push(
      Sr(p, S).then(() => T(e)).finally(() => _ == null ? void 0 : _())
    ), Promise.race(b);
  }
  function r(d, y) {
    if (!Pe(d))
      return n((m) => m === d, y);
    const { flush: v = "sync", deep: p = !1, timeout: S, throwOnTimeout: _ } = y ?? {};
    let g = null;
    const h = [new Promise((m) => {
      g = I(
        [e, d],
        ([P, x]) => {
          t !== (P === x) && (g == null || g(), m(P));
        },
        {
          flush: v,
          deep: p,
          immediate: !0
        }
      );
    })];
    return S != null && h.push(
      Sr(S, _).then(() => T(e)).finally(() => (g == null || g(), T(e)))
    ), Promise.race(h);
  }
  function o(d) {
    return n((y) => !!y, d);
  }
  function i(d) {
    return r(null, d);
  }
  function a(d) {
    return r(void 0, d);
  }
  function s(d) {
    return n(Number.isNaN, d);
  }
  function u(d, y) {
    return n((v) => {
      const p = Array.from(v);
      return p.includes(d) || p.includes(T(d));
    }, y);
  }
  function l(d) {
    return f(1, d);
  }
  function f(d = 1, y) {
    let v = -1;
    return n(() => (v += 1, v >= d), y);
  }
  return Array.isArray(T(e)) ? {
    toMatch: n,
    toContains: u,
    changed: l,
    changedTimes: f,
    get not() {
      return ii(e, !t);
    }
  } : {
    toMatch: n,
    toBe: r,
    toBeTruthy: o,
    toBeNull: i,
    toBeNaN: s,
    toBeUndefined: a,
    changed: l,
    changedTimes: f,
    get not() {
      return ii(e, !t);
    }
  };
}
function xr(e) {
  return ii(e);
}
function Uu(e, t) {
  return e === t;
}
function xv(...e) {
  var t;
  const n = e[0], r = e[1];
  let o = (t = e[2]) != null ? t : Uu;
  if (typeof o == "string") {
    const i = o;
    o = (a, s) => a[i] === s[i];
  }
  return C(() => T(n).filter((i) => T(r).findIndex((a) => o(i, a)) === -1));
}
function _v(e, t) {
  return C(() => T(e).every((n, r, o) => t(T(n), r, o)));
}
function Ov(e, t) {
  return C(() => T(e).map((n) => T(n)).filter(t));
}
function Ev(e, t) {
  return C(() => T(
    T(e).find((n, r, o) => t(T(n), r, o))
  ));
}
function Tv(e, t) {
  return C(() => T(e).findIndex((n, r, o) => t(T(n), r, o)));
}
function zu(e, t) {
  let n = e.length;
  for (; n-- > 0; )
    if (t(e[n], n, e))
      return e[n];
}
function Av(e, t) {
  return C(() => T(
    Array.prototype.findLast ? T(e).findLast((n, r, o) => t(T(n), r, o)) : zu(T(e), (n, r, o) => t(T(n), r, o))
  ));
}
function Ku(e) {
  return Cr(e) && Ba(e, "formIndex", "comparator");
}
function Mv(...e) {
  var t;
  const n = e[0], r = e[1];
  let o = e[2], i = 0;
  if (Ku(o) && (i = (t = o.fromIndex) != null ? t : 0, o = o.comparator), typeof o == "string") {
    const a = o;
    o = (s, u) => s[a] === T(u);
  }
  return o = o ?? ((a, s) => a === T(s)), C(() => T(n).slice(i).some((a, s, u) => o(
    T(a),
    T(r),
    s,
    T(u)
  )));
}
function kv(e, t) {
  return C(() => T(e).map((n) => T(n)).join(T(t)));
}
function jv(e, t) {
  return C(() => T(e).map((n) => T(n)).map(t));
}
function Cv(e, t, ...n) {
  const r = (o, i, a) => t(T(o), T(i), a);
  return C(() => {
    const o = T(e);
    return n.length ? o.reduce(r, T(n[0])) : o.reduce(r);
  });
}
function Dv(e, t) {
  return C(() => T(e).some((n, r, o) => t(T(n), r, o)));
}
function Gu(e) {
  return Array.from(new Set(e));
}
function Zu(e, t) {
  return e.reduce((n, r) => (n.some((o) => t(r, o, e)) || n.push(r), n), []);
}
function Rv(e, t) {
  return C(() => {
    const n = T(e).map((r) => T(r));
    return t ? Zu(n, t) : Gu(n);
  });
}
function Nv(e = 0, t = {}) {
  let n = ot(e);
  const r = O(e), {
    max: o = Number.POSITIVE_INFINITY,
    min: i = Number.NEGATIVE_INFINITY
  } = t, a = (d = 1) => r.value = Math.min(o, r.value + d), s = (d = 1) => r.value = Math.max(i, r.value - d), u = () => r.value, l = (d) => r.value = Math.max(i, Math.min(o, d));
  return { count: r, inc: a, dec: s, get: u, set: l, reset: (d = n) => (n = d, l(d)) };
}
const Xu = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, Hu = /[YMDHhms]o|\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a{1,2}|A{1,2}|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
function Bu(e, t, n, r) {
  let o = e < 12 ? "AM" : "PM";
  return r && (o = o.split("").reduce((i, a) => i += `${a}.`, "")), n ? o.toLowerCase() : o;
}
function dt(e) {
  const t = ["th", "st", "nd", "rd"], n = e % 100;
  return e + (t[(n - 20) % 10] || t[n] || t[0]);
}
function Vu(e, t, n = {}) {
  var r;
  const o = e.getFullYear(), i = e.getMonth(), a = e.getDate(), s = e.getHours(), u = e.getMinutes(), l = e.getSeconds(), f = e.getMilliseconds(), d = e.getDay(), y = (r = n.customMeridiem) != null ? r : Bu, v = {
    Yo: () => dt(o),
    YY: () => String(o).slice(-2),
    YYYY: () => o,
    M: () => i + 1,
    Mo: () => dt(i + 1),
    MM: () => `${i + 1}`.padStart(2, "0"),
    MMM: () => e.toLocaleDateString(n.locales, { month: "short" }),
    MMMM: () => e.toLocaleDateString(n.locales, { month: "long" }),
    D: () => String(a),
    Do: () => dt(a),
    DD: () => `${a}`.padStart(2, "0"),
    H: () => String(s),
    Ho: () => dt(s),
    HH: () => `${s}`.padStart(2, "0"),
    h: () => `${s % 12 || 12}`.padStart(1, "0"),
    ho: () => dt(s % 12 || 12),
    hh: () => `${s % 12 || 12}`.padStart(2, "0"),
    m: () => String(u),
    mo: () => dt(u),
    mm: () => `${u}`.padStart(2, "0"),
    s: () => String(l),
    so: () => dt(l),
    ss: () => `${l}`.padStart(2, "0"),
    SSS: () => `${f}`.padStart(3, "0"),
    d: () => d,
    dd: () => e.toLocaleDateString(n.locales, { weekday: "narrow" }),
    ddd: () => e.toLocaleDateString(n.locales, { weekday: "short" }),
    dddd: () => e.toLocaleDateString(n.locales, { weekday: "long" }),
    A: () => y(s, u),
    AA: () => y(s, u, !1, !0),
    a: () => y(s, u, !0),
    aa: () => y(s, u, !0, !0)
  };
  return t.replace(Hu, (p, S) => {
    var _, g;
    return (g = S ?? ((_ = v[p]) == null ? void 0 : _.call(v))) != null ? g : p;
  });
}
function Wu(e) {
  if (e === null)
    return new Date(Number.NaN);
  if (e === void 0)
    return /* @__PURE__ */ new Date();
  if (e instanceof Date)
    return new Date(e);
  if (typeof e == "string" && !/Z$/i.test(e)) {
    const t = e.match(Xu);
    if (t) {
      const n = t[2] - 1 || 0, r = (t[7] || "0").substring(0, 3);
      return new Date(t[1], n, t[3] || 1, t[4] || 0, t[5] || 0, t[6] || 0, r);
    }
  }
  return new Date(e);
}
function Lv(e, t = "HH:mm:ss", n = {}) {
  return C(() => Vu(Wu(T(e)), T(t), n));
}
function St(e, t = 1e3, n = {}) {
  const {
    immediate: r = !0,
    immediateCallback: o = !1
  } = n;
  let i = null;
  const a = O(!1);
  function s() {
    i && (clearInterval(i), i = null);
  }
  function u() {
    a.value = !1, s();
  }
  function l() {
    const f = T(t);
    f <= 0 || (a.value = !0, o && e(), s(), i = setInterval(e, f));
  }
  if (r && xe && l(), Pe(t) || typeof t == "function") {
    const f = I(t, () => {
      a.value && xe && l();
    });
    V(f);
  }
  return V(u), {
    isActive: a,
    pause: u,
    resume: l
  };
}
function Iv(e = 1e3, t = {}) {
  const {
    controls: n = !1,
    immediate: r = !0,
    callback: o
  } = t, i = O(0), a = () => i.value += 1, s = () => {
    i.value = 0;
  }, u = St(
    o ? () => {
      a(), o(i.value);
    } : a,
    e,
    { immediate: r }
  );
  return n ? {
    counter: i,
    reset: s,
    ...u
  } : i;
}
function Fv(e, t = {}) {
  var n;
  const r = O((n = t.initialValue) != null ? n : null);
  return I(
    e,
    () => r.value = Ht(),
    t
  ), r;
}
function jn(e, t, n = {}) {
  const {
    immediate: r = !0
  } = n, o = O(!1);
  let i = null;
  function a() {
    i && (clearTimeout(i), i = null);
  }
  function s() {
    o.value = !1, a();
  }
  function u(...l) {
    a(), o.value = !0, i = setTimeout(() => {
      o.value = !1, i = null, e(...l);
    }, T(t));
  }
  return r && (o.value = !0, xe && u()), V(s), {
    isPending: je(o),
    start: u,
    stop: s
  };
}
function Uv(e = 1e3, t = {}) {
  const {
    controls: n = !1,
    callback: r
  } = t, o = jn(
    r ?? re,
    e,
    t
  ), i = C(() => !o.isPending.value);
  return n ? {
    ready: i,
    ...o
  } : i;
}
function zv(e, t = {}) {
  const {
    method: n = "parseFloat",
    radix: r,
    nanToZero: o
  } = t;
  return C(() => {
    let i = T(e);
    return typeof i == "string" && (i = Number[n](i, r)), o && Number.isNaN(i) && (i = 0), i;
  });
}
function Kv(e) {
  return C(() => `${T(e)}`);
}
function Gv(e = !1, t = {}) {
  const {
    truthyValue: n = !0,
    falsyValue: r = !1
  } = t, o = Pe(e), i = O(e);
  function a(s) {
    if (arguments.length)
      return i.value = s, i.value;
    {
      const u = T(n);
      return i.value = i.value === u ? T(r) : u, i.value;
    }
  }
  return o ? a : [i, a];
}
function Zv(e, t, n) {
  let r = n != null && n.immediate ? [] : [...e instanceof Function ? e() : Array.isArray(e) ? e : T(e)];
  return I(e, (o, i, a) => {
    const s = Array.from({ length: r.length }), u = [];
    for (const f of o) {
      let d = !1;
      for (let y = 0; y < r.length; y++)
        if (!s[y] && f === r[y]) {
          s[y] = !0, d = !0;
          break;
        }
      d || u.push(f);
    }
    const l = r.filter((f, d) => !s[d]);
    t(o, r, u, l, a), r = [...o];
  }, n);
}
function Xv(e, t, n) {
  const {
    count: r,
    ...o
  } = n, i = O(0), a = kn(
    e,
    (...s) => {
      i.value += 1, i.value >= T(r) && Le(() => a()), t(...s);
    },
    o
  );
  return { count: i, stop: a };
}
function Hv(e, t, n = {}) {
  const {
    debounce: r = 0,
    maxWait: o = void 0,
    ...i
  } = n;
  return kn(
    e,
    t,
    {
      ...i,
      eventFilter: Si(r, { maxWait: o })
    }
  );
}
function Bv(e, t, n) {
  return I(
    e,
    t,
    {
      ...n,
      deep: !0
    }
  );
}
function _r(e, t, n = {}) {
  const {
    eventFilter: r = Dr,
    ...o
  } = n, i = Vt(
    r,
    t
  );
  let a, s, u;
  if (o.flush === "sync") {
    const l = O(!1);
    s = () => {
    }, a = (f) => {
      l.value = !0, f(), l.value = !1;
    }, u = I(
      e,
      (...f) => {
        l.value || i(...f);
      },
      o
    );
  } else {
    const l = [], f = O(0), d = O(0);
    s = () => {
      f.value = d.value;
    }, l.push(
      I(
        e,
        () => {
          d.value++;
        },
        { ...o, flush: "sync" }
      )
    ), a = (y) => {
      const v = d.value;
      y(), f.value += d.value - v;
    }, l.push(
      I(
        e,
        (...y) => {
          const v = f.value > 0 && f.value === d.value;
          f.value = 0, d.value = 0, !v && i(...y);
        },
        o
      )
    ), u = () => {
      l.forEach((y) => y());
    };
  }
  return { stop: u, ignoreUpdates: a, ignorePrevAsyncUpdates: s };
}
function Vv(e, t, n) {
  return I(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
function Wv(e, t, n) {
  const r = I(e, (...o) => (Le(() => r()), t(...o)), n);
  return r;
}
function Jv(e, t, n = {}) {
  const {
    throttle: r = 0,
    trailing: o = !0,
    leading: i = !0,
    ...a
  } = n;
  return kn(
    e,
    t,
    {
      ...a,
      eventFilter: Rr(r, o, i)
    }
  );
}
function Yv(e, t, n = {}) {
  let r;
  function o() {
    if (!r)
      return;
    const f = r;
    r = void 0, f();
  }
  function i(f) {
    r = f;
  }
  const a = (f, d) => (o(), t(f, d, i)), s = _r(e, a, n), { ignoreUpdates: u } = s;
  return {
    ...s,
    trigger: () => {
      let f;
      return u(() => {
        f = a(Ju(e), Yu(e));
      }), f;
    }
  };
}
function Ju(e) {
  return du(e) ? e : Array.isArray(e) ? e.map((t) => T(t)) : T(e);
}
function Yu(e) {
  return Array.isArray(e) ? e.map(() => {
  }) : void 0;
}
function $v(e, t, n) {
  return I(
    e,
    (r, o, i) => {
      r && t(r, o, i);
    },
    n
  );
}
function Qv(e, t, n) {
  let r;
  Pe(n) ? r = {
    evaluating: n
  } : r = n || {};
  const {
    lazy: o = !1,
    evaluating: i = void 0,
    shallow: a = !0,
    onError: s = re
  } = r, u = O(!o), l = a ? oe(t) : O(t);
  let f = 0;
  return Xt(async (d) => {
    if (!u.value)
      return;
    f++;
    const y = f;
    let v = !1;
    i && Promise.resolve().then(() => {
      i.value = !0;
    });
    try {
      const p = await e((S) => {
        d(() => {
          i && (i.value = !1), v || S();
        });
      });
      y === f && (l.value = p);
    } catch (p) {
      s(p);
    } finally {
      i && y === f && (i.value = !1), v = !0;
    }
  }), o ? C(() => (u.value = !0, l.value)) : l;
}
function qv(e, t, n, r) {
  let o = Kt(e);
  return n && (o = Kt(e, n)), r && (o = Kt(e, n, r)), typeof t == "function" ? C((i) => t(o, i)) : C({
    get: (i) => t.get(o, i),
    set: t.set
  });
}
function em(e = {}) {
  const {
    inheritAttrs: t = !0
  } = e, n = oe(), r = /* @__PURE__ */ ri({
    setup(i, { slots: a }) {
      return () => {
        n.value = a.default;
      };
    }
  }), o = /* @__PURE__ */ ri({
    inheritAttrs: t,
    setup(i, { attrs: a, slots: s }) {
      return () => {
        var u;
        if (!n.value && process.env.NODE_ENV !== "production")
          throw new Error("[VueUse] Failed to find the definition of reusable template");
        const l = (u = n.value) == null ? void 0 : u.call(n, { ...$u(a), $slots: s });
        return t && (l == null ? void 0 : l.length) === 1 ? l[0] : l;
      };
    }
  });
  return wu(
    { define: r, reuse: o },
    [r, o]
  );
}
function $u(e) {
  const t = {};
  for (const n in e)
    t[ku(n)] = e[n];
  return t;
}
function tm(e = {}) {
  let t = 0;
  const n = O([]);
  function r(...a) {
    const s = wr({
      key: t++,
      args: a,
      promise: void 0,
      resolve: () => {
      },
      reject: () => {
      },
      isResolving: !1,
      options: e
    });
    return n.value.push(s), s.promise = new Promise((u, l) => {
      s.resolve = (f) => (s.isResolving = !0, u(f)), s.reject = l;
    }).finally(() => {
      s.promise = void 0;
      const u = n.value.indexOf(s);
      u !== -1 && n.value.splice(u, 1);
    }), s.promise;
  }
  function o(...a) {
    return e.singleton && n.value.length > 0 ? n.value[0].promise : r(...a);
  }
  const i = /* @__PURE__ */ ri((a, { slots: s }) => {
    const u = () => n.value.map((l) => {
      var f;
      return Ui(mu, { key: l.key }, (f = s.default) == null ? void 0 : f.call(s, l));
    });
    return e.transition ? () => Ui(hu, e.transition, u) : u;
  });
  return i.start = o, i;
}
function nm(e) {
  return function(...t) {
    return e.apply(this, t.map((n) => T(n)));
  };
}
function Y(e) {
  var t;
  const n = T(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const U = xe ? window : void 0, Me = xe ? window.document : void 0, Ce = xe ? window.navigator : void 0, rm = xe ? window.location : void 0;
function R(...e) {
  let t, n, r, o;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, r, o] = e, t = U) : [t, n, r, o] = e, !t)
    return re;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const i = [], a = () => {
    i.forEach((f) => f()), i.length = 0;
  }, s = (f, d, y, v) => (f.addEventListener(d, y, v), () => f.removeEventListener(d, y, v)), u = I(
    () => [Y(t), T(o)],
    ([f, d]) => {
      if (a(), !f)
        return;
      const y = Cr(d) ? { ...d } : d;
      i.push(
        ...n.flatMap((v) => r.map((p) => s(f, v, p, y)))
      );
    },
    { immediate: !0, flush: "post" }
  ), l = () => {
    u(), a();
  };
  return V(l), l;
}
let Ki = !1;
function om(e, t, n = {}) {
  const { window: r = U, ignore: o = [], capture: i = !0, detectIframe: a = !1 } = n;
  if (!r)
    return;
  oi && !Ki && (Ki = !0, Array.from(r.document.body.children).forEach((y) => y.addEventListener("click", re)), r.document.documentElement.addEventListener("click", re));
  let s = !0;
  const u = (y) => o.some((v) => {
    if (typeof v == "string")
      return Array.from(r.document.querySelectorAll(v)).some((p) => p === y.target || y.composedPath().includes(p));
    {
      const p = Y(v);
      return p && (y.target === p || y.composedPath().includes(p));
    }
  }), f = [
    R(r, "click", (y) => {
      const v = Y(e);
      if (!(!v || v === y.target || y.composedPath().includes(v))) {
        if (y.detail === 0 && (s = !u(y)), !s) {
          s = !0;
          return;
        }
        t(y);
      }
    }, { passive: !0, capture: i }),
    R(r, "pointerdown", (y) => {
      const v = Y(e);
      s = !u(y) && !!(v && !y.composedPath().includes(v));
    }, { passive: !0 }),
    a && R(r, "blur", (y) => {
      setTimeout(() => {
        var v;
        const p = Y(e);
        ((v = r.document.activeElement) == null ? void 0 : v.tagName) === "IFRAME" && !(p != null && p.contains(r.document.activeElement)) && t(y);
      }, 0);
    })
  ].filter(Boolean);
  return () => f.forEach((y) => y());
}
function Qu(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function xi(...e) {
  let t, n, r = {};
  e.length === 3 ? (t = e[0], n = e[1], r = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], r = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
  const {
    target: o = U,
    eventName: i = "keydown",
    passive: a = !1,
    dedupe: s = !1
  } = r, u = Qu(t);
  return R(o, i, (f) => {
    f.repeat && T(s) || u(f) && n(f);
  }, a);
}
function im(e, t, n = {}) {
  return xi(e, t, { ...n, eventName: "keydown" });
}
function am(e, t, n = {}) {
  return xi(e, t, { ...n, eventName: "keypress" });
}
function sm(e, t, n = {}) {
  return xi(e, t, { ...n, eventName: "keyup" });
}
const qu = 500, el = 10;
function um(e, t, n) {
  var r, o;
  const i = C(() => Y(e));
  let a, s;
  function u() {
    a && (clearTimeout(a), a = void 0), s = void 0;
  }
  function l(p) {
    var S, _, g, b;
    (S = n == null ? void 0 : n.modifiers) != null && S.self && p.target !== i.value || (u(), (_ = n == null ? void 0 : n.modifiers) != null && _.prevent && p.preventDefault(), (g = n == null ? void 0 : n.modifiers) != null && g.stop && p.stopPropagation(), s = {
      x: p.x,
      y: p.y
    }, a = setTimeout(
      () => t(p),
      (b = n == null ? void 0 : n.delay) != null ? b : qu
    ));
  }
  function f(p) {
    var S, _, g, b;
    if ((S = n == null ? void 0 : n.modifiers) != null && S.self && p.target !== i.value || !s || (n == null ? void 0 : n.distanceThreshold) === !1)
      return;
    (_ = n == null ? void 0 : n.modifiers) != null && _.prevent && p.preventDefault(), (g = n == null ? void 0 : n.modifiers) != null && g.stop && p.stopPropagation();
    const h = p.x - s.x, m = p.y - s.y;
    Math.sqrt(h * h + m * m) >= ((b = n == null ? void 0 : n.distanceThreshold) != null ? b : el) && u();
  }
  const d = {
    capture: (r = n == null ? void 0 : n.modifiers) == null ? void 0 : r.capture,
    once: (o = n == null ? void 0 : n.modifiers) == null ? void 0 : o.once
  }, y = [
    R(i, "pointerdown", l, d),
    R(i, "pointermove", f, d),
    R(i, ["pointerup", "pointerleave"], u, d)
  ];
  return () => y.forEach((p) => p());
}
function tl() {
  const { activeElement: e, body: t } = document;
  if (!e || e === t)
    return !1;
  switch (e.tagName) {
    case "INPUT":
    case "TEXTAREA":
      return !0;
  }
  return e.hasAttribute("contenteditable");
}
function nl({
  keyCode: e,
  metaKey: t,
  ctrlKey: n,
  altKey: r
}) {
  return t || n || r ? !1 : e >= 48 && e <= 57 || e >= 65 && e <= 90 || e >= 97 && e <= 122;
}
function lm(e, t = {}) {
  const { document: n = Me } = t;
  n && R(n, "keydown", (o) => {
    !tl() && nl(o) && e(o);
  }, { passive: !0 });
}
function cm(e, t = null) {
  const n = wt();
  let r = () => {
  };
  const o = et((i, a) => (r = a, {
    get() {
      var s, u;
      return i(), (u = (s = n == null ? void 0 : n.proxy) == null ? void 0 : s.$refs[e]) != null ? u : t;
    },
    set() {
    }
  }));
  return me(r), Ua(r), o;
}
function rl(e = {}) {
  var t;
  const {
    window: n = U,
    deep: r = !0
  } = e, o = (t = e.document) != null ? t : n == null ? void 0 : n.document, i = () => {
    var s;
    let u = o == null ? void 0 : o.activeElement;
    if (r)
      for (; u != null && u.shadowRoot; )
        u = (s = u == null ? void 0 : u.shadowRoot) == null ? void 0 : s.activeElement;
    return u;
  }, a = za(
    () => null,
    () => i()
  );
  return n && (R(n, "blur", (s) => {
    s.relatedTarget === null && a.trigger();
  }, !0), R(n, "focus", a.trigger, !0)), a;
}
function ol() {
  const e = O(!1);
  return wt() && gi(() => {
    e.value = !0;
  }), e;
}
function $(e) {
  const t = ol();
  return C(() => (t.value, !!e()));
}
function Wt(e, t = {}) {
  const {
    immediate: n = !0,
    fpsLimit: r = void 0,
    window: o = U
  } = t, i = O(!1), a = r ? 1e3 / r : null;
  let s = 0, u = null;
  function l(y) {
    if (!i.value || !o)
      return;
    const v = y - (s || y);
    if (a && v < a) {
      u = o.requestAnimationFrame(l);
      return;
    }
    e({ delta: v, timestamp: y }), s = y, u = o.requestAnimationFrame(l);
  }
  function f() {
    !i.value && o && (i.value = !0, u = o.requestAnimationFrame(l));
  }
  function d() {
    i.value = !1, u != null && o && (o.cancelAnimationFrame(u), u = null);
  }
  return n && f(), V(d), {
    isActive: je(i),
    pause: d,
    resume: f
  };
}
function fm(e, t, n) {
  let r, o;
  Cr(n) ? (r = n, o = Ru(n, ["window", "immediate", "commitStyles", "persist", "onReady", "onError"])) : (r = { duration: n }, o = n);
  const {
    window: i = U,
    immediate: a = !0,
    commitStyles: s,
    persist: u,
    playbackRate: l = 1,
    onReady: f,
    onError: d = (F) => {
      console.error(F);
    }
  } = r, y = $(() => i && HTMLElement && "animate" in HTMLElement.prototype), v = oe(void 0), p = wr({
    startTime: null,
    currentTime: null,
    timeline: null,
    playbackRate: l,
    pending: !1,
    playState: a ? "idle" : "paused",
    replaceState: "active"
  }), S = C(() => p.pending), _ = C(() => p.playState), g = C(() => p.replaceState), b = C({
    get() {
      return p.startTime;
    },
    set(F) {
      p.startTime = F, v.value && (v.value.startTime = F);
    }
  }), h = C({
    get() {
      return p.currentTime;
    },
    set(F) {
      p.currentTime = F, v.value && (v.value.currentTime = F, ee());
    }
  }), m = C({
    get() {
      return p.timeline;
    },
    set(F) {
      p.timeline = F, v.value && (v.value.timeline = F);
    }
  }), P = C({
    get() {
      return p.playbackRate;
    },
    set(F) {
      p.playbackRate = F, v.value && (v.value.playbackRate = F);
    }
  }), x = () => {
    if (v.value)
      try {
        v.value.play(), ee();
      } catch (F) {
        te(), d(F);
      }
    else
      L();
  }, A = () => {
    var F;
    try {
      (F = v.value) == null || F.pause(), te();
    } catch (ne) {
      d(ne);
    }
  }, N = () => {
    var F;
    !v.value && L();
    try {
      (F = v.value) == null || F.reverse(), ee();
    } catch (ne) {
      te(), d(ne);
    }
  }, D = () => {
    var F;
    try {
      (F = v.value) == null || F.finish(), te();
    } catch (ne) {
      d(ne);
    }
  }, M = () => {
    var F;
    try {
      (F = v.value) == null || F.cancel(), te();
    } catch (ne) {
      d(ne);
    }
  };
  I(() => Y(e), (F) => {
    F && L();
  }), I(() => t, (F) => {
    !v.value && L(), !Y(e) && v.value && (v.value.effect = new KeyframeEffect(
      Y(e),
      T(F),
      o
    ));
  }, { deep: !0 }), me(() => {
    Le(() => L(!0));
  }), V(M);
  function L(F) {
    const ne = Y(e);
    !y.value || !ne || (v.value = ne.animate(T(t), o), s && v.value.commitStyles(), u && v.value.persist(), l !== 1 && (v.value.playbackRate = l), F && !a ? v.value.pause() : ee(), f == null || f(v.value));
  }
  R(v, ["cancel", "finish", "remove"], te);
  const { resume: K, pause: X } = Wt(() => {
    v.value && (p.pending = v.value.pending, p.playState = v.value.playState, p.replaceState = v.value.replaceState, p.startTime = v.value.startTime, p.currentTime = v.value.currentTime, p.timeline = v.value.timeline, p.playbackRate = v.value.playbackRate);
  }, { immediate: !1 });
  function ee() {
    y.value && K();
  }
  function te() {
    y.value && i && i.requestAnimationFrame(X);
  }
  return {
    isSupported: y,
    animate: v,
    // actions
    play: x,
    pause: A,
    reverse: N,
    finish: D,
    cancel: M,
    // state
    pending: S,
    playState: _,
    replaceState: g,
    startTime: b,
    currentTime: h,
    timeline: m,
    playbackRate: P
  };
}
function dm(e, t) {
  const {
    interrupt: n = !0,
    onError: r = re,
    onFinished: o = re,
    signal: i
  } = t || {}, a = {
    aborted: "aborted",
    fulfilled: "fulfilled",
    pending: "pending",
    rejected: "rejected"
  }, s = Array.from(Array.from({ length: e.length }), () => ({ state: a.pending, data: null })), u = ae(s), l = O(-1);
  if (!e || e.length === 0)
    return o(), {
      activeIndex: l,
      result: u
    };
  function f(d, y) {
    l.value++, u[l.value].data = y, u[l.value].state = d;
  }
  return e.reduce((d, y) => d.then((v) => {
    var p;
    if (i != null && i.aborted) {
      f(a.aborted, new Error("aborted"));
      return;
    }
    if (((p = u[l.value]) == null ? void 0 : p.state) === a.rejected && n) {
      o();
      return;
    }
    const S = y(v).then((_) => (f(a.fulfilled, _), l.value === e.length - 1 && o(), _));
    return i ? Promise.race([S, il(i)]) : S;
  }).catch((v) => i != null && i.aborted ? (f(a.aborted, v), v) : (f(a.rejected, v), r(), v)), Promise.resolve()), {
    activeIndex: l,
    result: u
  };
}
function il(e) {
  return new Promise((t, n) => {
    const r = new Error("aborted");
    e.aborted ? n(r) : e.addEventListener("abort", () => n(r), { once: !0 });
  });
}
function al(e, t, n) {
  const {
    immediate: r = !0,
    delay: o = 0,
    onError: i = re,
    onSuccess: a = re,
    resetOnExecute: s = !0,
    shallow: u = !0,
    throwError: l
  } = n ?? {}, f = u ? oe(t) : O(t), d = O(!1), y = O(!1), v = oe(void 0);
  async function p(g = 0, ...b) {
    s && (f.value = t), v.value = void 0, d.value = !1, y.value = !0, g > 0 && await Sr(g);
    const h = typeof e == "function" ? e(...b) : e;
    try {
      const m = await h;
      f.value = m, d.value = !0, a(m);
    } catch (m) {
      if (v.value = m, i(m), l)
        throw m;
    } finally {
      y.value = !1;
    }
    return f.value;
  }
  r && p(o);
  const S = {
    state: f,
    isReady: d,
    isLoading: y,
    error: v,
    execute: p
  };
  function _() {
    return new Promise((g, b) => {
      xr(y).toBe(!1).then(() => g(S)).catch(b);
    });
  }
  return {
    ...S,
    then(g, b) {
      return _().then(g, b);
    }
  };
}
const wn = {
  array: (e) => JSON.stringify(e),
  object: (e) => JSON.stringify(e),
  set: (e) => JSON.stringify(Array.from(e)),
  map: (e) => JSON.stringify(Object.fromEntries(e)),
  null: () => ""
};
function sl(e) {
  return e ? e instanceof Map ? wn.map : e instanceof Set ? wn.set : Array.isArray(e) ? wn.array : wn.object : wn.null;
}
function pm(e, t) {
  const n = O(""), r = O();
  function o() {
    if (xe)
      return r.value = new Promise((i, a) => {
        try {
          const s = T(e);
          if (s == null)
            i("");
          else if (typeof s == "string")
            i(No(new Blob([s], { type: "text/plain" })));
          else if (s instanceof Blob)
            i(No(s));
          else if (s instanceof ArrayBuffer)
            i(window.btoa(String.fromCharCode(...new Uint8Array(s))));
          else if (s instanceof HTMLCanvasElement)
            i(s.toDataURL(t == null ? void 0 : t.type, t == null ? void 0 : t.quality));
          else if (s instanceof HTMLImageElement) {
            const u = s.cloneNode(!1);
            u.crossOrigin = "Anonymous", ul(u).then(() => {
              const l = document.createElement("canvas"), f = l.getContext("2d");
              l.width = u.width, l.height = u.height, f.drawImage(u, 0, 0, l.width, l.height), i(l.toDataURL(t == null ? void 0 : t.type, t == null ? void 0 : t.quality));
            }).catch(a);
          } else if (typeof s == "object") {
            const l = ((t == null ? void 0 : t.serializer) || sl(s))(s);
            return i(No(new Blob([l], { type: "application/json" })));
          } else
            a(new Error("target is unsupported types"));
        } catch (s) {
          a(s);
        }
      }), r.value.then((i) => n.value = i), r.value;
  }
  return Pe(e) || typeof e == "function" ? I(e, o, { immediate: !0 }) : o(), {
    base64: n,
    promise: r,
    execute: o
  };
}
function ul(e) {
  return new Promise((t, n) => {
    e.complete ? t() : (e.onload = () => {
      t();
    }, e.onerror = n);
  });
}
function No(e) {
  return new Promise((t, n) => {
    const r = new FileReader();
    r.onload = (o) => {
      t(o.target.result);
    }, r.onerror = n, r.readAsDataURL(e);
  });
}
function hm(e = {}) {
  const { navigator: t = Ce } = e, n = ["chargingchange", "chargingtimechange", "dischargingtimechange", "levelchange"], r = $(() => t && "getBattery" in t), o = O(!1), i = O(0), a = O(0), s = O(1);
  let u;
  function l() {
    o.value = this.charging, i.value = this.chargingTime || 0, a.value = this.dischargingTime || 0, s.value = this.level;
  }
  return r.value && t.getBattery().then((f) => {
    u = f, l.call(u), R(u, n, l, { passive: !0 });
  }), {
    isSupported: r,
    charging: o,
    chargingTime: i,
    dischargingTime: a,
    level: s
  };
}
function vm(e) {
  let {
    acceptAllDevices: t = !1
  } = e || {};
  const {
    filters: n = void 0,
    optionalServices: r = void 0,
    navigator: o = Ce
  } = e || {}, i = $(() => o && "bluetooth" in o), a = oe(void 0), s = oe(null);
  I(a, () => {
    d();
  });
  async function u() {
    if (i.value) {
      s.value = null, n && n.length > 0 && (t = !1);
      try {
        a.value = await (o == null ? void 0 : o.bluetooth.requestDevice({
          acceptAllDevices: t,
          filters: n,
          optionalServices: r
        }));
      } catch (y) {
        s.value = y;
      }
    }
  }
  const l = O(), f = C(() => {
    var y;
    return ((y = l.value) == null ? void 0 : y.connected) || !1;
  });
  async function d() {
    if (s.value = null, a.value && a.value.gatt) {
      a.value.addEventListener("gattserverdisconnected", () => {
      });
      try {
        l.value = await a.value.gatt.connect();
      } catch (y) {
        s.value = y;
      }
    }
  }
  return me(() => {
    var y;
    a.value && ((y = a.value.gatt) == null || y.connect());
  }), V(() => {
    var y;
    a.value && ((y = a.value.gatt) == null || y.disconnect());
  }), {
    isSupported: i,
    isConnected: f,
    // Device:
    device: a,
    requestDevice: u,
    // Server:
    server: l,
    // Errors:
    error: s
  };
}
function ke(e, t = {}) {
  const { window: n = U } = t, r = $(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let o;
  const i = O(!1), a = (l) => {
    i.value = l.matches;
  }, s = () => {
    o && ("removeEventListener" in o ? o.removeEventListener("change", a) : o.removeListener(a));
  }, u = Xt(() => {
    r.value && (s(), o = n.matchMedia(T(e)), "addEventListener" in o ? o.addEventListener("change", a) : o.addListener(a), i.value = o.matches);
  });
  return V(() => {
    u(), s(), o = void 0;
  }), i;
}
const mm = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, ym = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
}, gm = {
  xs: 600,
  sm: 960,
  md: 1264,
  lg: 1904
}, bm = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600
}, wm = {
  xs: 600,
  sm: 1024,
  md: 1440,
  lg: 1920
}, Sm = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopL: 1440,
  desktop4K: 2560
}, Pm = {
  "3xs": 360,
  "2xs": 480,
  xs: 600,
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1440,
  "2xl": 1600,
  "3xl": 1920,
  "4xl": 2560
}, xm = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
function _m(e, t = {}) {
  function n(s, u) {
    let l = T(e[s]);
    return u != null && (l = Cu(l, u)), typeof l == "number" && (l = `${l}px`), l;
  }
  const { window: r = U } = t;
  function o(s) {
    return r ? r.matchMedia(s).matches : !1;
  }
  const i = (s) => ke(() => `(min-width: ${n(s)})`, t), a = Object.keys(e).reduce((s, u) => (Object.defineProperty(s, u, {
    get: () => i(u),
    enumerable: !0,
    configurable: !0
  }), s), {});
  return Object.assign(a, {
    greater(s) {
      return ke(() => `(min-width: ${n(s, 0.1)})`, t);
    },
    greaterOrEqual: i,
    smaller(s) {
      return ke(() => `(max-width: ${n(s, -0.1)})`, t);
    },
    smallerOrEqual(s) {
      return ke(() => `(max-width: ${n(s)})`, t);
    },
    between(s, u) {
      return ke(() => `(min-width: ${n(s)}) and (max-width: ${n(u, -0.1)})`, t);
    },
    isGreater(s) {
      return o(`(min-width: ${n(s, 0.1)})`);
    },
    isGreaterOrEqual(s) {
      return o(`(min-width: ${n(s)})`);
    },
    isSmaller(s) {
      return o(`(max-width: ${n(s, -0.1)})`);
    },
    isSmallerOrEqual(s) {
      return o(`(max-width: ${n(s)})`);
    },
    isInBetween(s, u) {
      return o(`(min-width: ${n(s)}) and (max-width: ${n(u, -0.1)})`);
    },
    current() {
      const s = Object.keys(e).map((u) => [u, i(u)]);
      return C(() => s.filter(([, u]) => u.value).map(([u]) => u));
    }
  });
}
function Om(e) {
  const {
    name: t,
    window: n = U
  } = e, r = $(() => n && "BroadcastChannel" in n), o = O(!1), i = O(), a = O(), s = oe(null), u = (f) => {
    i.value && i.value.postMessage(f);
  }, l = () => {
    i.value && i.value.close(), o.value = !0;
  };
  return r.value && me(() => {
    s.value = null, i.value = new BroadcastChannel(t), i.value.addEventListener("message", (f) => {
      a.value = f.data;
    }, { passive: !0 }), i.value.addEventListener("messageerror", (f) => {
      s.value = f;
    }, { passive: !0 }), i.value.addEventListener("close", () => {
      o.value = !0;
    });
  }), V(() => {
    l();
  }), {
    isSupported: r,
    channel: i,
    data: a,
    post: u,
    close: l,
    error: s,
    isClosed: o
  };
}
const Gi = [
  "hash",
  "host",
  "hostname",
  "href",
  "pathname",
  "port",
  "protocol",
  "search"
];
function Em(e = {}) {
  const { window: t = U } = e, n = Object.fromEntries(
    Gi.map((i) => [i, O()])
  );
  for (const [i, a] of Nu(n))
    I(a, (s) => {
      !(t != null && t.location) || t.location[i] === s || (t.location[i] = s);
    });
  const r = (i) => {
    var a;
    const { state: s, length: u } = (t == null ? void 0 : t.history) || {}, { origin: l } = (t == null ? void 0 : t.location) || {};
    for (const f of Gi)
      n[f].value = (a = t == null ? void 0 : t.location) == null ? void 0 : a[f];
    return ae({
      trigger: i,
      state: s,
      length: u,
      origin: l,
      ...n
    });
  }, o = O(r("load"));
  return t && (R(t, "popstate", () => o.value = r("popstate"), { passive: !0 }), R(t, "hashchange", () => o.value = r("hashchange"), { passive: !0 })), o;
}
function Tm(e, t = (r, o) => r === o, n) {
  const r = O(e.value);
  return I(() => e.value, (o) => {
    t(o, r.value) || (r.value = o);
  }, n), r;
}
function ai(e, t = {}) {
  const {
    controls: n = !1,
    navigator: r = Ce
  } = t, o = $(() => r && "permissions" in r);
  let i;
  const a = typeof e == "string" ? { name: e } : e, s = O(), u = () => {
    i && (s.value = i.state);
  }, l = ju(async () => {
    if (o.value) {
      if (!i)
        try {
          i = await r.permissions.query(a), R(i, "change", u), u();
        } catch {
          s.value = "prompt";
        }
      return i;
    }
  });
  return l(), n ? {
    state: s,
    isSupported: o,
    query: l
  } : s;
}
function Am(e = {}) {
  const {
    navigator: t = Ce,
    read: n = !1,
    source: r,
    copiedDuring: o = 1500,
    legacy: i = !1
  } = e, a = $(() => t && "clipboard" in t), s = ai("clipboard-read"), u = ai("clipboard-write"), l = C(() => a.value || i), f = O(""), d = O(!1), y = jn(() => d.value = !1, o);
  function v() {
    a.value && s.value !== "denied" ? t.clipboard.readText().then((g) => {
      f.value = g;
    }) : f.value = _();
  }
  l.value && n && R(["copy", "cut"], v);
  async function p(g = T(r)) {
    l.value && g != null && (a.value && u.value !== "denied" ? await t.clipboard.writeText(g) : S(g), f.value = g, d.value = !0, y.start());
  }
  function S(g) {
    const b = document.createElement("textarea");
    b.value = g ?? "", b.style.position = "absolute", b.style.opacity = "0", document.body.appendChild(b), b.select(), document.execCommand("copy"), b.remove();
  }
  function _() {
    var g, b, h;
    return (h = (b = (g = document == null ? void 0 : document.getSelection) == null ? void 0 : g.call(document)) == null ? void 0 : b.toString()) != null ? h : "";
  }
  return {
    isSupported: l,
    text: f,
    copied: d,
    copy: p
  };
}
function Mm(e = {}) {
  const {
    navigator: t = Ce,
    read: n = !1,
    source: r,
    copiedDuring: o = 1500
  } = e, i = $(() => t && "clipboard" in t), a = O([]), s = O(!1), u = jn(() => s.value = !1, o);
  function l() {
    i.value && t.clipboard.read().then((d) => {
      a.value = d;
    });
  }
  i.value && n && R(["copy", "cut"], l);
  async function f(d = T(r)) {
    i.value && d != null && (await t.clipboard.write(d), a.value = d, s.value = !0, u.start());
  }
  return {
    isSupported: i,
    content: a,
    copied: s,
    copy: f
  };
}
function Lr(e) {
  return JSON.parse(JSON.stringify(e));
}
function km(e, t = {}) {
  const n = O({}), {
    manual: r,
    clone: o = Lr,
    // watch options
    deep: i = !0,
    immediate: a = !0
  } = t;
  function s() {
    n.value = o(T(e));
  }
  return !r && (Pe(e) || typeof e == "function") ? I(e, s, {
    ...t,
    deep: i,
    immediate: a
  }) : s(), { cloned: n, sync: s };
}
const ir = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, ar = "__vueuse_ssr_handlers__", Ja = /* @__PURE__ */ ll();
function ll() {
  return ar in ir || (ir[ar] = ir[ar] || {}), ir[ar];
}
function _i(e, t) {
  return Ja[e] || t;
}
function jm(e, t) {
  Ja[e] = t;
}
function Ya(e) {
  return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
const $a = {
  boolean: {
    read: (e) => e === "true",
    write: (e) => String(e)
  },
  object: {
    read: (e) => JSON.parse(e),
    write: (e) => JSON.stringify(e)
  },
  number: {
    read: (e) => Number.parseFloat(e),
    write: (e) => String(e)
  },
  any: {
    read: (e) => e,
    write: (e) => String(e)
  },
  string: {
    read: (e) => e,
    write: (e) => String(e)
  },
  map: {
    read: (e) => new Map(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e.entries()))
  },
  set: {
    read: (e) => new Set(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e))
  },
  date: {
    read: (e) => new Date(e),
    write: (e) => e.toISOString()
  }
}, Zi = "vueuse-storage";
function Oi(e, t, n, r = {}) {
  var o;
  const {
    flush: i = "pre",
    deep: a = !0,
    listenToStorageChanges: s = !0,
    writeDefaults: u = !0,
    mergeDefaults: l = !1,
    shallow: f,
    window: d = U,
    eventFilter: y,
    onError: v = (D) => {
      console.error(D);
    },
    initOnMounted: p
  } = r, S = (f ? oe : O)(typeof t == "function" ? t() : t);
  if (!n)
    try {
      n = _i("getDefaultStorage", () => {
        var D;
        return (D = U) == null ? void 0 : D.localStorage;
      })();
    } catch (D) {
      v(D);
    }
  if (!n)
    return S;
  const _ = T(t), g = Ya(_), b = (o = r.serializer) != null ? o : $a[g], { pause: h, resume: m } = Pr(
    S,
    () => P(S.value),
    { flush: i, deep: a, eventFilter: y }
  );
  return d && s && me(() => {
    R(d, "storage", N), R(d, Zi, A), p && N();
  }), p || N(), S;
  function P(D) {
    try {
      if (D == null)
        n.removeItem(e);
      else {
        const M = b.write(D), L = n.getItem(e);
        L !== M && (n.setItem(e, M), d && d.dispatchEvent(new CustomEvent(Zi, {
          detail: {
            key: e,
            oldValue: L,
            newValue: M,
            storageArea: n
          }
        })));
      }
    } catch (M) {
      v(M);
    }
  }
  function x(D) {
    const M = D ? D.newValue : n.getItem(e);
    if (M == null)
      return u && _ != null && n.setItem(e, b.write(_)), _;
    if (!D && l) {
      const L = b.read(M);
      return typeof l == "function" ? l(L, _) : g === "object" && !Array.isArray(L) ? { ..._, ...L } : L;
    } else return typeof M != "string" ? M : b.read(M);
  }
  function A(D) {
    N(D.detail);
  }
  function N(D) {
    if (!(D && D.storageArea !== n)) {
      if (D && D.key == null) {
        S.value = _;
        return;
      }
      if (!(D && D.key !== e)) {
        h();
        try {
          (D == null ? void 0 : D.newValue) !== b.write(S.value) && (S.value = x(D));
        } catch (M) {
          v(M);
        } finally {
          D ? Le(m) : m();
        }
      }
    }
  }
}
function Qa(e) {
  return ke("(prefers-color-scheme: dark)", e);
}
function cl(e = {}) {
  const {
    selector: t = "html",
    attribute: n = "class",
    initialValue: r = "auto",
    window: o = U,
    storage: i,
    storageKey: a = "vueuse-color-scheme",
    listenToStorageChanges: s = !0,
    storageRef: u,
    emitAuto: l,
    disableTransition: f = !0
  } = e, d = {
    auto: "",
    light: "light",
    dark: "dark",
    ...e.modes || {}
  }, y = Qa({ window: o }), v = C(() => y.value ? "dark" : "light"), p = u || (a == null ? ve(r) : Oi(a, r, i, { window: o, listenToStorageChanges: s })), S = C(() => p.value === "auto" ? v.value : p.value), _ = _i(
    "updateHTMLAttrs",
    (m, P, x) => {
      const A = typeof m == "string" ? o == null ? void 0 : o.document.querySelector(m) : Y(m);
      if (!A)
        return;
      let N;
      if (f && (N = o.document.createElement("style"), N.appendChild(document.createTextNode("*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}")), o.document.head.appendChild(N)), P === "class") {
        const D = x.split(/\s/g);
        Object.values(d).flatMap((M) => (M || "").split(/\s/g)).filter(Boolean).forEach((M) => {
          D.includes(M) ? A.classList.add(M) : A.classList.remove(M);
        });
      } else
        A.setAttribute(P, x);
      f && (o.getComputedStyle(N).opacity, document.head.removeChild(N));
    }
  );
  function g(m) {
    var P;
    _(t, n, (P = d[m]) != null ? P : m);
  }
  function b(m) {
    e.onChanged ? e.onChanged(m, g) : g(m);
  }
  I(S, b, { flush: "post", immediate: !0 }), me(() => b(S.value));
  const h = C({
    get() {
      return l ? p.value : S.value;
    },
    set(m) {
      p.value = m;
    }
  });
  try {
    return Object.assign(h, { store: p, system: v, state: S });
  } catch {
    return h;
  }
}
function Cm(e = O(!1)) {
  const t = Te(), n = Te(), r = Te();
  let o = re;
  const i = (u) => (r.trigger(u), e.value = !0, new Promise((l) => {
    o = l;
  })), a = (u) => {
    e.value = !1, t.trigger(u), o({ data: u, isCanceled: !1 });
  }, s = (u) => {
    e.value = !1, n.trigger(u), o({ data: u, isCanceled: !0 });
  };
  return {
    isRevealed: C(() => e.value),
    reveal: i,
    confirm: a,
    cancel: s,
    onReveal: r.on,
    onConfirm: t.on,
    onCancel: n.on
  };
}
function Ei(e, t, n = {}) {
  const { window: r = U, ...o } = n;
  let i;
  const a = $(() => r && "MutationObserver" in r), s = () => {
    i && (i.disconnect(), i = void 0);
  }, u = I(
    () => Y(e),
    (d) => {
      s(), a.value && r && d && (i = new MutationObserver(t), i.observe(d, o));
    },
    { immediate: !0 }
  ), l = () => i == null ? void 0 : i.takeRecords(), f = () => {
    s(), u();
  };
  return V(f), {
    isSupported: a,
    stop: f,
    takeRecords: l
  };
}
function sr(e, t, n = {}) {
  const { window: r = U, initialValue: o = "", observe: i = !1 } = n, a = O(o), s = C(() => {
    var l;
    return Y(t) || ((l = r == null ? void 0 : r.document) == null ? void 0 : l.documentElement);
  });
  function u() {
    var l;
    const f = T(e), d = T(s);
    if (d && r) {
      const y = (l = r.getComputedStyle(d).getPropertyValue(f)) == null ? void 0 : l.trim();
      a.value = y || o;
    }
  }
  return i && Ei(s, u, {
    attributeFilter: ["style", "class"],
    window: r
  }), I(
    [s, () => T(e)],
    u,
    { immediate: !0 }
  ), I(
    a,
    (l) => {
      var f;
      (f = s.value) != null && f.style && s.value.style.setProperty(T(e), l);
    }
  ), a;
}
function fl() {
  const e = wt(), t = za(
    () => null,
    () => e.proxy.$el
  );
  return Ua(t.trigger), gi(t.trigger), t;
}
function Dm(e, t) {
  const n = oe(l()), r = ve(e), o = C({
    get() {
      var f;
      const d = r.value;
      let y = t != null && t.getIndexOf ? t.getIndexOf(n.value, d) : d.indexOf(n.value);
      return y < 0 && (y = (f = t == null ? void 0 : t.fallbackIndex) != null ? f : 0), y;
    },
    set(f) {
      i(f);
    }
  });
  function i(f) {
    const d = r.value, y = d.length, v = (f % y + y) % y, p = d[v];
    return n.value = p, p;
  }
  function a(f = 1) {
    return i(o.value + f);
  }
  function s(f = 1) {
    return a(f);
  }
  function u(f = 1) {
    return a(-f);
  }
  function l() {
    var f, d;
    return (d = T((f = t == null ? void 0 : t.initialValue) != null ? f : T(e)[0])) != null ? d : void 0;
  }
  return I(r, () => i(o.value)), {
    state: n,
    index: o,
    next: s,
    prev: u
  };
}
function Rm(e = {}) {
  const {
    valueDark: t = "dark",
    valueLight: n = "",
    window: r = U
  } = e, o = cl({
    ...e,
    onChanged: (s, u) => {
      var l;
      e.onChanged ? (l = e.onChanged) == null || l.call(e, s === "dark", u, s) : u(s);
    },
    modes: {
      dark: t,
      light: n
    }
  }), i = C(() => o.system ? o.system.value : Qa({ window: r }).value ? "dark" : "light");
  return C({
    get() {
      return o.value === "dark";
    },
    set(s) {
      const u = s ? "dark" : "light";
      i.value === u ? o.value = "auto" : o.value = u;
    }
  });
}
function qa(e) {
  return e;
}
function dl(e, t) {
  return e.value = t;
}
function pl(e) {
  return e ? typeof e == "function" ? e : Lr : qa;
}
function hl(e) {
  return e ? typeof e == "function" ? e : Lr : qa;
}
function vl(e, t = {}) {
  const {
    clone: n = !1,
    dump: r = pl(n),
    parse: o = hl(n),
    setSource: i = dl
  } = t;
  function a() {
    return vu({
      snapshot: r(e.value),
      timestamp: Ht()
    });
  }
  const s = O(a()), u = O([]), l = O([]), f = (h) => {
    i(e, o(h.snapshot)), s.value = h;
  }, d = () => {
    u.value.unshift(s.value), s.value = a(), t.capacity && u.value.length > t.capacity && u.value.splice(t.capacity, Number.POSITIVE_INFINITY), l.value.length && l.value.splice(0, l.value.length);
  }, y = () => {
    u.value.splice(0, u.value.length), l.value.splice(0, l.value.length);
  }, v = () => {
    const h = u.value.shift();
    h && (l.value.unshift(s.value), f(h));
  }, p = () => {
    const h = l.value.shift();
    h && (u.value.unshift(s.value), f(h));
  }, S = () => {
    f(s.value);
  }, _ = C(() => [s.value, ...u.value]), g = C(() => u.value.length > 0), b = C(() => l.value.length > 0);
  return {
    source: e,
    undoStack: u,
    redoStack: l,
    last: s,
    history: _,
    canUndo: g,
    canRedo: b,
    clear: y,
    commit: d,
    reset: S,
    undo: v,
    redo: p
  };
}
function es(e, t = {}) {
  const {
    deep: n = !1,
    flush: r = "pre",
    eventFilter: o
  } = t, {
    eventFilter: i,
    pause: a,
    resume: s,
    isActive: u
  } = Za(o), {
    ignoreUpdates: l,
    ignorePrevAsyncUpdates: f,
    stop: d
  } = _r(
    e,
    _,
    { deep: n, flush: r, eventFilter: i }
  );
  function y(m, P) {
    f(), l(() => {
      m.value = P;
    });
  }
  const v = vl(e, { ...t, clone: t.clone || n, setSource: y }), { clear: p, commit: S } = v;
  function _() {
    f(), S();
  }
  function g(m) {
    s(), m && _();
  }
  function b(m) {
    let P = !1;
    const x = () => P = !0;
    l(() => {
      m(x);
    }), P || _();
  }
  function h() {
    d(), p();
  }
  return {
    ...v,
    isTracking: u,
    pause: a,
    resume: g,
    commit: _,
    batch: b,
    dispose: h
  };
}
function Nm(e, t = {}) {
  const n = t.debounce ? Si(t.debounce) : void 0;
  return {
    ...es(e, { ...t, eventFilter: n })
  };
}
function Lm(e = {}) {
  const {
    window: t = U,
    eventFilter: n = Dr
  } = e, r = O({ x: null, y: null, z: null }), o = O({ alpha: null, beta: null, gamma: null }), i = O(0), a = O({
    x: null,
    y: null,
    z: null
  });
  if (t) {
    const s = Vt(
      n,
      (u) => {
        r.value = u.acceleration, a.value = u.accelerationIncludingGravity, o.value = u.rotationRate, i.value = u.interval;
      }
    );
    R(t, "devicemotion", s);
  }
  return {
    acceleration: r,
    accelerationIncludingGravity: a,
    rotationRate: o,
    interval: i
  };
}
function ml(e = {}) {
  const { window: t = U } = e, n = $(() => t && "DeviceOrientationEvent" in t), r = O(!1), o = O(null), i = O(null), a = O(null);
  return t && n.value && R(t, "deviceorientation", (s) => {
    r.value = s.absolute, o.value = s.alpha, i.value = s.beta, a.value = s.gamma;
  }), {
    isSupported: n,
    isAbsolute: r,
    alpha: o,
    beta: i,
    gamma: a
  };
}
function Im(e = {}) {
  const {
    window: t = U
  } = e, n = O(1);
  if (t) {
    let r = function() {
      n.value = t.devicePixelRatio, o(), i = t.matchMedia(`(resolution: ${n.value}dppx)`), i.addEventListener("change", r, { once: !0 });
    }, o = function() {
      i == null || i.removeEventListener("change", r);
    }, i;
    r(), V(o);
  }
  return { pixelRatio: n };
}
function Fm(e = {}) {
  const {
    navigator: t = Ce,
    requestPermissions: n = !1,
    constraints: r = { audio: !0, video: !0 },
    onUpdated: o
  } = e, i = O([]), a = C(() => i.value.filter((p) => p.kind === "videoinput")), s = C(() => i.value.filter((p) => p.kind === "audioinput")), u = C(() => i.value.filter((p) => p.kind === "audiooutput")), l = $(() => t && t.mediaDevices && t.mediaDevices.enumerateDevices), f = O(!1);
  let d;
  async function y() {
    l.value && (i.value = await t.mediaDevices.enumerateDevices(), o == null || o(i.value), d && (d.getTracks().forEach((p) => p.stop()), d = null));
  }
  async function v() {
    if (!l.value)
      return !1;
    if (f.value)
      return !0;
    const { state: p, query: S } = ai("camera", { controls: !0 });
    return await S(), p.value !== "granted" && (d = await t.mediaDevices.getUserMedia(r), y()), f.value = !0, f.value;
  }
  return l.value && (n && v(), R(t.mediaDevices, "devicechange", y), y()), {
    devices: i,
    ensurePermissions: v,
    permissionGranted: f,
    videoInputs: a,
    audioInputs: s,
    audioOutputs: u,
    isSupported: l
  };
}
function Um(e = {}) {
  var t;
  const n = O((t = e.enabled) != null ? t : !1), r = e.video, o = e.audio, { navigator: i = Ce } = e, a = $(() => {
    var v;
    return (v = i == null ? void 0 : i.mediaDevices) == null ? void 0 : v.getDisplayMedia;
  }), s = { audio: o, video: r }, u = oe();
  async function l() {
    if (!(!a.value || u.value))
      return u.value = await i.mediaDevices.getDisplayMedia(s), u.value;
  }
  async function f() {
    var v;
    (v = u.value) == null || v.getTracks().forEach((p) => p.stop()), u.value = void 0;
  }
  function d() {
    f(), n.value = !1;
  }
  async function y() {
    return await l(), u.value && (n.value = !0), u.value;
  }
  return I(
    n,
    (v) => {
      v ? l() : f();
    },
    { immediate: !0 }
  ), {
    isSupported: a,
    stream: u,
    start: y,
    stop: d,
    enabled: n
  };
}
function zm(e = {}) {
  const { document: t = Me } = e;
  if (!t)
    return O("visible");
  const n = O(t.visibilityState);
  return R(t, "visibilitychange", () => {
    n.value = t.visibilityState;
  }), n;
}
function Km(e, t = {}) {
  var n, r;
  const {
    pointerTypes: o,
    preventDefault: i,
    stopPropagation: a,
    exact: s,
    onMove: u,
    onEnd: l,
    onStart: f,
    initialValue: d,
    axis: y = "both",
    draggingElement: v = U,
    containerElement: p,
    handle: S = e
  } = t, _ = O(
    (n = T(d)) != null ? n : { x: 0, y: 0 }
  ), g = O(), b = (A) => o ? o.includes(A.pointerType) : !0, h = (A) => {
    T(i) && A.preventDefault(), T(a) && A.stopPropagation();
  }, m = (A) => {
    var N;
    if (!b(A) || T(s) && A.target !== T(e))
      return;
    const D = T(p), M = (N = D == null ? void 0 : D.getBoundingClientRect) == null ? void 0 : N.call(D), L = T(e).getBoundingClientRect(), K = {
      x: A.clientX - (D ? L.left - M.left : L.left),
      y: A.clientY - (D ? L.top - M.top : L.top)
    };
    (f == null ? void 0 : f(K, A)) !== !1 && (g.value = K, h(A));
  }, P = (A) => {
    var N;
    if (!b(A) || !g.value)
      return;
    const D = T(p), M = (N = D == null ? void 0 : D.getBoundingClientRect) == null ? void 0 : N.call(D), L = T(e).getBoundingClientRect();
    let { x: K, y: X } = _.value;
    (y === "x" || y === "both") && (K = A.clientX - g.value.x, D && (K = Math.min(Math.max(0, K), M.width - L.width))), (y === "y" || y === "both") && (X = A.clientY - g.value.y, D && (X = Math.min(Math.max(0, X), M.height - L.height))), _.value = {
      x: K,
      y: X
    }, u == null || u(_.value, A), h(A);
  }, x = (A) => {
    b(A) && g.value && (g.value = void 0, l == null || l(_.value, A), h(A));
  };
  if (xe) {
    const A = { capture: (r = t.capture) != null ? r : !0 };
    R(S, "pointerdown", m, A), R(v, "pointermove", P, A), R(v, "pointerup", x, A);
  }
  return {
    ...Wa(_),
    position: _,
    isDragging: C(() => !!g.value),
    style: C(
      () => `left:${_.value.x}px;top:${_.value.y}px;`
    )
  };
}
function Gm(e, t = {}) {
  const n = O(!1), r = oe(null);
  let o = 0, i = !0;
  if (xe) {
    const a = typeof t == "function" ? { onDrop: t } : t, s = (u) => {
      var l, f;
      const d = Array.from((f = (l = u.dataTransfer) == null ? void 0 : l.files) != null ? f : []);
      return r.value = d.length === 0 ? null : d;
    };
    R(e, "dragenter", (u) => {
      var l, f;
      const d = Array.from(((l = u == null ? void 0 : u.dataTransfer) == null ? void 0 : l.items) || []).map((y) => y.kind === "file" ? y.type : null).filter(Ga);
      if (a.dataTypes && u.dataTransfer) {
        const y = ot(a.dataTypes);
        if (i = typeof y == "function" ? y(d) : y ? y.some((v) => d.includes(v)) : !0, !i)
          return;
      }
      u.preventDefault(), o += 1, n.value = !0, (f = a.onEnter) == null || f.call(a, s(u), u);
    }), R(e, "dragover", (u) => {
      var l;
      i && (u.preventDefault(), (l = a.onOver) == null || l.call(a, s(u), u));
    }), R(e, "dragleave", (u) => {
      var l;
      i && (u.preventDefault(), o -= 1, o === 0 && (n.value = !1), (l = a.onLeave) == null || l.call(a, s(u), u));
    }), R(e, "drop", (u) => {
      var l;
      u.preventDefault(), o = 0, n.value = !1, (l = a.onDrop) == null || l.call(a, s(u), u);
    });
  }
  return {
    files: r,
    isOverDropZone: n
  };
}
function Ti(e, t, n = {}) {
  const { window: r = U, ...o } = n;
  let i;
  const a = $(() => r && "ResizeObserver" in r), s = () => {
    i && (i.disconnect(), i = void 0);
  }, u = C(() => Array.isArray(e) ? e.map((d) => Y(d)) : [Y(e)]), l = I(
    u,
    (d) => {
      if (s(), a.value && r) {
        i = new ResizeObserver(t);
        for (const y of d)
          y && i.observe(y, o);
      }
    },
    { immediate: !0, flush: "post", deep: !0 }
  ), f = () => {
    s(), l();
  };
  return V(f), {
    isSupported: a,
    stop: f
  };
}
function Zm(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: r = !0,
    windowScroll: o = !0,
    immediate: i = !0
  } = t, a = O(0), s = O(0), u = O(0), l = O(0), f = O(0), d = O(0), y = O(0), v = O(0);
  function p() {
    const S = Y(e);
    if (!S) {
      n && (a.value = 0, s.value = 0, u.value = 0, l.value = 0, f.value = 0, d.value = 0, y.value = 0, v.value = 0);
      return;
    }
    const _ = S.getBoundingClientRect();
    a.value = _.height, s.value = _.bottom, u.value = _.left, l.value = _.right, f.value = _.top, d.value = _.width, y.value = _.x, v.value = _.y;
  }
  return Ti(e, p), I(() => Y(e), (S) => !S && p()), o && R("scroll", p, { capture: !0, passive: !0 }), r && R("resize", p, { passive: !0 }), me(() => {
    i && p();
  }), {
    height: a,
    bottom: s,
    left: u,
    right: l,
    top: f,
    width: d,
    x: y,
    y: v,
    update: p
  };
}
function Xm(e) {
  const {
    x: t,
    y: n,
    document: r = Me,
    multiple: o,
    interval: i = "requestAnimationFrame",
    immediate: a = !0
  } = e, s = $(() => T(o) ? r && "elementsFromPoint" in r : r && "elementFromPoint" in r), u = O(null), l = () => {
    var d, y;
    u.value = T(o) ? (d = r == null ? void 0 : r.elementsFromPoint(T(t), T(n))) != null ? d : [] : (y = r == null ? void 0 : r.elementFromPoint(T(t), T(n))) != null ? y : null;
  }, f = i === "requestAnimationFrame" ? Wt(l, { immediate: a }) : St(l, i, { immediate: a });
  return {
    isSupported: s,
    element: u,
    ...f
  };
}
function Hm(e, t = {}) {
  const {
    delayEnter: n = 0,
    delayLeave: r = 0,
    window: o = U
  } = t, i = O(!1);
  let a;
  const s = (u) => {
    const l = u ? n : r;
    a && (clearTimeout(a), a = void 0), l ? a = setTimeout(() => i.value = u, l) : i.value = u;
  };
  return o && (R(e, "mouseenter", () => s(!0), { passive: !0 }), R(e, "mouseleave", () => s(!1), { passive: !0 })), i;
}
function ts(e, t = { width: 0, height: 0 }, n = {}) {
  const { window: r = U, box: o = "content-box" } = n, i = C(() => {
    var d, y;
    return (y = (d = Y(e)) == null ? void 0 : d.namespaceURI) == null ? void 0 : y.includes("svg");
  }), a = O(t.width), s = O(t.height), { stop: u } = Ti(
    e,
    ([d]) => {
      const y = o === "border-box" ? d.borderBoxSize : o === "content-box" ? d.contentBoxSize : d.devicePixelContentBoxSize;
      if (r && i.value) {
        const v = Y(e);
        if (v) {
          const p = r.getComputedStyle(v);
          a.value = Number.parseFloat(p.width), s.value = Number.parseFloat(p.height);
        }
      } else if (y) {
        const v = Array.isArray(y) ? y : [y];
        a.value = v.reduce((p, { inlineSize: S }) => p + S, 0), s.value = v.reduce((p, { blockSize: S }) => p + S, 0);
      } else
        a.value = d.contentRect.width, s.value = d.contentRect.height;
    },
    n
  );
  me(() => {
    const d = Y(e);
    d && (a.value = "offsetWidth" in d ? d.offsetWidth : t.width, s.value = "offsetHeight" in d ? d.offsetHeight : t.height);
  });
  const l = I(
    () => Y(e),
    (d) => {
      a.value = d ? t.width : 0, s.value = d ? t.height : 0;
    }
  );
  function f() {
    u(), l();
  }
  return {
    width: a,
    height: s,
    stop: f
  };
}
function yl(e, t, n = {}) {
  const {
    root: r,
    rootMargin: o = "0px",
    threshold: i = 0.1,
    window: a = U,
    immediate: s = !0
  } = n, u = $(() => a && "IntersectionObserver" in a), l = C(() => {
    const p = T(e);
    return (Array.isArray(p) ? p : [p]).map(Y).filter(Ga);
  });
  let f = re;
  const d = O(s), y = u.value ? I(
    () => [l.value, Y(r), d.value],
    ([p, S]) => {
      if (f(), !d.value || !p.length)
        return;
      const _ = new IntersectionObserver(
        t,
        {
          root: Y(S),
          rootMargin: o,
          threshold: i
        }
      );
      p.forEach((g) => g && _.observe(g)), f = () => {
        _.disconnect(), f = re;
      };
    },
    { immediate: s, flush: "post" }
  ) : re, v = () => {
    f(), y(), d.value = !1;
  };
  return V(v), {
    isSupported: u,
    isActive: d,
    pause() {
      f(), d.value = !1;
    },
    resume() {
      d.value = !0;
    },
    stop: v
  };
}
function gl(e, t = {}) {
  const { window: n = U, scrollTarget: r } = t, o = O(!1);
  return yl(
    e,
    (i) => {
      let a = o.value, s = 0;
      for (const u of i)
        u.time >= s && (s = u.time, a = u.isIntersecting);
      o.value = a;
    },
    {
      root: r,
      window: n,
      threshold: 0
    }
  ), o;
}
const Sn = /* @__PURE__ */ new Map();
function Bm(e) {
  const t = La();
  function n(s) {
    var u;
    const l = Sn.get(e) || /* @__PURE__ */ new Set();
    l.add(s), Sn.set(e, l);
    const f = () => o(s);
    return (u = t == null ? void 0 : t.cleanups) == null || u.push(f), f;
  }
  function r(s) {
    function u(...l) {
      o(u), s(...l);
    }
    return n(u);
  }
  function o(s) {
    const u = Sn.get(e);
    u && (u.delete(s), u.size || i());
  }
  function i() {
    Sn.delete(e);
  }
  function a(s, u) {
    var l;
    (l = Sn.get(e)) == null || l.forEach((f) => f(s, u));
  }
  return { on: n, once: r, off: o, emit: a, reset: i };
}
function Vm(e, t = [], n = {}) {
  const r = O(null), o = O(null), i = O("CONNECTING"), a = O(null), s = oe(null), {
    withCredentials: u = !1
  } = n, l = () => {
    a.value && (a.value.close(), a.value = null, i.value = "CLOSED");
  }, f = new EventSource(e, { withCredentials: u });
  a.value = f, f.onopen = () => {
    i.value = "OPEN", s.value = null;
  }, f.onerror = (d) => {
    i.value = "CLOSED", s.value = d;
  }, f.onmessage = (d) => {
    r.value = null, o.value = d.data;
  };
  for (const d of t)
    R(f, d, (y) => {
      r.value = d, o.value = y.data || null;
    });
  return V(() => {
    l();
  }), {
    eventSource: a,
    event: r,
    data: o,
    status: i,
    error: s,
    close: l
  };
}
function Wm(e = {}) {
  const { initialValue: t = "" } = e, n = $(() => typeof window < "u" && "EyeDropper" in window), r = O(t);
  async function o(i) {
    if (!n.value)
      return;
    const s = await new window.EyeDropper().open(i);
    return r.value = s.sRGBHex, s;
  }
  return { isSupported: n, sRGBHex: r, open: o };
}
function Jm(e = null, t = {}) {
  const {
    baseUrl: n = "",
    rel: r = "icon",
    document: o = Me
  } = t, i = ve(e), a = (s) => {
    const u = o == null ? void 0 : o.head.querySelectorAll(`link[rel*="${r}"]`);
    if (!u || u.length === 0) {
      const l = o == null ? void 0 : o.createElement("link");
      l && (l.rel = r, l.href = `${n}${s}`, l.type = `image/${s.split(".").pop()}`, o == null || o.head.append(l));
      return;
    }
    u == null || u.forEach((l) => l.href = `${n}${s}`);
  };
  return I(
    i,
    (s, u) => {
      typeof s == "string" && s !== u && a(s);
    },
    { immediate: !0 }
  ), i;
}
const bl = {
  json: "application/json",
  text: "text/plain"
};
function Or(e) {
  return e && Ba(e, "immediate", "refetch", "initialData", "timeout", "beforeFetch", "afterFetch", "onFetchError", "fetch", "updateDataOnError");
}
function wl(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Tn(e) {
  return typeof Headers < "u" && e instanceof Headers ? Object.fromEntries([...e.entries()]) : e;
}
function It(e, ...t) {
  return e === "overwrite" ? async (n) => {
    const r = t[t.length - 1];
    return r ? { ...n, ...await r(n) } : n;
  } : async (n) => {
    for (const r of t)
      r && (n = { ...n, ...await r(n) });
    return n;
  };
}
function Ym(e = {}) {
  const t = e.combination || "chain", n = e.options || {}, r = e.fetchOptions || {};
  function o(i, ...a) {
    const s = C(() => {
      const f = T(e.baseUrl), d = T(i);
      return f && !wl(d) ? Pl(f, d) : d;
    });
    let u = n, l = r;
    return a.length > 0 && (Or(a[0]) ? u = {
      ...u,
      ...a[0],
      beforeFetch: It(t, n.beforeFetch, a[0].beforeFetch),
      afterFetch: It(t, n.afterFetch, a[0].afterFetch),
      onFetchError: It(t, n.onFetchError, a[0].onFetchError)
    } : l = {
      ...l,
      ...a[0],
      headers: {
        ...Tn(l.headers) || {},
        ...Tn(a[0].headers) || {}
      }
    }), a.length > 1 && Or(a[1]) && (u = {
      ...u,
      ...a[1],
      beforeFetch: It(t, n.beforeFetch, a[1].beforeFetch),
      afterFetch: It(t, n.afterFetch, a[1].afterFetch),
      onFetchError: It(t, n.onFetchError, a[1].onFetchError)
    }), Sl(s, l, u);
  }
  return o;
}
function Sl(e, ...t) {
  var n;
  const r = typeof AbortController == "function";
  let o = {}, i = {
    immediate: !0,
    refetch: !1,
    timeout: 0,
    updateDataOnError: !1
  };
  const a = {
    method: "GET",
    type: "text",
    payload: void 0
  };
  t.length > 0 && (Or(t[0]) ? i = { ...i, ...t[0] } : o = t[0]), t.length > 1 && Or(t[1]) && (i = { ...i, ...t[1] });
  const {
    fetch: s = (n = U) == null ? void 0 : n.fetch,
    initialData: u,
    timeout: l
  } = i, f = Te(), d = Te(), y = Te(), v = O(!1), p = O(!1), S = O(!1), _ = O(null), g = oe(null), b = oe(null), h = oe(u || null), m = C(() => r && p.value);
  let P, x;
  const A = () => {
    r && (P == null || P.abort(), P = new AbortController(), P.signal.onabort = () => S.value = !0, o = {
      ...o,
      signal: P.signal
    });
  }, N = (F) => {
    p.value = F, v.value = !F;
  };
  l && (x = jn(A, l, { immediate: !1 }));
  let D = 0;
  const M = async (F = !1) => {
    var ne, se;
    A(), N(!0), b.value = null, _.value = null, S.value = !1, D += 1;
    const We = D, B = {
      method: a.method,
      headers: {}
    };
    if (a.payload) {
      const ie = Tn(B.headers), H = T(a.payload);
      !a.payloadType && H && Object.getPrototypeOf(H) === Object.prototype && !(H instanceof FormData) && (a.payloadType = "json"), a.payloadType && (ie["Content-Type"] = (ne = bl[a.payloadType]) != null ? ne : a.payloadType), B.body = a.payloadType === "json" ? JSON.stringify(H) : H;
    }
    let _t = !1;
    const Je = {
      url: T(e),
      options: {
        ...B,
        ...o
      },
      cancel: () => {
        _t = !0;
      }
    };
    if (i.beforeFetch && Object.assign(Je, await i.beforeFetch(Je)), _t || !s)
      return N(!1), Promise.resolve(null);
    let le = null;
    return x && x.start(), s(
      Je.url,
      {
        ...B,
        ...Je.options,
        headers: {
          ...Tn(B.headers),
          ...Tn((se = Je.options) == null ? void 0 : se.headers)
        }
      }
    ).then(async (ie) => {
      if (g.value = ie, _.value = ie.status, le = await ie.clone()[a.type](), !ie.ok)
        throw h.value = u || null, new Error(ie.statusText);
      return i.afterFetch && ({ data: le } = await i.afterFetch({
        data: le,
        response: ie
      })), h.value = le, f.trigger(ie), ie;
    }).catch(async (ie) => {
      let H = ie.message || ie.name;
      if (i.onFetchError && ({ error: H, data: le } = await i.onFetchError({
        data: le,
        error: ie,
        response: g.value
      })), b.value = H, i.updateDataOnError && (h.value = le), d.trigger(ie), F)
        throw ie;
      return null;
    }).finally(() => {
      We === D && N(!1), x && x.stop(), y.trigger(null);
    });
  }, L = ve(i.refetch);
  I(
    [
      L,
      ve(e)
    ],
    ([F]) => F && M(),
    { deep: !0 }
  );
  const K = {
    isFinished: v,
    statusCode: _,
    response: g,
    error: b,
    data: h,
    isFetching: p,
    canAbort: m,
    aborted: S,
    abort: A,
    execute: M,
    onFetchResponse: f.on,
    onFetchError: d.on,
    onFetchFinally: y.on,
    // method
    get: X("GET"),
    put: X("PUT"),
    post: X("POST"),
    delete: X("DELETE"),
    patch: X("PATCH"),
    head: X("HEAD"),
    options: X("OPTIONS"),
    // type
    json: te("json"),
    text: te("text"),
    blob: te("blob"),
    arrayBuffer: te("arrayBuffer"),
    formData: te("formData")
  };
  function X(F) {
    return (ne, se) => {
      if (!p.value)
        return a.method = F, a.payload = ne, a.payloadType = se, Pe(a.payload) && I(
          [
            L,
            ve(a.payload)
          ],
          ([We]) => We && M(),
          { deep: !0 }
        ), {
          ...K,
          then(We, B) {
            return ee().then(We, B);
          }
        };
    };
  }
  function ee() {
    return new Promise((F, ne) => {
      xr(v).toBe(!0).then(() => F(K)).catch((se) => ne(se));
    });
  }
  function te(F) {
    return () => {
      if (!p.value)
        return a.type = F, {
          ...K,
          then(ne, se) {
            return ee().then(ne, se);
          }
        };
    };
  }
  return i.immediate && Promise.resolve().then(() => M()), {
    ...K,
    then(F, ne) {
      return ee().then(F, ne);
    }
  };
}
function Pl(e, t) {
  return !e.endsWith("/") && !t.startsWith("/") ? `${e}/${t}` : `${e}${t}`;
}
const xl = {
  multiple: !0,
  accept: "*",
  reset: !1,
  directory: !1
};
function $m(e = {}) {
  const {
    document: t = Me
  } = e, n = O(null), { on: r, trigger: o } = Te();
  let i;
  t && (i = t.createElement("input"), i.type = "file", i.onchange = (u) => {
    const l = u.target;
    n.value = l.files, o(n.value);
  });
  const a = () => {
    n.value = null, i && (i.value = "", o(null));
  }, s = (u) => {
    if (!i)
      return;
    const l = {
      ...xl,
      ...e,
      ...u
    };
    i.multiple = l.multiple, i.accept = l.accept, i.webkitdirectory = l.directory, Eu(l, "capture") && (i.capture = l.capture), l.reset && a(), i.click();
  };
  return {
    files: je(n),
    open: s,
    reset: a,
    onChange: r
  };
}
function Qm(e = {}) {
  const {
    window: t = U,
    dataType: n = "Text"
  } = e, r = t, o = $(() => r && "showSaveFilePicker" in r && "showOpenFilePicker" in r), i = O(), a = O(), s = O(), u = C(() => {
    var b, h;
    return (h = (b = s.value) == null ? void 0 : b.name) != null ? h : "";
  }), l = C(() => {
    var b, h;
    return (h = (b = s.value) == null ? void 0 : b.type) != null ? h : "";
  }), f = C(() => {
    var b, h;
    return (h = (b = s.value) == null ? void 0 : b.size) != null ? h : 0;
  }), d = C(() => {
    var b, h;
    return (h = (b = s.value) == null ? void 0 : b.lastModified) != null ? h : 0;
  });
  async function y(b = {}) {
    if (!o.value)
      return;
    const [h] = await r.showOpenFilePicker({ ...T(e), ...b });
    i.value = h, await _(), await g();
  }
  async function v(b = {}) {
    o.value && (i.value = await r.showSaveFilePicker({ ...e, ...b }), a.value = void 0, await _(), await g());
  }
  async function p(b = {}) {
    if (o.value) {
      if (!i.value)
        return S(b);
      if (a.value) {
        const h = await i.value.createWritable();
        await h.write(a.value), await h.close();
      }
      await _();
    }
  }
  async function S(b = {}) {
    if (o.value) {
      if (i.value = await r.showSaveFilePicker({ ...e, ...b }), a.value) {
        const h = await i.value.createWritable();
        await h.write(a.value), await h.close();
      }
      await _();
    }
  }
  async function _() {
    var b;
    s.value = await ((b = i.value) == null ? void 0 : b.getFile());
  }
  async function g() {
    var b, h;
    const m = T(n);
    m === "Text" ? a.value = await ((b = s.value) == null ? void 0 : b.text()) : m === "ArrayBuffer" ? a.value = await ((h = s.value) == null ? void 0 : h.arrayBuffer()) : m === "Blob" && (a.value = s.value);
  }
  return I(() => T(n), g), {
    isSupported: o,
    data: a,
    file: s,
    fileName: u,
    fileMIME: l,
    fileSize: f,
    fileLastModified: d,
    open: y,
    create: v,
    save: p,
    saveAs: S,
    updateData: g
  };
}
function qm(e, t = {}) {
  const { initialValue: n = !1, focusVisible: r = !1 } = t, o = O(!1), i = C(() => Y(e));
  R(i, "focus", (s) => {
    var u, l;
    (!r || (l = (u = s.target).matches) != null && l.call(u, ":focus-visible")) && (o.value = !0);
  }), R(i, "blur", () => o.value = !1);
  const a = C({
    get: () => o.value,
    set(s) {
      var u, l;
      !s && o.value ? (u = i.value) == null || u.blur() : s && !o.value && ((l = i.value) == null || l.focus());
    }
  });
  return I(
    i,
    () => {
      a.value = n;
    },
    { immediate: !0, flush: "post" }
  ), { focused: a };
}
function ey(e, t = {}) {
  const n = rl(t), r = C(() => Y(e));
  return { focused: C(() => r.value && n.value ? r.value.contains(n.value) : !1) };
}
function ty(e) {
  var t;
  const n = O(0);
  if (typeof performance > "u")
    return n;
  const r = (t = e == null ? void 0 : e.every) != null ? t : 10;
  let o = performance.now(), i = 0;
  return Wt(() => {
    if (i += 1, i >= r) {
      const a = performance.now(), s = a - o;
      n.value = Math.round(1e3 / (s / i)), o = a, i = 0;
    }
  }), n;
}
const Xi = [
  "fullscreenchange",
  "webkitfullscreenchange",
  "webkitendfullscreen",
  "mozfullscreenchange",
  "MSFullscreenChange"
];
function ny(e, t = {}) {
  const {
    document: n = Me,
    autoExit: r = !1
  } = t, o = C(() => {
    var g;
    return (g = Y(e)) != null ? g : n == null ? void 0 : n.querySelector("html");
  }), i = O(!1), a = C(() => [
    "requestFullscreen",
    "webkitRequestFullscreen",
    "webkitEnterFullscreen",
    "webkitEnterFullScreen",
    "webkitRequestFullScreen",
    "mozRequestFullScreen",
    "msRequestFullscreen"
  ].find((g) => n && g in n || o.value && g in o.value)), s = C(() => [
    "exitFullscreen",
    "webkitExitFullscreen",
    "webkitExitFullScreen",
    "webkitCancelFullScreen",
    "mozCancelFullScreen",
    "msExitFullscreen"
  ].find((g) => n && g in n || o.value && g in o.value)), u = C(() => [
    "fullScreen",
    "webkitIsFullScreen",
    "webkitDisplayingFullscreen",
    "mozFullScreen",
    "msFullscreenElement"
  ].find((g) => n && g in n || o.value && g in o.value)), l = [
    "fullscreenElement",
    "webkitFullscreenElement",
    "mozFullScreenElement",
    "msFullscreenElement"
  ].find((g) => n && g in n), f = $(() => o.value && n && a.value !== void 0 && s.value !== void 0 && u.value !== void 0), d = () => l ? (n == null ? void 0 : n[l]) === o.value : !1, y = () => {
    if (u.value) {
      if (n && n[u.value] != null)
        return n[u.value];
      {
        const g = o.value;
        if ((g == null ? void 0 : g[u.value]) != null)
          return !!g[u.value];
      }
    }
    return !1;
  };
  async function v() {
    if (!(!f.value || !i.value)) {
      if (s.value)
        if ((n == null ? void 0 : n[s.value]) != null)
          await n[s.value]();
        else {
          const g = o.value;
          (g == null ? void 0 : g[s.value]) != null && await g[s.value]();
        }
      i.value = !1;
    }
  }
  async function p() {
    if (!f.value || i.value)
      return;
    y() && await v();
    const g = o.value;
    a.value && (g == null ? void 0 : g[a.value]) != null && (await g[a.value](), i.value = !0);
  }
  async function S() {
    await (i.value ? v() : p());
  }
  const _ = () => {
    const g = y();
    (!g || g && d()) && (i.value = g);
  };
  return R(n, Xi, _, !1), R(() => Y(o), Xi, _, !1), r && V(v), {
    isSupported: f,
    isFullscreen: i,
    enter: p,
    exit: v,
    toggle: S
  };
}
function ry(e) {
  return C(() => e.value ? {
    buttons: {
      a: e.value.buttons[0],
      b: e.value.buttons[1],
      x: e.value.buttons[2],
      y: e.value.buttons[3]
    },
    bumper: {
      left: e.value.buttons[4],
      right: e.value.buttons[5]
    },
    triggers: {
      left: e.value.buttons[6],
      right: e.value.buttons[7]
    },
    stick: {
      left: {
        horizontal: e.value.axes[0],
        vertical: e.value.axes[1],
        button: e.value.buttons[10]
      },
      right: {
        horizontal: e.value.axes[2],
        vertical: e.value.axes[3],
        button: e.value.buttons[11]
      }
    },
    dpad: {
      up: e.value.buttons[12],
      down: e.value.buttons[13],
      left: e.value.buttons[14],
      right: e.value.buttons[15]
    },
    back: e.value.buttons[8],
    start: e.value.buttons[9]
  } : null);
}
function oy(e = {}) {
  const {
    navigator: t = Ce
  } = e, n = $(() => t && "getGamepads" in t), r = O([]), o = Te(), i = Te(), a = (v) => {
    const p = [], S = "vibrationActuator" in v ? v.vibrationActuator : null;
    return S && p.push(S), v.hapticActuators && p.push(...v.hapticActuators), {
      ...v,
      id: v.id,
      hapticActuators: p,
      axes: v.axes.map((_) => _),
      buttons: v.buttons.map((_) => ({ pressed: _.pressed, touched: _.touched, value: _.value }))
    };
  }, s = () => {
    const v = (t == null ? void 0 : t.getGamepads()) || [];
    for (let p = 0; p < v.length; ++p) {
      const S = v[p];
      if (S) {
        const _ = r.value.findIndex(({ index: g }) => g === S.index);
        _ > -1 && (r.value[_] = a(S));
      }
    }
  }, { isActive: u, pause: l, resume: f } = Wt(s), d = (v) => {
    r.value.some(({ index: p }) => p === v.index) || (r.value.push(a(v)), o.trigger(v.index)), f();
  }, y = (v) => {
    r.value = r.value.filter((p) => p.index !== v.index), i.trigger(v.index);
  };
  return R("gamepadconnected", (v) => d(v.gamepad)), R("gamepaddisconnected", (v) => y(v.gamepad)), me(() => {
    const v = (t == null ? void 0 : t.getGamepads()) || [];
    if (v)
      for (let p = 0; p < v.length; ++p) {
        const S = v[p];
        S && d(S);
      }
  }), l(), {
    isSupported: n,
    onConnected: o.on,
    onDisconnected: i.on,
    gamepads: r,
    pause: l,
    resume: f,
    isActive: u
  };
}
function iy(e = {}) {
  const {
    enableHighAccuracy: t = !0,
    maximumAge: n = 3e4,
    timeout: r = 27e3,
    navigator: o = Ce,
    immediate: i = !0
  } = e, a = $(() => o && "geolocation" in o), s = O(null), u = oe(null), l = O({
    accuracy: 0,
    latitude: Number.POSITIVE_INFINITY,
    longitude: Number.POSITIVE_INFINITY,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    speed: null
  });
  function f(p) {
    s.value = p.timestamp, l.value = p.coords, u.value = null;
  }
  let d;
  function y() {
    a.value && (d = o.geolocation.watchPosition(
      f,
      (p) => u.value = p,
      {
        enableHighAccuracy: t,
        maximumAge: n,
        timeout: r
      }
    ));
  }
  i && y();
  function v() {
    d && o && o.geolocation.clearWatch(d);
  }
  return V(() => {
    v();
  }), {
    isSupported: a,
    coords: l,
    locatedAt: s,
    error: u,
    resume: y,
    pause: v
  };
}
const _l = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"], Ol = 6e4;
function ay(e = Ol, t = {}) {
  const {
    initialState: n = !1,
    listenForVisibilityChange: r = !0,
    events: o = _l,
    window: i = U,
    eventFilter: a = Rr(50)
  } = t, s = O(n), u = O(Ht());
  let l;
  const f = () => {
    s.value = !1, clearTimeout(l), l = setTimeout(() => s.value = !0, e);
  }, d = Vt(
    a,
    () => {
      u.value = Ht(), f();
    }
  );
  if (i) {
    const y = i.document;
    for (const v of o)
      R(i, v, d, { passive: !0 });
    r && R(y, "visibilitychange", () => {
      y.hidden || d();
    }), f();
  }
  return {
    idle: s,
    lastActive: u,
    reset: f
  };
}
async function El(e) {
  return new Promise((t, n) => {
    const r = new Image(), { src: o, srcset: i, sizes: a, class: s, loading: u, crossorigin: l, referrerPolicy: f } = e;
    r.src = o, i && (r.srcset = i), a && (r.sizes = a), s && (r.className = s), u && (r.loading = u), l && (r.crossOrigin = l), f && (r.referrerPolicy = f), r.onload = () => t(r), r.onerror = n;
  });
}
function sy(e, t = {}) {
  const n = al(
    () => El(T(e)),
    void 0,
    {
      resetOnExecute: !0,
      ...t
    }
  );
  return I(
    () => T(e),
    () => n.execute(t.delay),
    { deep: !0 }
  ), n;
}
const Hi = 1;
function Tl(e, t = {}) {
  const {
    throttle: n = 0,
    idle: r = 200,
    onStop: o = re,
    onScroll: i = re,
    offset: a = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: s = {
      capture: !1,
      passive: !0
    },
    behavior: u = "auto",
    window: l = U
  } = t, f = O(0), d = O(0), y = C({
    get() {
      return f.value;
    },
    set(x) {
      p(x, void 0);
    }
  }), v = C({
    get() {
      return d.value;
    },
    set(x) {
      p(void 0, x);
    }
  });
  function p(x, A) {
    var N, D, M;
    if (!l)
      return;
    const L = T(e);
    L && ((M = L instanceof Document ? l.document.body : L) == null || M.scrollTo({
      top: (N = T(A)) != null ? N : v.value,
      left: (D = T(x)) != null ? D : y.value,
      behavior: T(u)
    }));
  }
  const S = O(!1), _ = ae({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), g = ae({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), b = (x) => {
    S.value && (S.value = !1, g.left = !1, g.right = !1, g.top = !1, g.bottom = !1, o(x));
  }, h = Pi(b, n + r), m = (x) => {
    var A;
    if (!l)
      return;
    const N = x.document ? x.document.documentElement : (A = x.documentElement) != null ? A : x, { display: D, flexDirection: M } = getComputedStyle(N), L = N.scrollLeft;
    g.left = L < f.value, g.right = L > f.value;
    const K = Math.abs(L) <= 0 + (a.left || 0), X = Math.abs(L) + N.clientWidth >= N.scrollWidth - (a.right || 0) - Hi;
    D === "flex" && M === "row-reverse" ? (_.left = X, _.right = K) : (_.left = K, _.right = X), f.value = L;
    let ee = N.scrollTop;
    x === l.document && !ee && (ee = l.document.body.scrollTop), g.top = ee < d.value, g.bottom = ee > d.value;
    const te = Math.abs(ee) <= 0 + (a.top || 0), F = Math.abs(ee) + N.clientHeight >= N.scrollHeight - (a.bottom || 0) - Hi;
    D === "flex" && M === "column-reverse" ? (_.top = F, _.bottom = te) : (_.top = te, _.bottom = F), d.value = ee;
  }, P = (x) => {
    var A;
    if (!l)
      return;
    const N = (A = x.target.documentElement) != null ? A : x.target;
    m(N), S.value = !0, h(x), i(x);
  };
  return R(
    e,
    "scroll",
    n ? Va(P, n, !0, !1) : P,
    s
  ), me(() => {
    const x = T(e);
    x && m(x);
  }), R(
    e,
    "scrollend",
    b,
    s
  ), {
    x: y,
    y: v,
    isScrolling: S,
    arrivedState: _,
    directions: g,
    measure() {
      const x = T(e);
      l && x && m(x);
    }
  };
}
function hr(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function uy(e, t, n = {}) {
  var r;
  const {
    direction: o = "bottom",
    interval: i = 100,
    canLoadMore: a = () => !0
  } = n, s = ae(Tl(
    e,
    {
      ...n,
      offset: {
        [o]: (r = n.distance) != null ? r : 0,
        ...n.offset
      }
    }
  )), u = O(), l = C(() => !!u.value), f = C(() => hr(T(e))), d = gl(f);
  function y() {
    if (s.measure(), !f.value || !d.value || !a(f.value))
      return;
    const { scrollHeight: v, clientHeight: p, scrollWidth: S, clientWidth: _ } = f.value, g = o === "bottom" || o === "top" ? v <= p : S <= _;
    (s.arrivedState[o] || g) && (u.value || (u.value = Promise.all([
      t(s),
      new Promise((b) => setTimeout(b, i))
    ]).finally(() => {
      u.value = null, Le(() => y());
    })));
  }
  return I(
    () => [s.arrivedState[o], d.value],
    y,
    { immediate: !0 }
  ), {
    isLoading: l
  };
}
const Al = ["mousedown", "mouseup", "keydown", "keyup"];
function ly(e, t = {}) {
  const {
    events: n = Al,
    document: r = Me,
    initial: o = null
  } = t, i = O(o);
  return r && n.forEach((a) => {
    R(r, a, (s) => {
      typeof s.getModifierState == "function" && (i.value = s.getModifierState(e));
    });
  }), i;
}
function cy(e, t, n = {}) {
  const { window: r = U } = n;
  return Oi(e, t, r == null ? void 0 : r.localStorage, n);
}
const Ml = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};
function fy(e = {}) {
  const {
    reactive: t = !1,
    target: n = U,
    aliasMap: r = Ml,
    passive: o = !0,
    onEventFired: i = re
  } = e, a = ae(/* @__PURE__ */ new Set()), s = {
    toJSON() {
      return {};
    },
    current: a
  }, u = t ? ae(s) : s, l = /* @__PURE__ */ new Set(), f = /* @__PURE__ */ new Set();
  function d(S, _) {
    S in u && (t ? u[S] = _ : u[S].value = _);
  }
  function y() {
    a.clear();
    for (const S of f)
      d(S, !1);
  }
  function v(S, _) {
    var g, b;
    const h = (g = S.key) == null ? void 0 : g.toLowerCase(), P = [(b = S.code) == null ? void 0 : b.toLowerCase(), h].filter(Boolean);
    h && (_ ? a.add(h) : a.delete(h));
    for (const x of P)
      f.add(x), d(x, _);
    h === "meta" && !_ ? (l.forEach((x) => {
      a.delete(x), d(x, !1);
    }), l.clear()) : typeof S.getModifierState == "function" && S.getModifierState("Meta") && _ && [...a, ...P].forEach((x) => l.add(x));
  }
  R(n, "keydown", (S) => (v(S, !0), i(S)), { passive: o }), R(n, "keyup", (S) => (v(S, !1), i(S)), { passive: o }), R("blur", y, { passive: !0 }), R("focus", y, { passive: !0 });
  const p = new Proxy(
    u,
    {
      get(S, _, g) {
        if (typeof _ != "string")
          return Reflect.get(S, _, g);
        if (_ = _.toLowerCase(), _ in r && (_ = r[_]), !(_ in u))
          if (/[+_-]/.test(_)) {
            const h = _.split(/[+_-]/g).map((m) => m.trim());
            u[_] = C(() => h.every((m) => T(p[m])));
          } else
            u[_] = O(!1);
        const b = Reflect.get(S, _, g);
        return t ? T(b) : b;
      }
    }
  );
  return p;
}
function Lo(e, t) {
  T(e) && t(T(e));
}
function kl(e) {
  let t = [];
  for (let n = 0; n < e.length; ++n)
    t = [...t, [e.start(n), e.end(n)]];
  return t;
}
function Io(e) {
  return Array.from(e).map(({ label: t, kind: n, language: r, mode: o, activeCues: i, cues: a, inBandMetadataTrackDispatchType: s }, u) => ({ id: u, label: t, kind: n, language: r, mode: o, activeCues: i, cues: a, inBandMetadataTrackDispatchType: s }));
}
const jl = {
  src: "",
  tracks: []
};
function dy(e, t = {}) {
  t = {
    ...jl,
    ...t
  };
  const {
    document: n = Me
  } = t, r = O(0), o = O(0), i = O(!1), a = O(1), s = O(!1), u = O(!1), l = O(!1), f = O(1), d = O(!1), y = O([]), v = O([]), p = O(-1), S = O(!1), _ = O(!1), g = n && "pictureInPictureEnabled" in n, b = Te(), h = (M) => {
    Lo(e, (L) => {
      if (M) {
        const K = typeof M == "number" ? M : M.id;
        L.textTracks[K].mode = "disabled";
      } else
        for (let K = 0; K < L.textTracks.length; ++K)
          L.textTracks[K].mode = "disabled";
      p.value = -1;
    });
  }, m = (M, L = !0) => {
    Lo(e, (K) => {
      const X = typeof M == "number" ? M : M.id;
      L && h(), K.textTracks[X].mode = "showing", p.value = X;
    });
  }, P = () => new Promise((M, L) => {
    Lo(e, async (K) => {
      g && (S.value ? n.exitPictureInPicture().then(M).catch(L) : K.requestPictureInPicture().then(M).catch(L));
    });
  });
  Xt(() => {
    if (!n)
      return;
    const M = T(e);
    if (!M)
      return;
    const L = T(t.src);
    let K = [];
    L && (typeof L == "string" ? K = [{ src: L }] : Array.isArray(L) ? K = L : Cr(L) && (K = [L]), M.querySelectorAll("source").forEach((X) => {
      X.removeEventListener("error", b.trigger), X.remove();
    }), K.forEach(({ src: X, type: ee }) => {
      const te = n.createElement("source");
      te.setAttribute("src", X), te.setAttribute("type", ee || ""), te.addEventListener("error", b.trigger), M.appendChild(te);
    }), M.load());
  }), V(() => {
    const M = T(e);
    M && M.querySelectorAll("source").forEach((L) => L.removeEventListener("error", b.trigger));
  }), I([e, a], () => {
    const M = T(e);
    M && (M.volume = a.value);
  }), I([e, _], () => {
    const M = T(e);
    M && (M.muted = _.value);
  }), I([e, f], () => {
    const M = T(e);
    M && (M.playbackRate = f.value);
  }), Xt(() => {
    if (!n)
      return;
    const M = T(t.tracks), L = T(e);
    !M || !M.length || !L || (L.querySelectorAll("track").forEach((K) => K.remove()), M.forEach(({ default: K, kind: X, label: ee, src: te, srcLang: F }, ne) => {
      const se = n.createElement("track");
      se.default = K || !1, se.kind = X, se.label = ee, se.src = te, se.srclang = F, se.default && (p.value = ne), L.appendChild(se);
    }));
  });
  const { ignoreUpdates: x } = _r(r, (M) => {
    const L = T(e);
    L && (L.currentTime = M);
  }), { ignoreUpdates: A } = _r(l, (M) => {
    const L = T(e);
    L && (M ? L.play() : L.pause());
  });
  R(e, "timeupdate", () => x(() => r.value = T(e).currentTime)), R(e, "durationchange", () => o.value = T(e).duration), R(e, "progress", () => y.value = kl(T(e).buffered)), R(e, "seeking", () => i.value = !0), R(e, "seeked", () => i.value = !1), R(e, ["waiting", "loadstart"], () => {
    s.value = !0, A(() => l.value = !1);
  }), R(e, "loadeddata", () => s.value = !1), R(e, "playing", () => {
    s.value = !1, u.value = !1, A(() => l.value = !0);
  }), R(e, "ratechange", () => f.value = T(e).playbackRate), R(e, "stalled", () => d.value = !0), R(e, "ended", () => u.value = !0), R(e, "pause", () => A(() => l.value = !1)), R(e, "play", () => A(() => l.value = !0)), R(e, "enterpictureinpicture", () => S.value = !0), R(e, "leavepictureinpicture", () => S.value = !1), R(e, "volumechange", () => {
    const M = T(e);
    M && (a.value = M.volume, _.value = M.muted);
  });
  const N = [], D = I([e], () => {
    const M = T(e);
    M && (D(), N[0] = R(M.textTracks, "addtrack", () => v.value = Io(M.textTracks)), N[1] = R(M.textTracks, "removetrack", () => v.value = Io(M.textTracks)), N[2] = R(M.textTracks, "change", () => v.value = Io(M.textTracks)));
  });
  return V(() => N.forEach((M) => M())), {
    currentTime: r,
    duration: o,
    waiting: s,
    seeking: i,
    ended: u,
    stalled: d,
    buffered: y,
    playing: l,
    rate: f,
    // Volume
    volume: a,
    muted: _,
    // Tracks
    tracks: v,
    selectedTrack: p,
    enableTrack: m,
    disableTrack: h,
    // Picture in Picture
    supportsPictureInPicture: g,
    togglePictureInPicture: P,
    isPictureInPicture: S,
    // Events
    onSourceError: b.on
  };
}
function py(e, t) {
  const r = t != null && t.cache ? wr(t.cache) : wr(/* @__PURE__ */ new Map()), o = (...f) => t != null && t.getKey ? t.getKey(...f) : JSON.stringify(f), i = (f, ...d) => (r.set(f, e(...d)), r.get(f)), a = (...f) => i(o(...f), ...f), s = (...f) => {
    r.delete(o(...f));
  }, u = () => {
    r.clear();
  }, l = (...f) => {
    const d = o(...f);
    return r.has(d) ? r.get(d) : i(d, ...f);
  };
  return l.load = a, l.delete = s, l.clear = u, l.generateKey = o, l.cache = r, l;
}
function hy(e = {}) {
  const t = O(), n = $(() => typeof performance < "u" && "memory" in performance);
  if (n.value) {
    const { interval: r = 1e3 } = e;
    St(() => {
      t.value = performance.memory;
    }, r, { immediate: e.immediate, immediateCallback: e.immediateCallback });
  }
  return { isSupported: n, memory: t };
}
const Cl = {
  page: (e) => [e.pageX, e.pageY],
  client: (e) => [e.clientX, e.clientY],
  screen: (e) => [e.screenX, e.screenY],
  movement: (e) => e instanceof Touch ? null : [e.movementX, e.movementY]
};
function Dl(e = {}) {
  const {
    type: t = "page",
    touch: n = !0,
    resetOnTouchEnds: r = !1,
    initialValue: o = { x: 0, y: 0 },
    window: i = U,
    target: a = i,
    scroll: s = !0,
    eventFilter: u
  } = e;
  let l = null;
  const f = O(o.x), d = O(o.y), y = O(null), v = typeof t == "function" ? t : Cl[t], p = (P) => {
    const x = v(P);
    l = P, x && ([f.value, d.value] = x, y.value = "mouse");
  }, S = (P) => {
    if (P.touches.length > 0) {
      const x = v(P.touches[0]);
      x && ([f.value, d.value] = x, y.value = "touch");
    }
  }, _ = () => {
    if (!l || !i)
      return;
    const P = v(l);
    l instanceof MouseEvent && P && (f.value = P[0] + i.scrollX, d.value = P[1] + i.scrollY);
  }, g = () => {
    f.value = o.x, d.value = o.y;
  }, b = u ? (P) => u(() => p(P), {}) : (P) => p(P), h = u ? (P) => u(() => S(P), {}) : (P) => S(P), m = u ? () => u(() => _(), {}) : () => _();
  if (a) {
    const P = { passive: !0 };
    R(a, ["mousemove", "dragover"], b, P), n && t !== "movement" && (R(a, ["touchstart", "touchmove"], h, P), r && R(a, "touchend", g, P)), s && t === "page" && R(i, "scroll", m, { passive: !0 });
  }
  return {
    x: f,
    y: d,
    sourceType: y
  };
}
function Rl(e, t = {}) {
  const {
    handleOutside: n = !0,
    window: r = U
  } = t, o = t.type || "page", { x: i, y: a, sourceType: s } = Dl(t), u = O(e ?? (r == null ? void 0 : r.document.body)), l = O(0), f = O(0), d = O(0), y = O(0), v = O(0), p = O(0), S = O(!0);
  let _ = () => {
  };
  return r && (_ = I(
    [u, i, a],
    () => {
      const g = Y(u);
      if (!g)
        return;
      const {
        left: b,
        top: h,
        width: m,
        height: P
      } = g.getBoundingClientRect();
      d.value = b + (o === "page" ? r.pageXOffset : 0), y.value = h + (o === "page" ? r.pageYOffset : 0), v.value = P, p.value = m;
      const x = i.value - d.value, A = a.value - y.value;
      S.value = m === 0 || P === 0 || x < 0 || A < 0 || x > m || A > P, (n || !S.value) && (l.value = x, f.value = A);
    },
    { immediate: !0 }
  ), R(document, "mouseleave", () => {
    S.value = !0;
  })), {
    x: i,
    y: a,
    sourceType: s,
    elementX: l,
    elementY: f,
    elementPositionX: d,
    elementPositionY: y,
    elementHeight: v,
    elementWidth: p,
    isOutside: S,
    stop: _
  };
}
function vy(e = {}) {
  const {
    touch: t = !0,
    drag: n = !0,
    capture: r = !1,
    initialValue: o = !1,
    window: i = U
  } = e, a = O(o), s = O(null);
  if (!i)
    return {
      pressed: a,
      sourceType: s
    };
  const u = (d) => () => {
    a.value = !0, s.value = d;
  }, l = () => {
    a.value = !1, s.value = null;
  }, f = C(() => Y(e.target) || i);
  return R(f, "mousedown", u("mouse"), { passive: !0, capture: r }), R(i, "mouseleave", l, { passive: !0, capture: r }), R(i, "mouseup", l, { passive: !0, capture: r }), n && (R(f, "dragstart", u("mouse"), { passive: !0, capture: r }), R(i, "drop", l, { passive: !0, capture: r }), R(i, "dragend", l, { passive: !0, capture: r })), t && (R(f, "touchstart", u("touch"), { passive: !0, capture: r }), R(i, "touchend", l, { passive: !0, capture: r }), R(i, "touchcancel", l, { passive: !0, capture: r })), {
    pressed: a,
    sourceType: s
  };
}
function my(e = {}) {
  const { window: t = U } = e, n = t == null ? void 0 : t.navigator, r = $(() => n && "language" in n), o = O(n == null ? void 0 : n.language);
  return R(t, "languagechange", () => {
    n && (o.value = n.language);
  }), {
    isSupported: r,
    language: o
  };
}
function Nl(e = {}) {
  const { window: t = U } = e, n = t == null ? void 0 : t.navigator, r = $(() => n && "connection" in n), o = O(!0), i = O(!1), a = O(void 0), s = O(void 0), u = O(void 0), l = O(void 0), f = O(void 0), d = O(void 0), y = O("unknown"), v = r.value && n.connection;
  function p() {
    n && (o.value = n.onLine, a.value = o.value ? void 0 : Date.now(), s.value = o.value ? Date.now() : void 0, v && (u.value = v.downlink, l.value = v.downlinkMax, d.value = v.effectiveType, f.value = v.rtt, i.value = v.saveData, y.value = v.type));
  }
  return t && (R(t, "offline", () => {
    o.value = !1, a.value = Date.now();
  }), R(t, "online", () => {
    o.value = !0, s.value = Date.now();
  })), v && R(v, "change", p, !1), p(), {
    isSupported: r,
    isOnline: o,
    saveData: i,
    offlineAt: a,
    onlineAt: s,
    downlink: u,
    downlinkMax: l,
    effectiveType: d,
    rtt: f,
    type: y
  };
}
function Ll(e = {}) {
  const {
    controls: t = !1,
    interval: n = "requestAnimationFrame"
  } = e, r = O(/* @__PURE__ */ new Date()), o = () => r.value = /* @__PURE__ */ new Date(), i = n === "requestAnimationFrame" ? Wt(o, { immediate: !0 }) : St(o, n, { immediate: !0 });
  return t ? {
    now: r,
    ...i
  } : r;
}
function yy(e) {
  const t = O(), n = () => {
    t.value && URL.revokeObjectURL(t.value), t.value = void 0;
  };
  return I(
    () => T(e),
    (r) => {
      n(), r && (t.value = URL.createObjectURL(r));
    },
    { immediate: !0 }
  ), V(n), je(t);
}
function Bi(e, t, n) {
  if (typeof e == "function" || ni(e))
    return C(() => Ro(T(e), T(t), T(n)));
  const r = O(e);
  return C({
    get() {
      return r.value = Ro(r.value, T(t), T(n));
    },
    set(o) {
      r.value = Ro(o, T(t), T(n));
    }
  });
}
function gy(e) {
  const {
    total: t = Number.POSITIVE_INFINITY,
    pageSize: n = 10,
    page: r = 1,
    onPageChange: o = re,
    onPageSizeChange: i = re,
    onPageCountChange: a = re
  } = e, s = Bi(n, 1, Number.POSITIVE_INFINITY), u = C(() => Math.max(
    1,
    Math.ceil(T(t) / T(s))
  )), l = Bi(r, 1, u), f = C(() => l.value === 1), d = C(() => l.value === u.value);
  Pe(r) && zi(r, l, {
    direction: ni(r) ? "ltr" : "both"
  }), Pe(n) && zi(n, s, {
    direction: ni(n) ? "ltr" : "both"
  });
  function y() {
    l.value--;
  }
  function v() {
    l.value++;
  }
  const p = {
    currentPage: l,
    currentPageSize: s,
    pageCount: u,
    isFirstPage: f,
    isLastPage: d,
    prev: y,
    next: v
  };
  return I(l, () => {
    o(ae(p));
  }), I(s, () => {
    i(ae(p));
  }), I(u, () => {
    a(ae(p));
  }), p;
}
function by(e = {}) {
  const { isOnline: t } = Nl(e);
  return t;
}
function wy(e = {}) {
  const { window: t = U } = e, n = O(!1), r = (o) => {
    if (!t)
      return;
    o = o || t.event;
    const i = o.relatedTarget || o.toElement;
    n.value = !i;
  };
  return t && (R(t, "mouseout", r, { passive: !0 }), R(t.document, "mouseleave", r, { passive: !0 }), R(t.document, "mouseenter", r, { passive: !0 })), n;
}
function Sy(e, t = {}) {
  const {
    deviceOrientationTiltAdjust: n = (S) => S,
    deviceOrientationRollAdjust: r = (S) => S,
    mouseTiltAdjust: o = (S) => S,
    mouseRollAdjust: i = (S) => S,
    window: a = U
  } = t, s = ae(ml({ window: a })), {
    elementX: u,
    elementY: l,
    elementWidth: f,
    elementHeight: d
  } = Rl(e, { handleOutside: !1, window: a }), y = C(() => s.isSupported && (s.alpha != null && s.alpha !== 0 || s.gamma != null && s.gamma !== 0) ? "deviceOrientation" : "mouse"), v = C(() => {
    if (y.value === "deviceOrientation") {
      const S = -s.beta / 90;
      return r(S);
    } else {
      const S = -(l.value - d.value / 2) / d.value;
      return i(S);
    }
  }), p = C(() => {
    if (y.value === "deviceOrientation") {
      const S = s.gamma / 90;
      return n(S);
    } else {
      const S = (u.value - f.value / 2) / f.value;
      return o(S);
    }
  });
  return { roll: v, tilt: p, source: y };
}
function Py(e = fl()) {
  const t = oe(), n = () => {
    const r = Y(e);
    r && (t.value = r.parentElement);
  };
  return me(n), I(() => T(e), n), t;
}
function xy(e, t) {
  const {
    window: n = U,
    immediate: r = !0,
    ...o
  } = e, i = $(() => n && "PerformanceObserver" in n);
  let a;
  const s = () => {
    a == null || a.disconnect();
  }, u = () => {
    i.value && (s(), a = new PerformanceObserver(t), a.observe(o));
  };
  return V(s), r && u(), {
    isSupported: i,
    start: u,
    stop: s
  };
}
const ns = {
  x: 0,
  y: 0,
  pointerId: 0,
  pressure: 0,
  tiltX: 0,
  tiltY: 0,
  width: 0,
  height: 0,
  twist: 0,
  pointerType: null
}, Il = /* @__PURE__ */ Object.keys(ns);
function _y(e = {}) {
  const {
    target: t = U
  } = e, n = O(!1), r = O(e.initialValue || {});
  Object.assign(r.value, ns, r.value);
  const o = (i) => {
    n.value = !0, !(e.pointerTypes && !e.pointerTypes.includes(i.pointerType)) && (r.value = Du(i, Il, !1));
  };
  if (t) {
    const i = { passive: !0 };
    R(t, ["pointerdown", "pointermove", "pointerup"], o, i), R(t, "pointerleave", () => n.value = !1, i);
  }
  return {
    ...Wa(r),
    isInside: n
  };
}
function Oy(e, t = {}) {
  const { document: n = Me, pointerLockOptions: r } = t, o = $(() => n && "pointerLockElement" in n), i = O(), a = O();
  let s;
  o.value && (R(n, "pointerlockchange", () => {
    var f;
    const d = (f = n.pointerLockElement) != null ? f : i.value;
    s && d === s && (i.value = n.pointerLockElement, i.value || (s = a.value = null));
  }), R(n, "pointerlockerror", () => {
    var f;
    const d = (f = n.pointerLockElement) != null ? f : i.value;
    if (s && d === s) {
      const y = n.pointerLockElement ? "release" : "acquire";
      throw new Error(`Failed to ${y} pointer lock.`);
    }
  }));
  async function u(f, d) {
    var y;
    if (!o.value)
      throw new Error("Pointer Lock API is not supported by your browser.");
    if (a.value = f instanceof Event ? f.currentTarget : null, s = f instanceof Event ? (y = Y(e)) != null ? y : a.value : Y(f), !s)
      throw new Error("Target element undefined.");
    return s.requestPointerLock(d ?? r), await xr(i).toBe(s);
  }
  async function l() {
    return i.value ? (n.exitPointerLock(), await xr(i).toBeNull(), !0) : !1;
  }
  return {
    isSupported: o,
    element: i,
    triggerElement: a,
    lock: u,
    unlock: l
  };
}
function Ey(e, t = {}) {
  const n = ve(e), {
    threshold: r = 50,
    onSwipe: o,
    onSwipeEnd: i,
    onSwipeStart: a,
    disableTextSelect: s = !1
  } = t, u = ae({ x: 0, y: 0 }), l = (A, N) => {
    u.x = A, u.y = N;
  }, f = ae({ x: 0, y: 0 }), d = (A, N) => {
    f.x = A, f.y = N;
  }, y = C(() => u.x - f.x), v = C(() => u.y - f.y), { max: p, abs: S } = Math, _ = C(() => p(S(y.value), S(v.value)) >= r), g = O(!1), b = O(!1), h = C(() => _.value ? S(y.value) > S(v.value) ? y.value > 0 ? "left" : "right" : v.value > 0 ? "up" : "down" : "none"), m = (A) => {
    var N, D, M;
    const L = A.buttons === 0, K = A.buttons === 1;
    return (M = (D = (N = t.pointerTypes) == null ? void 0 : N.includes(A.pointerType)) != null ? D : L || K) != null ? M : !0;
  }, P = [
    R(e, "pointerdown", (A) => {
      if (!m(A))
        return;
      b.value = !0;
      const N = A.target;
      N == null || N.setPointerCapture(A.pointerId);
      const { clientX: D, clientY: M } = A;
      l(D, M), d(D, M), a == null || a(A);
    }),
    R(e, "pointermove", (A) => {
      if (!m(A) || !b.value)
        return;
      const { clientX: N, clientY: D } = A;
      d(N, D), !g.value && _.value && (g.value = !0), g.value && (o == null || o(A));
    }),
    R(e, "pointerup", (A) => {
      m(A) && (g.value && (i == null || i(A, h.value)), b.value = !1, g.value = !1);
    })
  ];
  me(() => {
    var A, N, D, M, L, K, X, ee;
    (N = (A = n.value) == null ? void 0 : A.style) == null || N.setProperty("touch-action", "none"), s && ((M = (D = n.value) == null ? void 0 : D.style) == null || M.setProperty("-webkit-user-select", "none"), (K = (L = n.value) == null ? void 0 : L.style) == null || K.setProperty("-ms-user-select", "none"), (ee = (X = n.value) == null ? void 0 : X.style) == null || ee.setProperty("user-select", "none"));
  });
  const x = () => P.forEach((A) => A());
  return {
    isSwiping: je(g),
    direction: je(h),
    posStart: je(u),
    posEnd: je(f),
    distanceX: y,
    distanceY: v,
    stop: x
  };
}
function Ty(e) {
  const t = ke("(prefers-color-scheme: light)", e), n = ke("(prefers-color-scheme: dark)", e);
  return C(() => n.value ? "dark" : t.value ? "light" : "no-preference");
}
function Ay(e) {
  const t = ke("(prefers-contrast: more)", e), n = ke("(prefers-contrast: less)", e), r = ke("(prefers-contrast: custom)", e);
  return C(() => t.value ? "more" : n.value ? "less" : r.value ? "custom" : "no-preference");
}
function My(e = {}) {
  const { window: t = U } = e;
  if (!t)
    return O(["en"]);
  const n = t.navigator, r = O(n.languages);
  return R(t, "languagechange", () => {
    r.value = n.languages;
  }), r;
}
function ky(e) {
  const t = ke("(prefers-reduced-motion: reduce)", e);
  return C(() => t.value ? "reduce" : "no-preference");
}
function jy(e, t) {
  const n = oe(t);
  return I(
    ve(e),
    (r, o) => {
      n.value = o;
    },
    { flush: "sync" }
  ), je(n);
}
function Cy(e = {}) {
  const {
    window: t = U
  } = e, n = $(() => t && "screen" in t && "orientation" in t.screen), r = n.value ? t.screen.orientation : {}, o = O(r.type), i = O(r.angle || 0);
  return n.value && R(t, "orientationchange", () => {
    o.value = r.type, i.value = r.angle;
  }), {
    isSupported: n,
    orientation: o,
    angle: i,
    lockOrientation: (u) => n.value && typeof r.lock == "function" ? r.lock(u) : Promise.reject(new Error("Not supported")),
    unlockOrientation: () => {
      n.value && typeof r.unlock == "function" && r.unlock();
    }
  };
}
const Vi = "--vueuse-safe-area-top", Wi = "--vueuse-safe-area-right", Ji = "--vueuse-safe-area-bottom", Yi = "--vueuse-safe-area-left";
function Dy() {
  const e = O(""), t = O(""), n = O(""), r = O("");
  if (xe) {
    const i = sr(Vi), a = sr(Wi), s = sr(Ji), u = sr(Yi);
    i.value = "env(safe-area-inset-top, 0px)", a.value = "env(safe-area-inset-right, 0px)", s.value = "env(safe-area-inset-bottom, 0px)", u.value = "env(safe-area-inset-left, 0px)", o(), R("resize", Pi(o));
  }
  function o() {
    e.value = ur(Vi), t.value = ur(Wi), n.value = ur(Ji), r.value = ur(Yi);
  }
  return {
    top: e,
    right: t,
    bottom: n,
    left: r,
    update: o
  };
}
function ur(e) {
  return getComputedStyle(document.documentElement).getPropertyValue(e);
}
function Ry(e, t = re, n = {}) {
  const {
    immediate: r = !0,
    manual: o = !1,
    type: i = "text/javascript",
    async: a = !0,
    crossOrigin: s,
    referrerPolicy: u,
    noModule: l,
    defer: f,
    document: d = Me,
    attrs: y = {}
  } = n, v = O(null);
  let p = null;
  const S = (b) => new Promise((h, m) => {
    const P = (N) => (v.value = N, h(N), N);
    if (!d) {
      h(!1);
      return;
    }
    let x = !1, A = d.querySelector(`script[src="${T(e)}"]`);
    A ? A.hasAttribute("data-loaded") && P(A) : (A = d.createElement("script"), A.type = i, A.async = a, A.src = T(e), f && (A.defer = f), s && (A.crossOrigin = s), l && (A.noModule = l), u && (A.referrerPolicy = u), Object.entries(y).forEach(([N, D]) => A == null ? void 0 : A.setAttribute(N, D)), x = !0), A.addEventListener("error", (N) => m(N)), A.addEventListener("abort", (N) => m(N)), A.addEventListener("load", () => {
      A.setAttribute("data-loaded", "true"), t(A), P(A);
    }), x && (A = d.head.appendChild(A)), b || P(A);
  }), _ = (b = !0) => (p || (p = S(b)), p), g = () => {
    if (!d)
      return;
    p = null, v.value && (v.value = null);
    const b = d.querySelector(`script[src="${T(e)}"]`);
    b && d.head.removeChild(b);
  };
  return r && !o && me(_), o || Fu(g), { scriptTag: v, load: _, unload: g };
}
function rs(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : rs(n);
  }
}
function Fl(e) {
  const t = e || window.event, n = t.target;
  return rs(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const lr = /* @__PURE__ */ new WeakMap();
function Ny(e, t = !1) {
  const n = O(t);
  let r = null, o;
  I(ve(e), (s) => {
    const u = hr(T(s));
    if (u) {
      const l = u;
      lr.get(l) || lr.set(l, o), n.value && (l.style.overflow = "hidden");
    }
  }, {
    immediate: !0
  });
  const i = () => {
    const s = hr(T(e));
    !s || n.value || (oi && (r = R(
      s,
      "touchmove",
      (u) => {
        Fl(u);
      },
      { passive: !1 }
    )), s.style.overflow = "hidden", n.value = !0);
  }, a = () => {
    var s;
    const u = hr(T(e));
    !u || !n.value || (oi && (r == null || r()), u.style.overflow = (s = lr.get(u)) != null ? s : "", lr.delete(u), n.value = !1);
  };
  return V(a), C({
    get() {
      return n.value;
    },
    set(s) {
      s ? i() : a();
    }
  });
}
function Ly(e, t, n = {}) {
  const { window: r = U } = n;
  return Oi(e, t, r == null ? void 0 : r.sessionStorage, n);
}
function Iy(e = {}, t = {}) {
  const { navigator: n = Ce } = t, r = n, o = $(() => r && "canShare" in r);
  return {
    isSupported: o,
    share: async (a = {}) => {
      if (o.value) {
        const s = {
          ...T(e),
          ...T(a)
        };
        let u = !0;
        if (s.files && r.canShare && (u = r.canShare({ files: s.files })), u)
          return r.share(s);
      }
    }
  };
}
const Ul = (e, t) => e.sort(t), cr = (e, t) => e - t;
function Fy(...e) {
  var t, n, r, o;
  const [i] = e;
  let a = cr, s = {};
  e.length === 2 ? typeof e[1] == "object" ? (s = e[1], a = (t = s.compareFn) != null ? t : cr) : a = (n = e[1]) != null ? n : cr : e.length > 2 && (a = (r = e[1]) != null ? r : cr, s = (o = e[2]) != null ? o : {});
  const {
    dirty: u = !1,
    sortFn: l = Ul
  } = s;
  return u ? (Xt(() => {
    const f = l(T(i), a);
    Pe(i) ? i.value = f : i.splice(0, i.length, ...f);
  }), i) : C(() => l([...T(i)], a));
}
function Uy(e = {}) {
  const {
    interimResults: t = !0,
    continuous: n = !0,
    window: r = U
  } = e, o = ve(e.lang || "en-US"), i = O(!1), a = O(!1), s = O(""), u = oe(void 0), l = (S = !i.value) => {
    i.value = S;
  }, f = () => {
    i.value = !0;
  }, d = () => {
    i.value = !1;
  }, y = r && (r.SpeechRecognition || r.webkitSpeechRecognition), v = $(() => y);
  let p;
  return v.value && (p = new y(), p.continuous = n, p.interimResults = t, p.lang = T(o), p.onstart = () => {
    a.value = !1;
  }, I(o, (S) => {
    p && !i.value && (p.lang = S);
  }), p.onresult = (S) => {
    const _ = Array.from(S.results).map((g) => (a.value = g.isFinal, g[0])).map((g) => g.transcript).join("");
    s.value = _, u.value = void 0;
  }, p.onerror = (S) => {
    u.value = S;
  }, p.onend = () => {
    i.value = !1, p.lang = T(o);
  }, I(i, () => {
    i.value ? p.start() : p.stop();
  })), V(() => {
    i.value = !1;
  }), {
    isSupported: v,
    isListening: i,
    isFinal: a,
    recognition: p,
    result: s,
    error: u,
    toggle: l,
    start: f,
    stop: d
  };
}
function zy(e, t = {}) {
  const {
    pitch: n = 1,
    rate: r = 1,
    volume: o = 1,
    window: i = U
  } = t, a = i && i.speechSynthesis, s = $(() => a), u = O(!1), l = O("init"), f = ve(e || ""), d = ve(t.lang || "en-US"), y = oe(void 0), v = (b = !u.value) => {
    u.value = b;
  }, p = (b) => {
    b.lang = T(d), b.voice = T(t.voice) || null, b.pitch = T(n), b.rate = T(r), b.volume = o, b.onstart = () => {
      u.value = !0, l.value = "play";
    }, b.onpause = () => {
      u.value = !1, l.value = "pause";
    }, b.onresume = () => {
      u.value = !0, l.value = "play";
    }, b.onend = () => {
      u.value = !1, l.value = "end";
    }, b.onerror = (h) => {
      y.value = h;
    };
  }, S = C(() => {
    u.value = !1, l.value = "init";
    const b = new SpeechSynthesisUtterance(f.value);
    return p(b), b;
  }), _ = () => {
    a.cancel(), S && a.speak(S.value);
  }, g = () => {
    a.cancel(), u.value = !1;
  };
  return s.value && (p(S.value), I(d, (b) => {
    S.value && !u.value && (S.value.lang = b);
  }), t.voice && I(t.voice, () => {
    a.cancel();
  }), I(u, () => {
    u.value ? a.resume() : a.pause();
  })), V(() => {
    u.value = !1;
  }), {
    isSupported: s,
    isPlaying: u,
    status: l,
    utterance: S,
    error: y,
    stop: g,
    toggle: v,
    speak: _
  };
}
function Ky(e, t) {
  const n = O(e), r = C(() => Array.isArray(n.value) ? n.value : Object.keys(n.value)), o = O(r.value.indexOf(t ?? r.value[0])), i = C(() => f(o.value)), a = C(() => o.value === 0), s = C(() => o.value === r.value.length - 1), u = C(() => r.value[o.value + 1]), l = C(() => r.value[o.value - 1]);
  function f(P) {
    return Array.isArray(n.value) ? n.value[P] : n.value[r.value[P]];
  }
  function d(P) {
    if (r.value.includes(P))
      return f(r.value.indexOf(P));
  }
  function y(P) {
    r.value.includes(P) && (o.value = r.value.indexOf(P));
  }
  function v() {
    s.value || o.value++;
  }
  function p() {
    a.value || o.value--;
  }
  function S(P) {
    m(P) && y(P);
  }
  function _(P) {
    return r.value.indexOf(P) === o.value + 1;
  }
  function g(P) {
    return r.value.indexOf(P) === o.value - 1;
  }
  function b(P) {
    return r.value.indexOf(P) === o.value;
  }
  function h(P) {
    return o.value < r.value.indexOf(P);
  }
  function m(P) {
    return o.value > r.value.indexOf(P);
  }
  return {
    steps: n,
    stepNames: r,
    index: o,
    current: i,
    next: u,
    previous: l,
    isFirst: a,
    isLast: s,
    at: f,
    get: d,
    goTo: y,
    goToNext: v,
    goToPrevious: p,
    goBackTo: S,
    isNext: _,
    isPrevious: g,
    isCurrent: b,
    isBefore: h,
    isAfter: m
  };
}
function Gy(e, t, n, r = {}) {
  var o;
  const {
    flush: i = "pre",
    deep: a = !0,
    listenToStorageChanges: s = !0,
    writeDefaults: u = !0,
    mergeDefaults: l = !1,
    shallow: f,
    window: d = U,
    eventFilter: y,
    onError: v = (h) => {
      console.error(h);
    }
  } = r, p = T(t), S = Ya(p), _ = (f ? oe : O)(t), g = (o = r.serializer) != null ? o : $a[S];
  if (!n)
    try {
      n = _i("getDefaultStorage", () => {
        var h;
        return (h = U) == null ? void 0 : h.localStorage;
      })();
    } catch (h) {
      v(h);
    }
  async function b(h) {
    if (!(!n || h && h.key !== e))
      try {
        const m = h ? h.newValue : await n.getItem(e);
        if (m == null)
          _.value = p, u && p !== null && await n.setItem(e, await g.write(p));
        else if (l) {
          const P = await g.read(m);
          typeof l == "function" ? _.value = l(P, p) : S === "object" && !Array.isArray(P) ? _.value = { ...p, ...P } : _.value = P;
        } else
          _.value = await g.read(m);
      } catch (m) {
        v(m);
      }
  }
  return b(), d && s && R(d, "storage", (h) => Promise.resolve().then(() => b(h))), n && kn(
    _,
    async () => {
      try {
        _.value == null ? await n.removeItem(e) : await n.setItem(e, await g.write(_.value));
      } catch (h) {
        v(h);
      }
    },
    {
      flush: i,
      deep: a,
      eventFilter: y
    }
  ), _;
}
let zl = 0;
function Zy(e, t = {}) {
  const n = O(!1), {
    document: r = Me,
    immediate: o = !0,
    manual: i = !1,
    id: a = `vueuse_styletag_${++zl}`
  } = t, s = O(e);
  let u = () => {
  };
  const l = () => {
    if (!r)
      return;
    const d = r.getElementById(a) || r.createElement("style");
    d.isConnected || (d.id = a, t.media && (d.media = t.media), r.head.appendChild(d)), !n.value && (u = I(
      s,
      (y) => {
        d.textContent = y;
      },
      { immediate: !0 }
    ), n.value = !0);
  }, f = () => {
    !r || !n.value || (u(), r.head.removeChild(r.getElementById(a)), n.value = !1);
  };
  return o && !i && me(l), i || V(f), {
    id: a,
    css: s,
    unload: f,
    load: l,
    isLoaded: je(n)
  };
}
function Xy(e, t = {}) {
  const {
    threshold: n = 50,
    onSwipe: r,
    onSwipeEnd: o,
    onSwipeStart: i,
    passive: a = !0,
    window: s = U
  } = t, u = ae({ x: 0, y: 0 }), l = ae({ x: 0, y: 0 }), f = C(() => u.x - l.x), d = C(() => u.y - l.y), { max: y, abs: v } = Math, p = C(() => y(v(f.value), v(d.value)) >= n), S = O(!1), _ = C(() => p.value ? v(f.value) > v(d.value) ? f.value > 0 ? "left" : "right" : d.value > 0 ? "up" : "down" : "none"), g = (D) => [D.touches[0].clientX, D.touches[0].clientY], b = (D, M) => {
    u.x = D, u.y = M;
  }, h = (D, M) => {
    l.x = D, l.y = M;
  };
  let m;
  const P = Kl(s == null ? void 0 : s.document);
  a ? m = P ? { passive: !0 } : { capture: !1 } : m = P ? { passive: !1, capture: !0 } : { capture: !0 };
  const x = (D) => {
    S.value && (o == null || o(D, _.value)), S.value = !1;
  }, A = [
    R(e, "touchstart", (D) => {
      if (D.touches.length !== 1)
        return;
      m.capture && !m.passive && D.preventDefault();
      const [M, L] = g(D);
      b(M, L), h(M, L), i == null || i(D);
    }, m),
    R(e, "touchmove", (D) => {
      if (D.touches.length !== 1)
        return;
      const [M, L] = g(D);
      h(M, L), !S.value && p.value && (S.value = !0), S.value && (r == null || r(D));
    }, m),
    R(e, ["touchend", "touchcancel"], x, m)
  ];
  return {
    isPassiveEventSupported: P,
    isSwiping: S,
    direction: _,
    coordsStart: u,
    coordsEnd: l,
    lengthX: f,
    lengthY: d,
    stop: () => A.forEach((D) => D())
  };
}
function Kl(e) {
  if (!e)
    return !1;
  let t = !1;
  const n = {
    get passive() {
      return t = !0, !1;
    }
  };
  return e.addEventListener("x", re, n), e.removeEventListener("x", re), t;
}
function Hy() {
  const e = O([]);
  return e.value.set = (t) => {
    t && e.value.push(t);
  }, pu(() => {
    e.value.length = 0;
  }), e;
}
function By(e = {}) {
  const {
    document: t = Me,
    selector: n = "html",
    observe: r = !1,
    initialValue: o = "ltr"
  } = e;
  function i() {
    var s, u;
    return (u = (s = t == null ? void 0 : t.querySelector(n)) == null ? void 0 : s.getAttribute("dir")) != null ? u : o;
  }
  const a = O(i());
  return me(() => a.value = i()), r && t && Ei(
    t.querySelector(n),
    () => a.value = i(),
    { attributes: !0 }
  ), C({
    get() {
      return a.value;
    },
    set(s) {
      var u, l;
      a.value = s, t && (a.value ? (u = t.querySelector(n)) == null || u.setAttribute("dir", a.value) : (l = t.querySelector(n)) == null || l.removeAttribute("dir"));
    }
  });
}
function Gl(e) {
  var t;
  const n = (t = e.rangeCount) != null ? t : 0;
  return Array.from({ length: n }, (r, o) => e.getRangeAt(o));
}
function Vy(e = {}) {
  const {
    window: t = U
  } = e, n = O(null), r = C(() => {
    var s, u;
    return (u = (s = n.value) == null ? void 0 : s.toString()) != null ? u : "";
  }), o = C(() => n.value ? Gl(n.value) : []), i = C(() => o.value.map((s) => s.getBoundingClientRect()));
  function a() {
    n.value = null, t && (n.value = t.getSelection());
  }
  return t && R(t.document, "selectionchange", a), {
    text: r,
    rects: i,
    ranges: o,
    selection: n
  };
}
function Wy(e) {
  const t = O(e == null ? void 0 : e.element), n = O(e == null ? void 0 : e.input), r = O(1);
  function o() {
    var i, a;
    if (!t.value)
      return;
    let s = "";
    t.value.style.height = "1px", r.value = (i = t.value) == null ? void 0 : i.scrollHeight, e != null && e.styleTarget ? T(e.styleTarget).style.height = `${r.value}px` : s = `${r.value}px`, t.value.style.height = s, (a = e == null ? void 0 : e.onResize) == null || a.call(e);
  }
  return I([n, t], () => Le(o), { immediate: !0 }), Ti(t, () => o()), e != null && e.watch && I(e.watch, o, { immediate: !0, deep: !0 }), {
    textarea: t,
    input: n,
    triggerResize: o
  };
}
function Jy(e, t = {}) {
  const { throttle: n = 200, trailing: r = !0 } = t, o = Rr(n, r);
  return {
    ...es(e, { ...t, eventFilter: o })
  };
}
const Zl = [
  { max: 6e4, value: 1e3, name: "second" },
  { max: 276e4, value: 6e4, name: "minute" },
  { max: 72e6, value: 36e5, name: "hour" },
  { max: 5184e5, value: 864e5, name: "day" },
  { max: 24192e5, value: 6048e5, name: "week" },
  { max: 28512e6, value: 2592e6, name: "month" },
  { max: Number.POSITIVE_INFINITY, value: 31536e6, name: "year" }
], Xl = {
  justNow: "just now",
  past: (e) => e.match(/\d/) ? `${e} ago` : e,
  future: (e) => e.match(/\d/) ? `in ${e}` : e,
  month: (e, t) => e === 1 ? t ? "last month" : "next month" : `${e} month${e > 1 ? "s" : ""}`,
  year: (e, t) => e === 1 ? t ? "last year" : "next year" : `${e} year${e > 1 ? "s" : ""}`,
  day: (e, t) => e === 1 ? t ? "yesterday" : "tomorrow" : `${e} day${e > 1 ? "s" : ""}`,
  week: (e, t) => e === 1 ? t ? "last week" : "next week" : `${e} week${e > 1 ? "s" : ""}`,
  hour: (e) => `${e} hour${e > 1 ? "s" : ""}`,
  minute: (e) => `${e} minute${e > 1 ? "s" : ""}`,
  second: (e) => `${e} second${e > 1 ? "s" : ""}`,
  invalid: ""
};
function Hl(e) {
  return e.toISOString().slice(0, 10);
}
function Yy(e, t = {}) {
  const {
    controls: n = !1,
    updateInterval: r = 3e4
  } = t, { now: o, ...i } = Ll({ interval: r, controls: !0 }), a = C(() => Bl(new Date(T(e)), t, T(o)));
  return n ? {
    timeAgo: a,
    ...i
  } : a;
}
function Bl(e, t = {}, n = Date.now()) {
  var r;
  const {
    max: o,
    messages: i = Xl,
    fullDateFormatter: a = Hl,
    units: s = Zl,
    showSecond: u = !1,
    rounding: l = "round"
  } = t, f = typeof l == "number" ? (_) => +_.toFixed(l) : Math[l], d = +n - +e, y = Math.abs(d);
  function v(_, g) {
    return f(Math.abs(_) / g.value);
  }
  function p(_, g) {
    const b = v(_, g), h = _ > 0, m = S(g.name, b, h);
    return S(h ? "past" : "future", m, h);
  }
  function S(_, g, b) {
    const h = i[_];
    return typeof h == "function" ? h(g, b) : h.replace("{0}", g.toString());
  }
  if (y < 6e4 && !u)
    return i.justNow;
  if (typeof o == "number" && y > o)
    return a(new Date(e));
  if (typeof o == "string") {
    const _ = (r = s.find((g) => g.name === o)) == null ? void 0 : r.max;
    if (_ && y > _)
      return a(new Date(e));
  }
  for (const [_, g] of s.entries()) {
    if (v(d, g) <= 0 && s[_ - 1])
      return p(d, s[_ - 1]);
    if (y < g.max)
      return p(d, g);
  }
  return i.invalid;
}
function $y(e, t, n) {
  const { start: r } = jn(i, t, { immediate: !1 }), o = O(!1);
  async function i() {
    o.value && (await e(), r());
  }
  function a() {
    o.value || (o.value = !0, i());
  }
  function s() {
    o.value = !1;
  }
  return n != null && n.immediate && a(), V(s), {
    isActive: o,
    pause: s,
    resume: a
  };
}
function Qy(e = {}) {
  const {
    controls: t = !1,
    offset: n = 0,
    immediate: r = !0,
    interval: o = "requestAnimationFrame",
    callback: i
  } = e, a = O(Ht() + n), s = () => a.value = Ht() + n, u = i ? () => {
    s(), i(a.value);
  } : s, l = o === "requestAnimationFrame" ? Wt(u, { immediate: r }) : St(u, o, { immediate: r });
  return t ? {
    timestamp: a,
    ...l
  } : a;
}
function qy(e = null, t = {}) {
  var n, r, o;
  const {
    document: i = Me,
    restoreOnUnmount: a = (d) => d
  } = t, s = (n = i == null ? void 0 : i.title) != null ? n : "", u = ve((r = e ?? (i == null ? void 0 : i.title)) != null ? r : null), l = e && typeof e == "function";
  function f(d) {
    if (!("titleTemplate" in t))
      return d;
    const y = t.titleTemplate || "%s";
    return typeof y == "function" ? y(d) : T(y).replace(/%s/g, d);
  }
  return I(
    u,
    (d, y) => {
      d !== y && i && (i.title = f(typeof d == "string" ? d : ""));
    },
    { immediate: !0 }
  ), t.observe && !t.titleTemplate && i && !l && Ei(
    (o = i.head) == null ? void 0 : o.querySelector("title"),
    () => {
      i && i.title !== u.value && (u.value = f(i.title));
    },
    { childList: !0 }
  ), Iu(() => {
    if (a) {
      const d = a(s, u.value || "");
      d != null && i && (i.title = d);
    }
  }), u;
}
const Vl = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
}, e0 = /* @__PURE__ */ Object.assign({}, { linear: Ha }, Vl);
function Wl([e, t, n, r]) {
  const o = (f, d) => 1 - 3 * d + 3 * f, i = (f, d) => 3 * d - 6 * f, a = (f) => 3 * f, s = (f, d, y) => ((o(d, y) * f + i(d, y)) * f + a(d)) * f, u = (f, d, y) => 3 * o(d, y) * f * f + 2 * i(d, y) * f + a(d), l = (f) => {
    let d = f;
    for (let y = 0; y < 4; ++y) {
      const v = u(d, e, n);
      if (v === 0)
        return d;
      const p = s(d, e, n) - f;
      d -= p / v;
    }
    return d;
  };
  return (f) => e === t && n === r ? f : s(l(f), t, r);
}
function $i(e, t, n) {
  return e + n * (t - e);
}
function Fo(e) {
  return (typeof e == "number" ? [e] : e) || [];
}
function Jl(e, t, n, r = {}) {
  var o, i;
  const a = T(t), s = T(n), u = Fo(a), l = Fo(s), f = (o = T(r.duration)) != null ? o : 1e3, d = Date.now(), y = Date.now() + f, v = typeof r.transition == "function" ? r.transition : (i = T(r.transition)) != null ? i : Ha, p = typeof v == "function" ? v : Wl(v);
  return new Promise((S) => {
    e.value = a;
    const _ = () => {
      var g;
      if ((g = r.abort) != null && g.call(r)) {
        S();
        return;
      }
      const b = Date.now(), h = p((b - d) / f), m = Fo(e.value).map((P, x) => $i(u[x], l[x], h));
      Array.isArray(e.value) ? e.value = m.map((P, x) => {
        var A, N;
        return $i((A = u[x]) != null ? A : 0, (N = l[x]) != null ? N : 0, h);
      }) : typeof e.value == "number" && (e.value = m[0]), b < y ? requestAnimationFrame(_) : (e.value = s, S());
    };
    _();
  });
}
function t0(e, t = {}) {
  let n = 0;
  const r = () => {
    const i = T(e);
    return typeof i == "number" ? i : i.map(T);
  }, o = O(r());
  return I(r, async (i) => {
    var a, s;
    if (T(t.disabled))
      return;
    const u = ++n;
    if (t.delay && await Sr(T(t.delay)), u !== n)
      return;
    const l = Array.isArray(i) ? i.map(T) : T(i);
    (a = t.onStarted) == null || a.call(t), await Jl(o, o.value, l, {
      ...t,
      abort: () => {
        var f;
        return u !== n || ((f = t.abort) == null ? void 0 : f.call(t));
      }
    }), (s = t.onFinished) == null || s.call(t);
  }, { deep: !0 }), I(() => T(t.disabled), (i) => {
    i && (n++, o.value = r());
  }), V(() => {
    n++;
  }), C(() => T(t.disabled) ? r() : o.value);
}
function n0(e = "history", t = {}) {
  const {
    initialValue: n = {},
    removeNullishValues: r = !0,
    removeFalsyValues: o = !1,
    write: i = !0,
    window: a = U
  } = t;
  if (!a)
    return ae(n);
  const s = ae({});
  function u() {
    if (e === "history")
      return a.location.search || "";
    if (e === "hash") {
      const g = a.location.hash || "", b = g.indexOf("?");
      return b > 0 ? g.slice(b) : "";
    } else
      return (a.location.hash || "").replace(/^#/, "");
  }
  function l(g) {
    const b = g.toString();
    if (e === "history")
      return `${b ? `?${b}` : ""}${a.location.hash || ""}`;
    if (e === "hash-params")
      return `${a.location.search || ""}${b ? `#${b}` : ""}`;
    const h = a.location.hash || "#", m = h.indexOf("?");
    return m > 0 ? `${h.slice(0, m)}${b ? `?${b}` : ""}` : `${h}${b ? `?${b}` : ""}`;
  }
  function f() {
    return new URLSearchParams(u());
  }
  function d(g) {
    const b = new Set(Object.keys(s));
    for (const h of g.keys()) {
      const m = g.getAll(h);
      s[h] = m.length > 1 ? m : g.get(h) || "", b.delete(h);
    }
    Array.from(b).forEach((h) => delete s[h]);
  }
  const { pause: y, resume: v } = Pr(
    s,
    () => {
      const g = new URLSearchParams("");
      Object.keys(s).forEach((b) => {
        const h = s[b];
        Array.isArray(h) ? h.forEach((m) => g.append(b, m)) : r && h == null || o && !h ? g.delete(b) : g.set(b, h);
      }), p(g);
    },
    { deep: !0 }
  );
  function p(g, b) {
    y(), b && d(g), a.history.replaceState(
      a.history.state,
      a.document.title,
      a.location.pathname + l(g)
    ), v();
  }
  function S() {
    i && p(f(), !0);
  }
  R(a, "popstate", S, !1), e !== "history" && R(a, "hashchange", S, !1);
  const _ = f();
  return _.keys().next().value ? d(_) : Object.assign(s, n), s;
}
function r0(e = {}) {
  var t, n;
  const r = O((t = e.enabled) != null ? t : !1), o = O((n = e.autoSwitch) != null ? n : !0), i = O(e.constraints), { navigator: a = Ce } = e, s = $(() => {
    var S;
    return (S = a == null ? void 0 : a.mediaDevices) == null ? void 0 : S.getUserMedia;
  }), u = oe();
  function l(S) {
    switch (S) {
      case "video": {
        if (i.value)
          return i.value.video || !1;
        break;
      }
      case "audio": {
        if (i.value)
          return i.value.audio || !1;
        break;
      }
    }
  }
  async function f() {
    if (!(!s.value || u.value))
      return u.value = await a.mediaDevices.getUserMedia({
        video: l("video"),
        audio: l("audio")
      }), u.value;
  }
  function d() {
    var S;
    (S = u.value) == null || S.getTracks().forEach((_) => _.stop()), u.value = void 0;
  }
  function y() {
    d(), r.value = !1;
  }
  async function v() {
    return await f(), u.value && (r.value = !0), u.value;
  }
  async function p() {
    return d(), await v();
  }
  return I(
    r,
    (S) => {
      S ? f() : d();
    },
    { immediate: !0 }
  ), I(
    i,
    () => {
      o.value && u.value && p();
    },
    { immediate: !0 }
  ), {
    isSupported: s,
    stream: u,
    start: v,
    stop: y,
    restart: p,
    constraints: i,
    enabled: r,
    autoSwitch: o
  };
}
function Yl(e, t, n, r = {}) {
  var o, i, a;
  const {
    clone: s = !1,
    passive: u = !1,
    eventName: l,
    deep: f = !1,
    defaultValue: d,
    shouldEmit: y
  } = r, v = wt(), p = n || (v == null ? void 0 : v.emit) || ((o = v == null ? void 0 : v.$emit) == null ? void 0 : o.bind(v)) || ((a = (i = v == null ? void 0 : v.proxy) == null ? void 0 : i.$emit) == null ? void 0 : a.bind(v == null ? void 0 : v.proxy));
  let S = l;
  t || (t = "modelValue"), S = S || `update:${t.toString()}`;
  const _ = (h) => s ? typeof s == "function" ? s(h) : Lr(h) : h, g = () => _u(e[t]) ? _(e[t]) : d, b = (h) => {
    y ? y(h) && p(S, h) : p(S, h);
  };
  if (u) {
    const h = g(), m = O(h);
    let P = !1;
    return I(
      () => e[t],
      (x) => {
        P || (P = !0, m.value = _(x), Le(() => P = !1));
      }
    ), I(
      m,
      (x) => {
        !P && (x !== e[t] || f) && b(x);
      },
      { deep: f }
    ), m;
  } else
    return C({
      get() {
        return g();
      },
      set(h) {
        b(h);
      }
    });
}
function o0(e, t, n = {}) {
  const r = {};
  for (const o in e)
    r[o] = Yl(
      e,
      o,
      t,
      n
    );
  return r;
}
function i0(e) {
  const {
    pattern: t = [],
    interval: n = 0,
    navigator: r = Ce
  } = e || {}, o = $(() => typeof r < "u" && "vibrate" in r), i = ve(t);
  let a;
  const s = (l = i.value) => {
    o.value && r.vibrate(l);
  }, u = () => {
    o.value && r.vibrate(0), a == null || a.pause();
  };
  return n > 0 && (a = St(
    s,
    n,
    {
      immediate: !1,
      immediateCallback: !1
    }
  )), {
    isSupported: o,
    pattern: t,
    intervalControls: a,
    vibrate: s,
    stop: u
  };
}
function a0(e, t) {
  const { containerStyle: n, wrapperProps: r, scrollTo: o, calculateRange: i, currentList: a, containerRef: s } = "itemHeight" in t ? ql(t, e) : Ql(t, e);
  return {
    list: a,
    scrollTo: o,
    containerProps: {
      ref: s,
      onScroll: () => {
        i();
      },
      style: n
    },
    wrapperProps: r
  };
}
function os(e) {
  const t = O(null), n = ts(t), r = O([]), o = oe(e);
  return { state: O({ start: 0, end: 10 }), source: o, currentList: r, size: n, containerRef: t };
}
function is(e, t, n) {
  return (r) => {
    if (typeof n == "number")
      return Math.ceil(r / n);
    const { start: o = 0 } = e.value;
    let i = 0, a = 0;
    for (let s = o; s < t.value.length; s++) {
      const u = n(s);
      if (i += u, a = s, i > r)
        break;
    }
    return a - o;
  };
}
function as(e, t) {
  return (n) => {
    if (typeof t == "number")
      return Math.floor(n / t) + 1;
    let r = 0, o = 0;
    for (let i = 0; i < e.value.length; i++) {
      const a = t(i);
      if (r += a, r >= n) {
        o = i;
        break;
      }
    }
    return o + 1;
  };
}
function ss(e, t, n, r, { containerRef: o, state: i, currentList: a, source: s }) {
  return () => {
    const u = o.value;
    if (u) {
      const l = n(e === "vertical" ? u.scrollTop : u.scrollLeft), f = r(e === "vertical" ? u.clientHeight : u.clientWidth), d = l - t, y = l + f + t;
      i.value = {
        start: d < 0 ? 0 : d,
        end: y > s.value.length ? s.value.length : y
      }, a.value = s.value.slice(i.value.start, i.value.end).map((v, p) => ({
        data: v,
        index: p + i.value.start
      }));
    }
  };
}
function us(e, t) {
  return (n) => typeof e == "number" ? n * e : t.value.slice(0, n).reduce((o, i, a) => o + e(a), 0);
}
function ls(e, t, n) {
  I([e.width, e.height, t], () => {
    n();
  });
}
function cs(e, t) {
  return C(() => typeof e == "number" ? t.value.length * e : t.value.reduce((n, r, o) => n + e(o), 0));
}
const $l = {
  horizontal: "scrollLeft",
  vertical: "scrollTop"
};
function fs(e, t, n, r) {
  return (o) => {
    r.value && (r.value[$l[e]] = n(o), t());
  };
}
function Ql(e, t) {
  const n = os(t), { state: r, source: o, currentList: i, size: a, containerRef: s } = n, u = { overflowX: "auto" }, { itemWidth: l, overscan: f = 5 } = e, d = is(r, o, l), y = as(o, l), v = ss("horizontal", f, y, d, n), p = us(l, o), S = C(() => p(r.value.start)), _ = cs(l, o);
  ls(a, t, v);
  const g = fs("horizontal", v, p, s), b = C(() => ({
    style: {
      height: "100%",
      width: `${_.value - S.value}px`,
      marginLeft: `${S.value}px`,
      display: "flex"
    }
  }));
  return {
    scrollTo: g,
    calculateRange: v,
    wrapperProps: b,
    containerStyle: u,
    currentList: i,
    containerRef: s
  };
}
function ql(e, t) {
  const n = os(t), { state: r, source: o, currentList: i, size: a, containerRef: s } = n, u = { overflowY: "auto" }, { itemHeight: l, overscan: f = 5 } = e, d = is(r, o, l), y = as(o, l), v = ss("vertical", f, y, d, n), p = us(l, o), S = C(() => p(r.value.start)), _ = cs(l, o);
  ls(a, t, v);
  const g = fs("vertical", v, p, s), b = C(() => ({
    style: {
      width: "100%",
      height: `${_.value - S.value}px`,
      marginTop: `${S.value}px`
    }
  }));
  return {
    calculateRange: v,
    scrollTo: g,
    containerStyle: u,
    wrapperProps: b,
    currentList: i,
    containerRef: s
  };
}
function s0(e = {}) {
  const {
    navigator: t = Ce,
    document: n = Me
  } = e;
  let r;
  const o = $(() => t && "wakeLock" in t), i = O(!1);
  async function a() {
    !o.value || !r || (n && n.visibilityState === "visible" && (r = await t.wakeLock.request("screen")), i.value = !r.released);
  }
  n && R(n, "visibilitychange", a, { passive: !0 });
  async function s(l) {
    o.value && (r = await t.wakeLock.request(l), i.value = !r.released);
  }
  async function u() {
    !o.value || !r || (await r.release(), i.value = !r.released, r = null);
  }
  return {
    isSupported: o,
    isActive: i,
    request: s,
    release: u
  };
}
function u0(e = {}) {
  const {
    window: t = U,
    requestPermissions: n = !0
  } = e, r = e, o = $(() => !!t && "Notification" in t), i = O(o.value && "permission" in Notification && Notification.permission === "granted"), a = O(null), s = async () => {
    if (o.value)
      return !i.value && Notification.permission !== "denied" && await Notification.requestPermission() === "granted" && (i.value = !0), i.value;
  }, { on: u, trigger: l } = Te(), { on: f, trigger: d } = Te(), { on: y, trigger: v } = Te(), { on: p, trigger: S } = Te(), _ = async (b) => {
    if (!o.value || !i.value)
      return;
    const h = Object.assign({}, r, b);
    return a.value = new Notification(h.title || "", h), a.value.onclick = l, a.value.onshow = d, a.value.onerror = v, a.value.onclose = S, a.value;
  }, g = () => {
    a.value && a.value.close(), a.value = null;
  };
  if (n && me(s), V(g), o.value && t) {
    const b = t.document;
    R(b, "visibilitychange", (h) => {
      h.preventDefault(), b.visibilityState === "visible" && g();
    });
  }
  return {
    isSupported: o,
    notification: a,
    ensurePermissions: s,
    permissionGranted: i,
    show: _,
    close: g,
    onClick: u,
    onShow: f,
    onError: y,
    onClose: p
  };
}
const Qi = "ping";
function Uo(e) {
  return e === !0 ? {} : e;
}
function l0(e, t = {}) {
  const {
    onConnected: n,
    onDisconnected: r,
    onError: o,
    onMessage: i,
    immediate: a = !0,
    autoClose: s = !0,
    protocols: u = []
  } = t, l = O(null), f = O("CLOSED"), d = O(), y = ve(e);
  let v, p, S = !1, _ = 0, g = [], b;
  const h = () => {
    if (g.length && d.value && f.value === "OPEN") {
      for (const D of g)
        d.value.send(D);
      g = [];
    }
  }, m = () => {
    clearTimeout(b), b = void 0;
  }, P = (D = 1e3, M) => {
    !xe || !d.value || (S = !0, m(), v == null || v(), d.value.close(D, M));
  }, x = (D, M = !0) => !d.value || f.value !== "OPEN" ? (M && g.push(D), !1) : (h(), d.value.send(D), !0), A = () => {
    if (S || typeof y.value > "u")
      return;
    const D = new WebSocket(y.value, u);
    d.value = D, f.value = "CONNECTING", D.onopen = () => {
      f.value = "OPEN", n == null || n(D), p == null || p(), h();
    }, D.onclose = (M) => {
      if (f.value = "CLOSED", d.value = void 0, r == null || r(D, M), !S && t.autoReconnect) {
        const {
          retries: L = -1,
          delay: K = 1e3,
          onFailed: X
        } = Uo(t.autoReconnect);
        _ += 1, typeof L == "number" && (L < 0 || _ < L) || typeof L == "function" && L() ? setTimeout(A, K) : X == null || X();
      }
    }, D.onerror = (M) => {
      o == null || o(D, M);
    }, D.onmessage = (M) => {
      if (t.heartbeat) {
        m();
        const {
          message: L = Qi
        } = Uo(t.heartbeat);
        if (M.data === L)
          return;
      }
      l.value = M.data, i == null || i(D, M);
    };
  };
  if (t.heartbeat) {
    const {
      message: D = Qi,
      interval: M = 1e3,
      pongTimeout: L = 1e3
    } = Uo(t.heartbeat), { pause: K, resume: X } = St(
      () => {
        x(D, !1), b == null && (b = setTimeout(() => {
          P(), S = !1;
        }, L));
      },
      M,
      { immediate: !1 }
    );
    v = K, p = X;
  }
  s && (xe && R("beforeunload", () => P()), V(P));
  const N = () => {
    !xe && !xu || (P(), S = !1, _ = 0, A());
  };
  return a && I(y, N, { immediate: !0 }), {
    data: l,
    status: f,
    close: P,
    send: x,
    open: N,
    ws: d
  };
}
function c0(e, t, n) {
  const {
    window: r = U
  } = n ?? {}, o = O(null), i = oe(), a = (...u) => {
    i.value && i.value.postMessage(...u);
  }, s = function() {
    i.value && i.value.terminate();
  };
  return r && (typeof e == "string" ? i.value = new Worker(e, t) : typeof e == "function" ? i.value = e() : i.value = e, i.value.onmessage = (u) => {
    o.value = u.data;
  }, V(() => {
    i.value && i.value.terminate();
  })), {
    data: o,
    post: a,
    terminate: s,
    worker: i
  };
}
function ec(e) {
  return (t) => {
    const n = t.data[0];
    return Promise.resolve(e.apply(void 0, n)).then((r) => {
      postMessage(["SUCCESS", r]);
    }).catch((r) => {
      postMessage(["ERROR", r]);
    });
  };
}
function tc(e) {
  return e.length === 0 ? "" : `importScripts(${e.map((n) => `'${n}'`).toString()})`;
}
function nc(e, t) {
  const n = `${tc(t)}; onmessage=(${ec})(${e})`, r = new Blob([n], { type: "text/javascript" });
  return URL.createObjectURL(r);
}
function f0(e, t = {}) {
  const {
    dependencies: n = [],
    timeout: r,
    window: o = U
  } = t, i = O(), a = O("PENDING"), s = O({}), u = O(), l = (v = "PENDING") => {
    i.value && i.value._url && o && (i.value.terminate(), URL.revokeObjectURL(i.value._url), s.value = {}, i.value = void 0, o.clearTimeout(u.value), a.value = v);
  };
  l(), V(l);
  const f = () => {
    const v = nc(e, n), p = new Worker(v);
    return p._url = v, p.onmessage = (S) => {
      const { resolve: _ = () => {
      }, reject: g = () => {
      } } = s.value, [b, h] = S.data;
      switch (b) {
        case "SUCCESS":
          _(h), l(b);
          break;
        default:
          g(h), l("ERROR");
          break;
      }
    }, p.onerror = (S) => {
      const { reject: _ = () => {
      } } = s.value;
      S.preventDefault(), _(S), l("ERROR");
    }, r && (u.value = setTimeout(
      () => l("TIMEOUT_EXPIRED"),
      r
    )), p;
  }, d = (...v) => new Promise((p, S) => {
    s.value = {
      resolve: p,
      reject: S
    }, i.value && i.value.postMessage([[...v]]), a.value = "RUNNING";
  });
  return {
    workerFn: (...v) => a.value === "RUNNING" ? (console.error(
      "[useWebWorkerFn] You can only run one instance of the worker at a time."
    ), Promise.reject()) : (i.value = f(), d(...v)),
    workerStatus: a,
    workerTerminate: l
  };
}
function d0(e = {}) {
  const { window: t = U } = e;
  if (!t)
    return O(!1);
  const n = O(t.document.hasFocus());
  return R(t, "blur", () => {
    n.value = !1;
  }), R(t, "focus", () => {
    n.value = !0;
  }), n;
}
function p0(e = {}) {
  const { window: t = U, behavior: n = "auto" } = e;
  if (!t)
    return {
      x: O(0),
      y: O(0)
    };
  const r = O(t.scrollX), o = O(t.scrollY), i = C({
    get() {
      return r.value;
    },
    set(s) {
      scrollTo({ left: s, behavior: n });
    }
  }), a = C({
    get() {
      return o.value;
    },
    set(s) {
      scrollTo({ top: s, behavior: n });
    }
  });
  return R(
    t,
    "scroll",
    () => {
      r.value = t.scrollX, o.value = t.scrollY;
    },
    {
      capture: !1,
      passive: !0
    }
  ), { x: i, y: a };
}
function rc(e = {}) {
  const {
    window: t = U,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: r = Number.POSITIVE_INFINITY,
    listenOrientation: o = !0,
    includeScrollbar: i = !0
  } = e, a = O(n), s = O(r), u = () => {
    t && (i ? (a.value = t.innerWidth, s.value = t.innerHeight) : (a.value = t.document.documentElement.clientWidth, s.value = t.document.documentElement.clientHeight));
  };
  if (u(), me(u), R("resize", u, { passive: !0 }), o) {
    const l = ke("(orientation: portrait)");
    I(l, () => u());
  }
  return { width: a, height: s };
}
let pt;
function h0(e, {
  mode: t = "replace",
  route: n = bi(),
  router: r = wi()
} = {}) {
  pt = n.hash, V(() => {
    pt = void 0;
  });
  let o;
  const i = et((a, s) => (o = s, {
    get() {
      return a(), pt || T(e);
    },
    set(u) {
      u !== pt && (pt = u === null ? void 0 : u, s(), Le(() => {
        const { params: l, query: f } = n;
        r[T(t)]({ params: l, query: f, hash: pt });
      }));
    }
  }));
  return I(
    () => n.hash,
    () => {
      pt = n.hash, o();
    },
    { flush: "sync" }
  ), i;
}
const zo = /* @__PURE__ */ new WeakMap();
function v0(e, t, n = {}) {
  const {
    mode: r = "replace",
    route: o = bi(),
    router: i = wi(),
    transform: a = (d) => d
  } = n;
  zo.has(i) || zo.set(i, /* @__PURE__ */ new Map());
  const s = zo.get(i);
  let u = o.params[e];
  V(() => {
    u = void 0;
  });
  let l;
  const f = et((d, y) => (l = y, {
    get() {
      return d(), a(u !== void 0 ? u : T(t));
    },
    set(v) {
      u !== v && (u = v, s.set(e, v), y(), Le(() => {
        if (s.size === 0)
          return;
        const p = Object.fromEntries(s.entries());
        s.clear();
        const { params: S, query: _, hash: g } = o;
        i[T(r)]({
          params: {
            ...S,
            ...p
          },
          query: _,
          hash: g
        });
      }));
    }
  }));
  return I(
    () => o.params[e],
    (d) => {
      u = d, l();
    },
    { flush: "sync" }
  ), f;
}
const Ko = /* @__PURE__ */ new WeakMap();
function m0(e, t, n = {}) {
  const {
    mode: r = "replace",
    route: o = bi(),
    router: i = wi(),
    transform: a = (d) => d
  } = n;
  Ko.has(i) || Ko.set(i, /* @__PURE__ */ new Map());
  const s = Ko.get(i);
  let u = o.query[e];
  V(() => {
    u = void 0;
  });
  let l;
  const f = et((d, y) => (l = y, {
    get() {
      return d(), a(u !== void 0 ? u : T(t));
    },
    set(v) {
      u !== v && (u = v, s.set(e, v), y(), Le(() => {
        if (s.size === 0)
          return;
        const p = Object.fromEntries(s.entries());
        s.clear();
        const { params: S, query: _, hash: g } = o;
        i[T(r)]({
          params: S,
          query: { ..._, ...p },
          hash: g
        });
      }));
    }
  }));
  return I(
    () => o.query[e],
    (d) => {
      u = d, l();
    },
    { flush: "sync" }
  ), f;
}
var oc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ic(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ds = { exports: {} };
/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(oc, function() {
    var n = {};
    n.version = "0.2.0";
    var r = n.settings = {
      minimum: 0.08,
      easing: "ease",
      positionUsing: "",
      speed: 200,
      trickle: !0,
      trickleRate: 0.02,
      trickleSpeed: 800,
      showSpinner: !0,
      barSelector: '[role="bar"]',
      spinnerSelector: '[role="spinner"]',
      parent: "body",
      template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
    };
    n.configure = function(p) {
      var S, _;
      for (S in p)
        _ = p[S], _ !== void 0 && p.hasOwnProperty(S) && (r[S] = _);
      return this;
    }, n.status = null, n.set = function(p) {
      var S = n.isStarted();
      p = o(p, r.minimum, 1), n.status = p === 1 ? null : p;
      var _ = n.render(!S), g = _.querySelector(r.barSelector), b = r.speed, h = r.easing;
      return _.offsetWidth, s(function(m) {
        r.positionUsing === "" && (r.positionUsing = n.getPositioningCSS()), u(g, a(p, b, h)), p === 1 ? (u(_, {
          transition: "none",
          opacity: 1
        }), _.offsetWidth, setTimeout(function() {
          u(_, {
            transition: "all " + b + "ms linear",
            opacity: 0
          }), setTimeout(function() {
            n.remove(), m();
          }, b);
        }, b)) : setTimeout(m, b);
      }), this;
    }, n.isStarted = function() {
      return typeof n.status == "number";
    }, n.start = function() {
      n.status || n.set(0);
      var p = function() {
        setTimeout(function() {
          n.status && (n.trickle(), p());
        }, r.trickleSpeed);
      };
      return r.trickle && p(), this;
    }, n.done = function(p) {
      return !p && !n.status ? this : n.inc(0.3 + 0.5 * Math.random()).set(1);
    }, n.inc = function(p) {
      var S = n.status;
      return S ? (typeof p != "number" && (p = (1 - S) * o(Math.random() * S, 0.1, 0.95)), S = o(S + p, 0, 0.994), n.set(S)) : n.start();
    }, n.trickle = function() {
      return n.inc(Math.random() * r.trickleRate);
    }, function() {
      var p = 0, S = 0;
      n.promise = function(_) {
        return !_ || _.state() === "resolved" ? this : (S === 0 && n.start(), p++, S++, _.always(function() {
          S--, S === 0 ? (p = 0, n.done()) : n.set((p - S) / p);
        }), this);
      };
    }(), n.render = function(p) {
      if (n.isRendered()) return document.getElementById("nprogress");
      f(document.documentElement, "nprogress-busy");
      var S = document.createElement("div");
      S.id = "nprogress", S.innerHTML = r.template;
      var _ = S.querySelector(r.barSelector), g = p ? "-100" : i(n.status || 0), b = document.querySelector(r.parent), h;
      return u(_, {
        transition: "all 0 linear",
        transform: "translate3d(" + g + "%,0,0)"
      }), r.showSpinner || (h = S.querySelector(r.spinnerSelector), h && v(h)), b != document.body && f(b, "nprogress-custom-parent"), b.appendChild(S), S;
    }, n.remove = function() {
      d(document.documentElement, "nprogress-busy"), d(document.querySelector(r.parent), "nprogress-custom-parent");
      var p = document.getElementById("nprogress");
      p && v(p);
    }, n.isRendered = function() {
      return !!document.getElementById("nprogress");
    }, n.getPositioningCSS = function() {
      var p = document.body.style, S = "WebkitTransform" in p ? "Webkit" : "MozTransform" in p ? "Moz" : "msTransform" in p ? "ms" : "OTransform" in p ? "O" : "";
      return S + "Perspective" in p ? "translate3d" : S + "Transform" in p ? "translate" : "margin";
    };
    function o(p, S, _) {
      return p < S ? S : p > _ ? _ : p;
    }
    function i(p) {
      return (-1 + p) * 100;
    }
    function a(p, S, _) {
      var g;
      return r.positionUsing === "translate3d" ? g = { transform: "translate3d(" + i(p) + "%,0,0)" } : r.positionUsing === "translate" ? g = { transform: "translate(" + i(p) + "%,0)" } : g = { "margin-left": i(p) + "%" }, g.transition = "all " + S + "ms " + _, g;
    }
    var s = /* @__PURE__ */ function() {
      var p = [];
      function S() {
        var _ = p.shift();
        _ && _(S);
      }
      return function(_) {
        p.push(_), p.length == 1 && S();
      };
    }(), u = /* @__PURE__ */ function() {
      var p = ["Webkit", "O", "Moz", "ms"], S = {};
      function _(m) {
        return m.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function(P, x) {
          return x.toUpperCase();
        });
      }
      function g(m) {
        var P = document.body.style;
        if (m in P) return m;
        for (var x = p.length, A = m.charAt(0).toUpperCase() + m.slice(1), N; x--; )
          if (N = p[x] + A, N in P) return N;
        return m;
      }
      function b(m) {
        return m = _(m), S[m] || (S[m] = g(m));
      }
      function h(m, P, x) {
        P = b(P), m.style[P] = x;
      }
      return function(m, P) {
        var x = arguments, A, N;
        if (x.length == 2)
          for (A in P)
            N = P[A], N !== void 0 && P.hasOwnProperty(A) && h(m, A, N);
        else
          h(m, x[1], x[2]);
      };
    }();
    function l(p, S) {
      var _ = typeof p == "string" ? p : y(p);
      return _.indexOf(" " + S + " ") >= 0;
    }
    function f(p, S) {
      var _ = y(p), g = _ + S;
      l(_, S) || (p.className = g.substring(1));
    }
    function d(p, S) {
      var _ = y(p), g;
      l(p, S) && (g = _.replace(" " + S + " ", " "), p.className = g.substring(1, g.length - 1));
    }
    function y(p) {
      return (" " + (p.className || "") + " ").replace(/\s+/gi, " ");
    }
    function v(p) {
      p && p.parentNode && p.parentNode.removeChild(p);
    }
    return n;
  });
})(ds);
var ac = ds.exports;
const Go = /* @__PURE__ */ ic(ac);
function y0(e, t) {
  Go.configure({ showSpinner: !1, ...t }), e.beforeEach(async () => (Go.start(), !0)), e.afterEach(async () => (Go.done(), !0));
}
var sc = Object.defineProperty, uc = (e, t, n) => t in e ? sc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ee = (e, t, n) => uc(e, typeof t != "symbol" ? t + "" : t, n), we = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function lc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function cc(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Er = { exports: {} };
Er.exports;
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", o = 9007199254740991, i = "[object Arguments]", a = "[object Array]", s = "[object Boolean]", u = "[object Date]", l = "[object Error]", f = "[object Function]", d = "[object GeneratorFunction]", y = "[object Map]", v = "[object Number]", p = "[object Object]", S = "[object Promise]", _ = "[object RegExp]", g = "[object Set]", b = "[object String]", h = "[object Symbol]", m = "[object WeakMap]", P = "[object ArrayBuffer]", x = "[object DataView]", A = "[object Float32Array]", N = "[object Float64Array]", D = "[object Int8Array]", M = "[object Int16Array]", L = "[object Int32Array]", K = "[object Uint8Array]", X = "[object Uint8ClampedArray]", ee = "[object Uint16Array]", te = "[object Uint32Array]", F = /[\\^$.*+?()[\]{}|]/g, ne = /\w*$/, se = /^\[object .+?Constructor\]$/, We = /^(?:0|[1-9]\d*)$/, B = {};
  B[i] = B[a] = B[P] = B[x] = B[s] = B[u] = B[A] = B[N] = B[D] = B[M] = B[L] = B[y] = B[v] = B[p] = B[_] = B[g] = B[b] = B[h] = B[K] = B[X] = B[ee] = B[te] = !0, B[l] = B[f] = B[m] = !1;
  var _t = typeof we == "object" && we && we.Object === Object && we, Je = typeof self == "object" && self && self.Object === Object && self, le = _t || Je || Function("return this")(), ie = t && !t.nodeType && t, H = ie && !0 && e && !e.nodeType && e, Nn = H && H.exports === ie;
  function Hr(c, w) {
    return c.set(w[0], w[1]), c;
  }
  function Ie(c, w) {
    return c.add(w), c;
  }
  function Ln(c, w) {
    for (var E = -1, j = c ? c.length : 0; ++E < j && w(c[E], E, c) !== !1; )
      ;
    return c;
  }
  function In(c, w) {
    for (var E = -1, j = w.length, G = c.length; ++E < j; )
      c[G + E] = w[E];
    return c;
  }
  function en(c, w, E, j) {
    for (var G = -1, z = c ? c.length : 0; ++G < z; )
      E = w(E, c[G], G, c);
    return E;
  }
  function tn(c, w) {
    for (var E = -1, j = Array(c); ++E < c; )
      j[E] = w(E);
    return j;
  }
  function Fn(c, w) {
    return c == null ? void 0 : c[w];
  }
  function nn(c) {
    var w = !1;
    if (c != null && typeof c.toString != "function")
      try {
        w = !!(c + "");
      } catch {
      }
    return w;
  }
  function Un(c) {
    var w = -1, E = Array(c.size);
    return c.forEach(function(j, G) {
      E[++w] = [G, j];
    }), E;
  }
  function rn(c, w) {
    return function(E) {
      return c(w(E));
    };
  }
  function zn(c) {
    var w = -1, E = Array(c.size);
    return c.forEach(function(j) {
      E[++w] = j;
    }), E;
  }
  var Br = Array.prototype, Vr = Function.prototype, Ot = Object.prototype, on = le["__core-js_shared__"], Kn = function() {
    var c = /[^.]+$/.exec(on && on.keys && on.keys.IE_PROTO || "");
    return c ? "Symbol(src)_1." + c : "";
  }(), Gn = Vr.toString, Ze = Ot.hasOwnProperty, Et = Ot.toString, Wr = RegExp(
    "^" + Gn.call(Ze).replace(F, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), it = Nn ? le.Buffer : void 0, Tt = le.Symbol, an = le.Uint8Array, De = rn(Object.getPrototypeOf, Object), Zn = Object.create, Xn = Ot.propertyIsEnumerable, Jr = Br.splice, sn = Object.getOwnPropertySymbols, At = it ? it.isBuffer : void 0, Hn = rn(Object.keys, Object), Mt = Ue(le, "DataView"), at = Ue(le, "Map"), Fe = Ue(le, "Promise"), kt = Ue(le, "Set"), un = Ue(le, "WeakMap"), st = Ue(Object, "create"), ln = Se(Mt), ut = Se(at), cn = Se(Fe), fn = Se(kt), dn = Se(un), tt = Tt ? Tt.prototype : void 0, Bn = tt ? tt.valueOf : void 0;
  function Ye(c) {
    var w = -1, E = c ? c.length : 0;
    for (this.clear(); ++w < E; ) {
      var j = c[w];
      this.set(j[0], j[1]);
    }
  }
  function Yr() {
    this.__data__ = st ? st(null) : {};
  }
  function $r(c) {
    return this.has(c) && delete this.__data__[c];
  }
  function Qr(c) {
    var w = this.__data__;
    if (st) {
      var E = w[c];
      return E === r ? void 0 : E;
    }
    return Ze.call(w, c) ? w[c] : void 0;
  }
  function Vn(c) {
    var w = this.__data__;
    return st ? w[c] !== void 0 : Ze.call(w, c);
  }
  function pn(c, w) {
    var E = this.__data__;
    return E[c] = st && w === void 0 ? r : w, this;
  }
  Ye.prototype.clear = Yr, Ye.prototype.delete = $r, Ye.prototype.get = Qr, Ye.prototype.has = Vn, Ye.prototype.set = pn;
  function pe(c) {
    var w = -1, E = c ? c.length : 0;
    for (this.clear(); ++w < E; ) {
      var j = c[w];
      this.set(j[0], j[1]);
    }
  }
  function qr() {
    this.__data__ = [];
  }
  function eo(c) {
    var w = this.__data__, E = Ct(w, c);
    if (E < 0)
      return !1;
    var j = w.length - 1;
    return E == j ? w.pop() : Jr.call(w, E, 1), !0;
  }
  function to(c) {
    var w = this.__data__, E = Ct(w, c);
    return E < 0 ? void 0 : w[E][1];
  }
  function no(c) {
    return Ct(this.__data__, c) > -1;
  }
  function ro(c, w) {
    var E = this.__data__, j = Ct(E, c);
    return j < 0 ? E.push([c, w]) : E[j][1] = w, this;
  }
  pe.prototype.clear = qr, pe.prototype.delete = eo, pe.prototype.get = to, pe.prototype.has = no, pe.prototype.set = ro;
  function ye(c) {
    var w = -1, E = c ? c.length : 0;
    for (this.clear(); ++w < E; ) {
      var j = c[w];
      this.set(j[0], j[1]);
    }
  }
  function oo() {
    this.__data__ = {
      hash: new Ye(),
      map: new (at || pe)(),
      string: new Ye()
    };
  }
  function io(c) {
    return ct(this, c).delete(c);
  }
  function ao(c) {
    return ct(this, c).get(c);
  }
  function so(c) {
    return ct(this, c).has(c);
  }
  function uo(c, w) {
    return ct(this, c).set(c, w), this;
  }
  ye.prototype.clear = oo, ye.prototype.delete = io, ye.prototype.get = ao, ye.prototype.has = so, ye.prototype.set = uo;
  function _e(c) {
    this.__data__ = new pe(c);
  }
  function lo() {
    this.__data__ = new pe();
  }
  function co(c) {
    return this.__data__.delete(c);
  }
  function fo(c) {
    return this.__data__.get(c);
  }
  function po(c) {
    return this.__data__.has(c);
  }
  function ho(c, w) {
    var E = this.__data__;
    if (E instanceof pe) {
      var j = E.__data__;
      if (!at || j.length < n - 1)
        return j.push([c, w]), this;
      E = this.__data__ = new ye(j);
    }
    return E.set(c, w), this;
  }
  _e.prototype.clear = lo, _e.prototype.delete = co, _e.prototype.get = fo, _e.prototype.has = po, _e.prototype.set = ho;
  function jt(c, w) {
    var E = yn(c) || Rt(c) ? tn(c.length, String) : [], j = E.length, G = !!j;
    for (var z in c)
      Ze.call(c, z) && !(G && (z == "length" || Ao(z, j))) && E.push(z);
    return E;
  }
  function Wn(c, w, E) {
    var j = c[w];
    (!(Ze.call(c, w) && qn(j, E)) || E === void 0 && !(w in c)) && (c[w] = E);
  }
  function Ct(c, w) {
    for (var E = c.length; E--; )
      if (qn(c[E][0], w))
        return E;
    return -1;
  }
  function Xe(c, w) {
    return c && mn(w, bn(w), c);
  }
  function hn(c, w, E, j, G, z, Q) {
    var J;
    if (j && (J = z ? j(c, G, z, Q) : j(c)), J !== void 0)
      return J;
    if (!Be(c))
      return c;
    var ue = yn(c);
    if (ue) {
      if (J = Eo(c), !w)
        return xo(c, J);
    } else {
      var q = Qe(c), ge = q == f || q == d;
      if (er(c))
        return Dt(c, w);
      if (q == p || q == i || ge && !z) {
        if (nn(c))
          return z ? c : {};
        if (J = He(ge ? {} : c), !w)
          return _o(c, Xe(J, c));
      } else {
        if (!B[q])
          return z ? c : {};
        J = To(c, q, hn, w);
      }
    }
    Q || (Q = new _e());
    var Oe = Q.get(c);
    if (Oe)
      return Oe;
    if (Q.set(c, J), !ue)
      var ce = E ? Oo(c) : bn(c);
    return Ln(ce || c, function(be, he) {
      ce && (he = be, be = c[he]), Wn(J, he, hn(be, w, E, j, he, c, Q));
    }), J;
  }
  function vo(c) {
    return Be(c) ? Zn(c) : {};
  }
  function mo(c, w, E) {
    var j = w(c);
    return yn(c) ? j : In(j, E(c));
  }
  function yo(c) {
    return Et.call(c);
  }
  function go(c) {
    if (!Be(c) || ko(c))
      return !1;
    var w = gn(c) || nn(c) ? Wr : se;
    return w.test(Se(c));
  }
  function bo(c) {
    if (!$n(c))
      return Hn(c);
    var w = [];
    for (var E in Object(c))
      Ze.call(c, E) && E != "constructor" && w.push(E);
    return w;
  }
  function Dt(c, w) {
    if (w)
      return c.slice();
    var E = new c.constructor(c.length);
    return c.copy(E), E;
  }
  function vn(c) {
    var w = new c.constructor(c.byteLength);
    return new an(w).set(new an(c)), w;
  }
  function lt(c, w) {
    var E = w ? vn(c.buffer) : c.buffer;
    return new c.constructor(E, c.byteOffset, c.byteLength);
  }
  function Jn(c, w, E) {
    var j = w ? E(Un(c), !0) : Un(c);
    return en(j, Hr, new c.constructor());
  }
  function Yn(c) {
    var w = new c.constructor(c.source, ne.exec(c));
    return w.lastIndex = c.lastIndex, w;
  }
  function wo(c, w, E) {
    var j = w ? E(zn(c), !0) : zn(c);
    return en(j, Ie, new c.constructor());
  }
  function So(c) {
    return Bn ? Object(Bn.call(c)) : {};
  }
  function Po(c, w) {
    var E = w ? vn(c.buffer) : c.buffer;
    return new c.constructor(E, c.byteOffset, c.length);
  }
  function xo(c, w) {
    var E = -1, j = c.length;
    for (w || (w = Array(j)); ++E < j; )
      w[E] = c[E];
    return w;
  }
  function mn(c, w, E, j) {
    E || (E = {});
    for (var G = -1, z = w.length; ++G < z; ) {
      var Q = w[G], J = void 0;
      Wn(E, Q, J === void 0 ? c[Q] : J);
    }
    return E;
  }
  function _o(c, w) {
    return mn(c, $e(c), w);
  }
  function Oo(c) {
    return mo(c, bn, $e);
  }
  function ct(c, w) {
    var E = c.__data__;
    return Mo(w) ? E[typeof w == "string" ? "string" : "hash"] : E.map;
  }
  function Ue(c, w) {
    var E = Fn(c, w);
    return go(E) ? E : void 0;
  }
  var $e = sn ? rn(sn, Object) : Co, Qe = yo;
  (Mt && Qe(new Mt(new ArrayBuffer(1))) != x || at && Qe(new at()) != y || Fe && Qe(Fe.resolve()) != S || kt && Qe(new kt()) != g || un && Qe(new un()) != m) && (Qe = function(c) {
    var w = Et.call(c), E = w == p ? c.constructor : void 0, j = E ? Se(E) : void 0;
    if (j)
      switch (j) {
        case ln:
          return x;
        case ut:
          return y;
        case cn:
          return S;
        case fn:
          return g;
        case dn:
          return m;
      }
    return w;
  });
  function Eo(c) {
    var w = c.length, E = c.constructor(w);
    return w && typeof c[0] == "string" && Ze.call(c, "index") && (E.index = c.index, E.input = c.input), E;
  }
  function He(c) {
    return typeof c.constructor == "function" && !$n(c) ? vo(De(c)) : {};
  }
  function To(c, w, E, j) {
    var G = c.constructor;
    switch (w) {
      case P:
        return vn(c);
      case s:
      case u:
        return new G(+c);
      case x:
        return lt(c, j);
      case A:
      case N:
      case D:
      case M:
      case L:
      case K:
      case X:
      case ee:
      case te:
        return Po(c, j);
      case y:
        return Jn(c, j, E);
      case v:
      case b:
        return new G(c);
      case _:
        return Yn(c);
      case g:
        return wo(c, j, E);
      case h:
        return So(c);
    }
  }
  function Ao(c, w) {
    return w = w ?? o, !!w && (typeof c == "number" || We.test(c)) && c > -1 && c % 1 == 0 && c < w;
  }
  function Mo(c) {
    var w = typeof c;
    return w == "string" || w == "number" || w == "symbol" || w == "boolean" ? c !== "__proto__" : c === null;
  }
  function ko(c) {
    return !!Kn && Kn in c;
  }
  function $n(c) {
    var w = c && c.constructor, E = typeof w == "function" && w.prototype || Ot;
    return c === E;
  }
  function Se(c) {
    if (c != null) {
      try {
        return Gn.call(c);
      } catch {
      }
      try {
        return c + "";
      } catch {
      }
    }
    return "";
  }
  function Qn(c) {
    return hn(c, !0, !0);
  }
  function qn(c, w) {
    return c === w || c !== c && w !== w;
  }
  function Rt(c) {
    return jo(c) && Ze.call(c, "callee") && (!Xn.call(c, "callee") || Et.call(c) == i);
  }
  var yn = Array.isArray;
  function Nt(c) {
    return c != null && tr(c.length) && !gn(c);
  }
  function jo(c) {
    return nr(c) && Nt(c);
  }
  var er = At || Do;
  function gn(c) {
    var w = Be(c) ? Et.call(c) : "";
    return w == f || w == d;
  }
  function tr(c) {
    return typeof c == "number" && c > -1 && c % 1 == 0 && c <= o;
  }
  function Be(c) {
    var w = typeof c;
    return !!c && (w == "object" || w == "function");
  }
  function nr(c) {
    return !!c && typeof c == "object";
  }
  function bn(c) {
    return Nt(c) ? jt(c) : bo(c);
  }
  function Co() {
    return [];
  }
  function Do() {
    return !1;
  }
  e.exports = Qn;
})(Er, Er.exports);
var fc = Er.exports;
const qi = /* @__PURE__ */ lc(fc);
var Tr = { exports: {} };
Tr.exports;
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", o = 1, i = 2, a = 9007199254740991, s = "[object Arguments]", u = "[object Array]", l = "[object AsyncFunction]", f = "[object Boolean]", d = "[object Date]", y = "[object Error]", v = "[object Function]", p = "[object GeneratorFunction]", S = "[object Map]", _ = "[object Number]", g = "[object Null]", b = "[object Object]", h = "[object Promise]", m = "[object Proxy]", P = "[object RegExp]", x = "[object Set]", A = "[object String]", N = "[object Symbol]", D = "[object Undefined]", M = "[object WeakMap]", L = "[object ArrayBuffer]", K = "[object DataView]", X = "[object Float32Array]", ee = "[object Float64Array]", te = "[object Int8Array]", F = "[object Int16Array]", ne = "[object Int32Array]", se = "[object Uint8Array]", We = "[object Uint8ClampedArray]", B = "[object Uint16Array]", _t = "[object Uint32Array]", Je = /[\\^$.*+?()[\]{}|]/g, le = /^\[object .+?Constructor\]$/, ie = /^(?:0|[1-9]\d*)$/, H = {};
  H[X] = H[ee] = H[te] = H[F] = H[ne] = H[se] = H[We] = H[B] = H[_t] = !0, H[s] = H[u] = H[L] = H[f] = H[K] = H[d] = H[y] = H[v] = H[S] = H[_] = H[b] = H[P] = H[x] = H[A] = H[M] = !1;
  var Nn = typeof we == "object" && we && we.Object === Object && we, Hr = typeof self == "object" && self && self.Object === Object && self, Ie = Nn || Hr || Function("return this")(), Ln = t && !t.nodeType && t, In = Ln && !0 && e && !e.nodeType && e, en = In && In.exports === Ln, tn = en && Nn.process, Fn = function() {
    try {
      return tn && tn.binding && tn.binding("util");
    } catch {
    }
  }(), nn = Fn && Fn.isTypedArray;
  function Un(c, w) {
    for (var E = -1, j = c == null ? 0 : c.length, G = 0, z = []; ++E < j; ) {
      var Q = c[E];
      w(Q, E, c) && (z[G++] = Q);
    }
    return z;
  }
  function rn(c, w) {
    for (var E = -1, j = w.length, G = c.length; ++E < j; )
      c[G + E] = w[E];
    return c;
  }
  function zn(c, w) {
    for (var E = -1, j = c == null ? 0 : c.length; ++E < j; )
      if (w(c[E], E, c))
        return !0;
    return !1;
  }
  function Br(c, w) {
    for (var E = -1, j = Array(c); ++E < c; )
      j[E] = w(E);
    return j;
  }
  function Vr(c) {
    return function(w) {
      return c(w);
    };
  }
  function Ot(c, w) {
    return c.has(w);
  }
  function on(c, w) {
    return c == null ? void 0 : c[w];
  }
  function Kn(c) {
    var w = -1, E = Array(c.size);
    return c.forEach(function(j, G) {
      E[++w] = [G, j];
    }), E;
  }
  function Gn(c, w) {
    return function(E) {
      return c(w(E));
    };
  }
  function Ze(c) {
    var w = -1, E = Array(c.size);
    return c.forEach(function(j) {
      E[++w] = j;
    }), E;
  }
  var Et = Array.prototype, Wr = Function.prototype, it = Object.prototype, Tt = Ie["__core-js_shared__"], an = Wr.toString, De = it.hasOwnProperty, Zn = function() {
    var c = /[^.]+$/.exec(Tt && Tt.keys && Tt.keys.IE_PROTO || "");
    return c ? "Symbol(src)_1." + c : "";
  }(), Xn = it.toString, Jr = RegExp(
    "^" + an.call(De).replace(Je, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), sn = en ? Ie.Buffer : void 0, At = Ie.Symbol, Hn = Ie.Uint8Array, Mt = it.propertyIsEnumerable, at = Et.splice, Fe = At ? At.toStringTag : void 0, kt = Object.getOwnPropertySymbols, un = sn ? sn.isBuffer : void 0, st = Gn(Object.keys, Object), ln = $e(Ie, "DataView"), ut = $e(Ie, "Map"), cn = $e(Ie, "Promise"), fn = $e(Ie, "Set"), dn = $e(Ie, "WeakMap"), tt = $e(Object, "create"), Bn = Se(ln), Ye = Se(ut), Yr = Se(cn), $r = Se(fn), Qr = Se(dn), Vn = At ? At.prototype : void 0, pn = Vn ? Vn.valueOf : void 0;
  function pe(c) {
    var w = -1, E = c == null ? 0 : c.length;
    for (this.clear(); ++w < E; ) {
      var j = c[w];
      this.set(j[0], j[1]);
    }
  }
  function qr() {
    this.__data__ = tt ? tt(null) : {}, this.size = 0;
  }
  function eo(c) {
    var w = this.has(c) && delete this.__data__[c];
    return this.size -= w ? 1 : 0, w;
  }
  function to(c) {
    var w = this.__data__;
    if (tt) {
      var E = w[c];
      return E === r ? void 0 : E;
    }
    return De.call(w, c) ? w[c] : void 0;
  }
  function no(c) {
    var w = this.__data__;
    return tt ? w[c] !== void 0 : De.call(w, c);
  }
  function ro(c, w) {
    var E = this.__data__;
    return this.size += this.has(c) ? 0 : 1, E[c] = tt && w === void 0 ? r : w, this;
  }
  pe.prototype.clear = qr, pe.prototype.delete = eo, pe.prototype.get = to, pe.prototype.has = no, pe.prototype.set = ro;
  function ye(c) {
    var w = -1, E = c == null ? 0 : c.length;
    for (this.clear(); ++w < E; ) {
      var j = c[w];
      this.set(j[0], j[1]);
    }
  }
  function oo() {
    this.__data__ = [], this.size = 0;
  }
  function io(c) {
    var w = this.__data__, E = Dt(w, c);
    if (E < 0)
      return !1;
    var j = w.length - 1;
    return E == j ? w.pop() : at.call(w, E, 1), --this.size, !0;
  }
  function ao(c) {
    var w = this.__data__, E = Dt(w, c);
    return E < 0 ? void 0 : w[E][1];
  }
  function so(c) {
    return Dt(this.__data__, c) > -1;
  }
  function uo(c, w) {
    var E = this.__data__, j = Dt(E, c);
    return j < 0 ? (++this.size, E.push([c, w])) : E[j][1] = w, this;
  }
  ye.prototype.clear = oo, ye.prototype.delete = io, ye.prototype.get = ao, ye.prototype.has = so, ye.prototype.set = uo;
  function _e(c) {
    var w = -1, E = c == null ? 0 : c.length;
    for (this.clear(); ++w < E; ) {
      var j = c[w];
      this.set(j[0], j[1]);
    }
  }
  function lo() {
    this.size = 0, this.__data__ = {
      hash: new pe(),
      map: new (ut || ye)(),
      string: new pe()
    };
  }
  function co(c) {
    var w = Ue(this, c).delete(c);
    return this.size -= w ? 1 : 0, w;
  }
  function fo(c) {
    return Ue(this, c).get(c);
  }
  function po(c) {
    return Ue(this, c).has(c);
  }
  function ho(c, w) {
    var E = Ue(this, c), j = E.size;
    return E.set(c, w), this.size += E.size == j ? 0 : 1, this;
  }
  _e.prototype.clear = lo, _e.prototype.delete = co, _e.prototype.get = fo, _e.prototype.has = po, _e.prototype.set = ho;
  function jt(c) {
    var w = -1, E = c == null ? 0 : c.length;
    for (this.__data__ = new _e(); ++w < E; )
      this.add(c[w]);
  }
  function Wn(c) {
    return this.__data__.set(c, r), this;
  }
  function Ct(c) {
    return this.__data__.has(c);
  }
  jt.prototype.add = jt.prototype.push = Wn, jt.prototype.has = Ct;
  function Xe(c) {
    var w = this.__data__ = new ye(c);
    this.size = w.size;
  }
  function hn() {
    this.__data__ = new ye(), this.size = 0;
  }
  function vo(c) {
    var w = this.__data__, E = w.delete(c);
    return this.size = w.size, E;
  }
  function mo(c) {
    return this.__data__.get(c);
  }
  function yo(c) {
    return this.__data__.has(c);
  }
  function go(c, w) {
    var E = this.__data__;
    if (E instanceof ye) {
      var j = E.__data__;
      if (!ut || j.length < n - 1)
        return j.push([c, w]), this.size = ++E.size, this;
      E = this.__data__ = new _e(j);
    }
    return E.set(c, w), this.size = E.size, this;
  }
  Xe.prototype.clear = hn, Xe.prototype.delete = vo, Xe.prototype.get = mo, Xe.prototype.has = yo, Xe.prototype.set = go;
  function bo(c, w) {
    var E = Rt(c), j = !E && qn(c), G = !E && !j && Nt(c), z = !E && !j && !G && nr(c), Q = E || j || G || z, J = Q ? Br(c.length, String) : [], ue = J.length;
    for (var q in c)
      De.call(c, q) && !(Q && // Safari 9 has enumerable `arguments.length` in strict mode.
      (q == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      G && (q == "offset" || q == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      z && (q == "buffer" || q == "byteLength" || q == "byteOffset") || // Skip index properties.
      To(q, ue))) && J.push(q);
    return J;
  }
  function Dt(c, w) {
    for (var E = c.length; E--; )
      if (Qn(c[E][0], w))
        return E;
    return -1;
  }
  function vn(c, w, E) {
    var j = w(c);
    return Rt(c) ? j : rn(j, E(c));
  }
  function lt(c) {
    return c == null ? c === void 0 ? D : g : Fe && Fe in Object(c) ? Qe(c) : $n(c);
  }
  function Jn(c) {
    return Be(c) && lt(c) == s;
  }
  function Yn(c, w, E, j, G) {
    return c === w ? !0 : c == null || w == null || !Be(c) && !Be(w) ? c !== c && w !== w : wo(c, w, E, j, Yn, G);
  }
  function wo(c, w, E, j, G, z) {
    var Q = Rt(c), J = Rt(w), ue = Q ? u : He(c), q = J ? u : He(w);
    ue = ue == s ? b : ue, q = q == s ? b : q;
    var ge = ue == b, Oe = q == b, ce = ue == q;
    if (ce && Nt(c)) {
      if (!Nt(w))
        return !1;
      Q = !0, ge = !1;
    }
    if (ce && !ge)
      return z || (z = new Xe()), Q || nr(c) ? mn(c, w, E, j, G, z) : _o(c, w, ue, E, j, G, z);
    if (!(E & o)) {
      var be = ge && De.call(c, "__wrapped__"), he = Oe && De.call(w, "__wrapped__");
      if (be || he) {
        var nt = be ? c.value() : c, qe = he ? w.value() : w;
        return z || (z = new Xe()), G(nt, qe, E, j, z);
      }
    }
    return ce ? (z || (z = new Xe()), Oo(c, w, E, j, G, z)) : !1;
  }
  function So(c) {
    if (!tr(c) || Mo(c))
      return !1;
    var w = er(c) ? Jr : le;
    return w.test(Se(c));
  }
  function Po(c) {
    return Be(c) && gn(c.length) && !!H[lt(c)];
  }
  function xo(c) {
    if (!ko(c))
      return st(c);
    var w = [];
    for (var E in Object(c))
      De.call(c, E) && E != "constructor" && w.push(E);
    return w;
  }
  function mn(c, w, E, j, G, z) {
    var Q = E & o, J = c.length, ue = w.length;
    if (J != ue && !(Q && ue > J))
      return !1;
    var q = z.get(c);
    if (q && z.get(w))
      return q == w;
    var ge = -1, Oe = !0, ce = E & i ? new jt() : void 0;
    for (z.set(c, w), z.set(w, c); ++ge < J; ) {
      var be = c[ge], he = w[ge];
      if (j)
        var nt = Q ? j(he, be, ge, w, c, z) : j(be, he, ge, c, w, z);
      if (nt !== void 0) {
        if (nt)
          continue;
        Oe = !1;
        break;
      }
      if (ce) {
        if (!zn(w, function(qe, ft) {
          if (!Ot(ce, ft) && (be === qe || G(be, qe, E, j, z)))
            return ce.push(ft);
        })) {
          Oe = !1;
          break;
        }
      } else if (!(be === he || G(be, he, E, j, z))) {
        Oe = !1;
        break;
      }
    }
    return z.delete(c), z.delete(w), Oe;
  }
  function _o(c, w, E, j, G, z, Q) {
    switch (E) {
      case K:
        if (c.byteLength != w.byteLength || c.byteOffset != w.byteOffset)
          return !1;
        c = c.buffer, w = w.buffer;
      case L:
        return !(c.byteLength != w.byteLength || !z(new Hn(c), new Hn(w)));
      case f:
      case d:
      case _:
        return Qn(+c, +w);
      case y:
        return c.name == w.name && c.message == w.message;
      case P:
      case A:
        return c == w + "";
      case S:
        var J = Kn;
      case x:
        var ue = j & o;
        if (J || (J = Ze), c.size != w.size && !ue)
          return !1;
        var q = Q.get(c);
        if (q)
          return q == w;
        j |= i, Q.set(c, w);
        var ge = mn(J(c), J(w), j, G, z, Q);
        return Q.delete(c), ge;
      case N:
        if (pn)
          return pn.call(c) == pn.call(w);
    }
    return !1;
  }
  function Oo(c, w, E, j, G, z) {
    var Q = E & o, J = ct(c), ue = J.length, q = ct(w), ge = q.length;
    if (ue != ge && !Q)
      return !1;
    for (var Oe = ue; Oe--; ) {
      var ce = J[Oe];
      if (!(Q ? ce in w : De.call(w, ce)))
        return !1;
    }
    var be = z.get(c);
    if (be && z.get(w))
      return be == w;
    var he = !0;
    z.set(c, w), z.set(w, c);
    for (var nt = Q; ++Oe < ue; ) {
      ce = J[Oe];
      var qe = c[ce], ft = w[ce];
      if (j)
        var Fi = Q ? j(ft, qe, ce, w, c, z) : j(qe, ft, ce, c, w, z);
      if (!(Fi === void 0 ? qe === ft || G(qe, ft, E, j, z) : Fi)) {
        he = !1;
        break;
      }
      nt || (nt = ce == "constructor");
    }
    if (he && !nt) {
      var rr = c.constructor, or = w.constructor;
      rr != or && "constructor" in c && "constructor" in w && !(typeof rr == "function" && rr instanceof rr && typeof or == "function" && or instanceof or) && (he = !1);
    }
    return z.delete(c), z.delete(w), he;
  }
  function ct(c) {
    return vn(c, bn, Eo);
  }
  function Ue(c, w) {
    var E = c.__data__;
    return Ao(w) ? E[typeof w == "string" ? "string" : "hash"] : E.map;
  }
  function $e(c, w) {
    var E = on(c, w);
    return So(E) ? E : void 0;
  }
  function Qe(c) {
    var w = De.call(c, Fe), E = c[Fe];
    try {
      c[Fe] = void 0;
      var j = !0;
    } catch {
    }
    var G = Xn.call(c);
    return j && (w ? c[Fe] = E : delete c[Fe]), G;
  }
  var Eo = kt ? function(c) {
    return c == null ? [] : (c = Object(c), Un(kt(c), function(w) {
      return Mt.call(c, w);
    }));
  } : Co, He = lt;
  (ln && He(new ln(new ArrayBuffer(1))) != K || ut && He(new ut()) != S || cn && He(cn.resolve()) != h || fn && He(new fn()) != x || dn && He(new dn()) != M) && (He = function(c) {
    var w = lt(c), E = w == b ? c.constructor : void 0, j = E ? Se(E) : "";
    if (j)
      switch (j) {
        case Bn:
          return K;
        case Ye:
          return S;
        case Yr:
          return h;
        case $r:
          return x;
        case Qr:
          return M;
      }
    return w;
  });
  function To(c, w) {
    return w = w ?? a, !!w && (typeof c == "number" || ie.test(c)) && c > -1 && c % 1 == 0 && c < w;
  }
  function Ao(c) {
    var w = typeof c;
    return w == "string" || w == "number" || w == "symbol" || w == "boolean" ? c !== "__proto__" : c === null;
  }
  function Mo(c) {
    return !!Zn && Zn in c;
  }
  function ko(c) {
    var w = c && c.constructor, E = typeof w == "function" && w.prototype || it;
    return c === E;
  }
  function $n(c) {
    return Xn.call(c);
  }
  function Se(c) {
    if (c != null) {
      try {
        return an.call(c);
      } catch {
      }
      try {
        return c + "";
      } catch {
      }
    }
    return "";
  }
  function Qn(c, w) {
    return c === w || c !== c && w !== w;
  }
  var qn = Jn(/* @__PURE__ */ function() {
    return arguments;
  }()) ? Jn : function(c) {
    return Be(c) && De.call(c, "callee") && !Mt.call(c, "callee");
  }, Rt = Array.isArray;
  function yn(c) {
    return c != null && gn(c.length) && !er(c);
  }
  var Nt = un || Do;
  function jo(c, w) {
    return Yn(c, w);
  }
  function er(c) {
    if (!tr(c))
      return !1;
    var w = lt(c);
    return w == v || w == p || w == l || w == m;
  }
  function gn(c) {
    return typeof c == "number" && c > -1 && c % 1 == 0 && c <= a;
  }
  function tr(c) {
    var w = typeof c;
    return c != null && (w == "object" || w == "function");
  }
  function Be(c) {
    return c != null && typeof c == "object";
  }
  var nr = nn ? Vr(nn) : Po;
  function bn(c) {
    return yn(c) ? bo(c) : xo(c);
  }
  function Co() {
    return [];
  }
  function Do() {
    return !1;
  }
  e.exports = jo;
})(Tr, Tr.exports);
Tr.exports;
var dc = "Expected a function", ps = "__lodash_hash_undefined__", pc = 1 / 0, hc = "[object Function]", vc = "[object GeneratorFunction]", mc = "[object Symbol]", yc = /^\./, gc = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, bc = /[\\^$.*+?()[\]{}|]/g, wc = /\\(\\)?/g, Sc = /^\[object .+?Constructor\]$/, Pc = typeof we == "object" && we && we.Object === Object && we, xc = typeof self == "object" && self && self.Object === Object && self, Ai = Pc || xc || Function("return this")();
function _c(e, t) {
  return e == null ? void 0 : e[t];
}
function Oc(e) {
  var t = !1;
  if (e != null && typeof e.toString != "function")
    try {
      t = !!(e + "");
    } catch {
    }
  return t;
}
var Ec = Array.prototype, Tc = Function.prototype, hs = Object.prototype, Zo = Ai["__core-js_shared__"], ea = function() {
  var e = /[^.]+$/.exec(Zo && Zo.keys && Zo.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}(), vs = Tc.toString, Mi = hs.hasOwnProperty, ms = hs.toString, Ac = RegExp(
  "^" + vs.call(Mi).replace(bc, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), ta = Ai.Symbol, Mc = Ec.splice, kc = ys(Ai, "Map"), An = ys(Object, "create"), na = ta ? ta.prototype : void 0, ra = na ? na.toString : void 0;
function gt(e) {
  var t = -1, n = e ? e.length : 0;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function jc() {
  this.__data__ = An ? An(null) : {};
}
function Cc(e) {
  return this.has(e) && delete this.__data__[e];
}
function Dc(e) {
  var t = this.__data__;
  if (An) {
    var n = t[e];
    return n === ps ? void 0 : n;
  }
  return Mi.call(t, e) ? t[e] : void 0;
}
function Rc(e) {
  var t = this.__data__;
  return An ? t[e] !== void 0 : Mi.call(t, e);
}
function Nc(e, t) {
  var n = this.__data__;
  return n[e] = An && t === void 0 ? ps : t, this;
}
gt.prototype.clear = jc;
gt.prototype.delete = Cc;
gt.prototype.get = Dc;
gt.prototype.has = Rc;
gt.prototype.set = Nc;
function Jt(e) {
  var t = -1, n = e ? e.length : 0;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function Lc() {
  this.__data__ = [];
}
function Ic(e) {
  var t = this.__data__, n = Ir(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : Mc.call(t, n, 1), !0;
}
function Fc(e) {
  var t = this.__data__, n = Ir(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function Uc(e) {
  return Ir(this.__data__, e) > -1;
}
function zc(e, t) {
  var n = this.__data__, r = Ir(n, e);
  return r < 0 ? n.push([e, t]) : n[r][1] = t, this;
}
Jt.prototype.clear = Lc;
Jt.prototype.delete = Ic;
Jt.prototype.get = Fc;
Jt.prototype.has = Uc;
Jt.prototype.set = zc;
function Pt(e) {
  var t = -1, n = e ? e.length : 0;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function Kc() {
  this.__data__ = {
    hash: new gt(),
    map: new (kc || Jt)(),
    string: new gt()
  };
}
function Gc(e) {
  return Fr(this, e).delete(e);
}
function Zc(e) {
  return Fr(this, e).get(e);
}
function Xc(e) {
  return Fr(this, e).has(e);
}
function Hc(e, t) {
  return Fr(this, e).set(e, t), this;
}
Pt.prototype.clear = Kc;
Pt.prototype.delete = Gc;
Pt.prototype.get = Zc;
Pt.prototype.has = Xc;
Pt.prototype.set = Hc;
function Ir(e, t) {
  for (var n = e.length; n--; )
    if ($c(e[n][0], t))
      return n;
  return -1;
}
function Bc(e) {
  if (!gs(e) || Jc(e))
    return !1;
  var t = Qc(e) || Oc(e) ? Ac : Sc;
  return t.test(Yc(e));
}
function Vc(e) {
  if (typeof e == "string")
    return e;
  if (ef(e))
    return ra ? ra.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -pc ? "-0" : t;
}
function Fr(e, t) {
  var n = e.__data__;
  return Wc(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function ys(e, t) {
  var n = _c(e, t);
  return Bc(n) ? n : void 0;
}
function Wc(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Jc(e) {
  return !!ea && ea in e;
}
ki(function(e) {
  e = tf(e);
  var t = [];
  return yc.test(e) && t.push(""), e.replace(gc, function(n, r, o, i) {
    t.push(o ? i.replace(wc, "$1") : r || n);
  }), t;
});
function Yc(e) {
  if (e != null) {
    try {
      return vs.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
function ki(e, t) {
  if (typeof e != "function" || t && typeof t != "function")
    throw new TypeError(dc);
  var n = function() {
    var r = arguments, o = t ? t.apply(this, r) : r[0], i = n.cache;
    if (i.has(o))
      return i.get(o);
    var a = e.apply(this, r);
    return n.cache = i.set(o, a), a;
  };
  return n.cache = new (ki.Cache || Pt)(), n;
}
ki.Cache = Pt;
function $c(e, t) {
  return e === t || e !== e && t !== t;
}
function Qc(e) {
  var t = gs(e) ? ms.call(e) : "";
  return t == hc || t == vc;
}
function gs(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function qc(e) {
  return !!e && typeof e == "object";
}
function ef(e) {
  return typeof e == "symbol" || qc(e) && ms.call(e) == mc;
}
function tf(e) {
  return e == null ? "" : Vc(e);
}
var nf = typeof we == "object" && we && we.Object === Object && we, rf = typeof self == "object" && self && self.Object === Object && self;
nf || rf || Function("return this")();
function Ke(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function bs(e) {
  return Ke(e) === "Null";
}
function ws(e) {
  return Ke(e) === "Undefined";
}
function si(e) {
  return ws(e) || bs(e);
}
function of(e) {
  return Ke(e) === "String";
}
function af(e) {
  return Ke(e) === "Number";
}
function sf(e) {
  return Ke(e) === "Function";
}
const Ss = Array.isArray;
function uf(e) {
  return Ke(e) == "Object";
}
function Ps(e) {
  return !!e && typeof e == "object";
}
function lf(e) {
  return Ke(e) === "Map";
}
function cf(e) {
  return Ke(e) === "Set";
}
function ff(e) {
  return Ke(e) === "Symbol";
}
function df(e) {
  return Ke(e) === "Promise";
}
function pf(e) {
  return /^https?:\/\//.test(e);
}
function xt() {
  return typeof window < "u" && typeof document < "u";
}
const hf = xt() && typeof document.body.style.webkitLineClamp < "u", vf = xt() && typeof ResizeObserver < "u", mf = xt() && typeof IntersectionObserver < "u", yf = xt() && /^((?!chrome|android).)*safari/i.test(navigator.userAgent), gf = xt() && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), bf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getType: Ke,
  intersectionObserverEnabled: mf,
  isArray: Ss,
  isBrowser: xt,
  isFunction: sf,
  isMap: lf,
  isMobile: gf,
  isNull: bs,
  isNullOrUndef: si,
  isNumber: af,
  isObject: uf,
  isObjectType: Ps,
  isPromise: df,
  isSafari: yf,
  isSet: cf,
  isString: of,
  isSymbol: ff,
  isUndef: ws,
  isUrl: pf,
  nativeEllipsisEnabled: hf,
  resizeObserverEnabled: vf
}, Symbol.toStringTag, { value: "Module" }));
class wf {
  constructor(t = "MOGIC_") {
    Ee(this, "storage"), Ee(this, "prefix"), typeof window < "u" && (this.storage = window.localStorage, this.prefix = t);
  }
  getKey(t) {
    return `${this.prefix}${t}`.toUpperCase();
  }
  get(t) {
    var n;
    const r = (n = this.storage) == null ? void 0 : n.getItem(this.getKey(t));
    if (!r) return null;
    try {
      const o = JSON.parse(r), { value: i, expire: a } = o;
      if (si(a) || a >= (/* @__PURE__ */ new Date()).getTime())
        return i;
      this.remove(t);
    } catch (o) {
      console.error(o);
    }
    return null;
  }
  /**
   * @param {string} key
   * @param {*} value
   * @param {*} expire time in ms
   */
  set(t, n, r) {
    var o;
    const i = JSON.stringify({
      value: n,
      time: Date.now(),
      expire: si(r) ? null : (/* @__PURE__ */ new Date()).getTime() + (r || 0)
    });
    try {
      (o = this.storage) == null || o.setItem(this.getKey(t), i);
    } catch (a) {
      console.error(a);
    }
  }
  remove(t) {
    var n;
    (n = this.storage) == null || n.removeItem(this.getKey(t));
  }
  clear(t) {
    var n, r;
    const o = {};
    t != null && t.length && t.forEach((i) => {
      this.get(i) && (o[i] = this.get(i));
    }), (n = this.storage) == null || n.clear(), (r = Object.keys(o)) == null || r.forEach((i) => {
      this.set(i, o[i]);
    });
  }
}
new wf();
function Sf(e) {
  return (...t) => {
    if (typeof e == "function") {
      const n = e(...t);
      return n instanceof Promise ? n : new Promise((r, o) => {
        try {
          r(n);
        } catch (i) {
          o(i);
        }
      });
    }
    return Promise.resolve(e);
  };
}
const xs = Symbol("cancel"), Pf = () => new Error("cancel", { cause: xs }), _s = (e) => Of(e, "cause") === xs, xf = (e) => {
  let t = () => {
  };
  const n = new Promise((r, o) => {
    e.then(r).catch(o), t = () => o(Pf());
  });
  return n.cancel = t, n.catch((r) => {
    if (_s(r))
      return console.log("Promise cancelled.");
    throw r;
  }), n;
};
class _f {
  constructor() {
    Ee(this, "cancelMap", /* @__PURE__ */ new Map());
  }
  add(t, n) {
    const r = xf(t);
    return n = n ?? Symbol("key"), this.cancelMap.set(n, r.cancel), r;
  }
  cancel(t) {
    const n = this.cancelMap.get(t);
    n && (n(), this.cancelMap.delete(t));
  }
  cancelAll() {
    this.cancelMap.forEach((t) => t()), this.cancelMap.clear();
  }
}
function Of(e, t) {
  Ss(t) || (t = [t]);
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    return Ps(e) && r in e ? e[r] : void 0;
  }
}
function Os(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Ef } = Object.prototype, { getPrototypeOf: ji } = Object, Ur = /* @__PURE__ */ ((e) => (t) => {
  const n = Ef.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ge = (e) => (e = e.toLowerCase(), (t) => Ur(t) === e), zr = (e) => (t) => typeof t === e, { isArray: Yt } = Array, Mn = zr("undefined");
function Tf(e) {
  return e !== null && !Mn(e) && e.constructor !== null && !Mn(e.constructor) && Ne(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Es = Ge("ArrayBuffer");
function Af(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Es(e.buffer), t;
}
const Mf = zr("string"), Ne = zr("function"), Ts = zr("number"), Kr = (e) => e !== null && typeof e == "object", kf = (e) => e === !0 || e === !1, vr = (e) => {
  if (Ur(e) !== "object")
    return !1;
  const t = ji(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, jf = Ge("Date"), Cf = Ge("File"), Df = Ge("Blob"), Rf = Ge("FileList"), Nf = (e) => Kr(e) && Ne(e.pipe), Lf = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Ne(e.append) && ((t = Ur(e)) === "formdata" || // detect form-data instance
  t === "object" && Ne(e.toString) && e.toString() === "[object FormData]"));
}, If = Ge("URLSearchParams"), [Ff, Uf, zf, Kf] = ["ReadableStream", "Request", "Response", "Headers"].map(Ge), Gf = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Cn(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), Yt(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length;
    let s;
    for (r = 0; r < a; r++)
      s = i[r], t.call(null, e[s], s, e);
  }
}
function As(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const Ms = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, ks = (e) => !Mn(e) && e !== Ms;
function ui() {
  const { caseless: e } = ks(this) && this || {}, t = {}, n = (r, o) => {
    const i = e && As(t, o) || o;
    vr(t[i]) && vr(r) ? t[i] = ui(t[i], r) : vr(r) ? t[i] = ui({}, r) : Yt(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && Cn(arguments[r], n);
  return t;
}
const Zf = (e, t, n, { allOwnKeys: r } = {}) => (Cn(t, (o, i) => {
  n && Ne(o) ? e[i] = Os(o, n) : e[i] = o;
}, { allOwnKeys: r }), e), Xf = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Hf = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Bf = (e, t, n, r) => {
  let o, i, a;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      a = o[i], (!r || r(a, e, t)) && !s[a] && (t[a] = e[a], s[a] = !0);
    e = n !== !1 && ji(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Vf = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, Wf = (e) => {
  if (!e) return null;
  if (Yt(e)) return e;
  let t = e.length;
  if (!Ts(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Jf = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && ji(Uint8Array)), Yf = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const o = r.value;
    t.call(e, o[0], o[1]);
  }
}, $f = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Qf = Ge("HTMLFormElement"), qf = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, n, r) {
    return n.toUpperCase() + r;
  }
), oa = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), ed = Ge("RegExp"), js = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Cn(n, (o, i) => {
    let a;
    (a = t(o, i, e)) !== !1 && (r[i] = a || o);
  }), Object.defineProperties(e, r);
}, td = (e) => {
  js(e, (t, n) => {
    if (Ne(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Ne(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, nd = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((i) => {
      n[i] = !0;
    });
  };
  return Yt(e) ? r(e) : r(String(e).split(t)), n;
}, rd = () => {
}, od = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, Xo = "abcdefghijklmnopqrstuvwxyz", ia = "0123456789", Cs = {
  DIGIT: ia,
  ALPHA: Xo,
  ALPHA_DIGIT: Xo + Xo.toUpperCase() + ia
}, id = (e = 16, t = Cs.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function ad(e) {
  return !!(e && Ne(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const sd = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (Kr(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const i = Yt(r) ? [] : {};
        return Cn(r, (a, s) => {
          const u = n(a, o + 1);
          !Mn(u) && (i[s] = u);
        }), t[o] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, ud = Ge("AsyncFunction"), ld = (e) => e && (Kr(e) || Ne(e)) && Ne(e.then) && Ne(e.catch), k = {
  isArray: Yt,
  isArrayBuffer: Es,
  isBuffer: Tf,
  isFormData: Lf,
  isArrayBufferView: Af,
  isString: Mf,
  isNumber: Ts,
  isBoolean: kf,
  isObject: Kr,
  isPlainObject: vr,
  isReadableStream: Ff,
  isRequest: Uf,
  isResponse: zf,
  isHeaders: Kf,
  isUndefined: Mn,
  isDate: jf,
  isFile: Cf,
  isBlob: Df,
  isRegExp: ed,
  isFunction: Ne,
  isStream: Nf,
  isURLSearchParams: If,
  isTypedArray: Jf,
  isFileList: Rf,
  forEach: Cn,
  merge: ui,
  extend: Zf,
  trim: Gf,
  stripBOM: Xf,
  inherits: Hf,
  toFlatObject: Bf,
  kindOf: Ur,
  kindOfTest: Ge,
  endsWith: Vf,
  toArray: Wf,
  forEachEntry: Yf,
  matchAll: $f,
  isHTMLForm: Qf,
  hasOwnProperty: oa,
  hasOwnProp: oa,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: js,
  freezeMethods: td,
  toObjectSet: nd,
  toCamelCase: qf,
  noop: rd,
  toFiniteNumber: od,
  findKey: As,
  global: Ms,
  isContextDefined: ks,
  ALPHABET: Cs,
  generateString: id,
  isSpecCompliantForm: ad,
  toJSONObject: sd,
  isAsyncFn: ud,
  isThenable: ld
};
function Z(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o);
}
k.inherits(Z, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: k.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Ds = Z.prototype, Rs = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Rs[e] = { value: e };
});
Object.defineProperties(Z, Rs);
Object.defineProperty(Ds, "isAxiosError", { value: !0 });
Z.from = (e, t, n, r, o, i) => {
  const a = Object.create(Ds);
  return k.toFlatObject(e, a, function(s) {
    return s !== Error.prototype;
  }, (s) => s !== "isAxiosError"), Z.call(a, e.message, t, n, r, o), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
const cd = null;
function li(e) {
  return k.isPlainObject(e) || k.isArray(e);
}
function Ns(e) {
  return k.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function aa(e, t, n) {
  return e ? e.concat(t).map(function(r, o) {
    return r = Ns(r), !n && o ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
function fd(e) {
  return k.isArray(e) && !e.some(li);
}
const dd = k.toFlatObject(k, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Gr(e, t, n) {
  if (!k.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = k.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(v, p) {
    return !k.isUndefined(p[v]);
  });
  const r = n.metaTokens, o = n.visitor || l, i = n.dots, a = n.indexes, s = (n.Blob || typeof Blob < "u" && Blob) && k.isSpecCompliantForm(t);
  if (!k.isFunction(o))
    throw new TypeError("visitor must be a function");
  function u(v) {
    if (v === null) return "";
    if (k.isDate(v))
      return v.toISOString();
    if (!s && k.isBlob(v))
      throw new Z("Blob is not supported. Use a Buffer instead.");
    return k.isArrayBuffer(v) || k.isTypedArray(v) ? s && typeof Blob == "function" ? new Blob([v]) : Buffer.from(v) : v;
  }
  function l(v, p, S) {
    let _ = v;
    if (v && !S && typeof v == "object") {
      if (k.endsWith(p, "{}"))
        p = r ? p : p.slice(0, -2), v = JSON.stringify(v);
      else if (k.isArray(v) && fd(v) || (k.isFileList(v) || k.endsWith(p, "[]")) && (_ = k.toArray(v)))
        return p = Ns(p), _.forEach(function(g, b) {
          !(k.isUndefined(g) || g === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? aa([p], b, i) : a === null ? p : p + "[]",
            u(g)
          );
        }), !1;
    }
    return li(v) ? !0 : (t.append(aa(S, p, i), u(v)), !1);
  }
  const f = [], d = Object.assign(dd, {
    defaultVisitor: l,
    convertValue: u,
    isVisitable: li
  });
  function y(v, p) {
    if (!k.isUndefined(v)) {
      if (f.indexOf(v) !== -1)
        throw Error("Circular reference detected in " + p.join("."));
      f.push(v), k.forEach(v, function(S, _) {
        (!(k.isUndefined(S) || S === null) && o.call(
          t,
          S,
          k.isString(_) ? _.trim() : _,
          p,
          d
        )) === !0 && y(S, p ? p.concat(_) : [_]);
      }), f.pop();
    }
  }
  if (!k.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), t;
}
function sa(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Ci(e, t) {
  this._pairs = [], e && Gr(e, this, t);
}
const Ls = Ci.prototype;
Ls.append = function(e, t) {
  this._pairs.push([e, t]);
};
Ls.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, sa);
  } : sa;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
function pd(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Is(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || pd, o = n && n.serialize;
  let i;
  if (o ? i = o(t, n) : i = k.isURLSearchParams(t) ? t.toString() : new Ci(t, n).toString(r), i) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class ua {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    k.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const Fs = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, hd = typeof URLSearchParams < "u" ? URLSearchParams : Ci, vd = typeof FormData < "u" ? FormData : null, md = typeof Blob < "u" ? Blob : null, yd = {
  isBrowser: !0,
  classes: {
    URLSearchParams: hd,
    FormData: vd,
    Blob: md
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Di = typeof window < "u" && typeof document < "u", gd = ((e) => Di && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), bd = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", wd = Di && window.location.href || "http://localhost", Sd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Di,
  hasStandardBrowserEnv: gd,
  hasStandardBrowserWebWorkerEnv: bd,
  origin: wd
}, Symbol.toStringTag, { value: "Module" })), ze = {
  ...Sd,
  ...yd
};
function Pd(e, t) {
  return Gr(e, new ze.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, i) {
      return ze.isNode && k.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function xd(e) {
  return k.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function _d(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let i;
  for (r = 0; r < o; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function Us(e) {
  function t(n, r, o, i) {
    let a = n[i++];
    if (a === "__proto__") return !0;
    const s = Number.isFinite(+a), u = i >= n.length;
    return a = !a && k.isArray(o) ? o.length : a, u ? (k.hasOwnProp(o, a) ? o[a] = [o[a], r] : o[a] = r, !s) : ((!o[a] || !k.isObject(o[a])) && (o[a] = []), t(n, r, o[a], i) && k.isArray(o[a]) && (o[a] = _d(o[a])), !s);
  }
  if (k.isFormData(e) && k.isFunction(e.entries)) {
    const n = {};
    return k.forEachEntry(e, (r, o) => {
      t(xd(r), o, n, 0);
    }), n;
  }
  return null;
}
function Od(e, t, n) {
  if (k.isString(e))
    try {
      return (t || JSON.parse)(e), k.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (0, JSON.stringify)(e);
}
const Dn = {
  transitional: Fs,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const n = t.getContentType() || "", r = n.indexOf("application/json") > -1, o = k.isObject(e);
    if (o && k.isHTMLForm(e) && (e = new FormData(e)), k.isFormData(e))
      return r ? JSON.stringify(Us(e)) : e;
    if (k.isArrayBuffer(e) || k.isBuffer(e) || k.isStream(e) || k.isFile(e) || k.isBlob(e) || k.isReadableStream(e))
      return e;
    if (k.isArrayBufferView(e))
      return e.buffer;
    if (k.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let i;
    if (o) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Pd(e, this.formSerializer).toString();
      if ((i = k.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const a = this.env && this.env.FormData;
        return Gr(
          i ? { "files[]": e } : e,
          a && new a(),
          this.formSerializer
        );
      }
    }
    return o || r ? (t.setContentType("application/json", !1), Od(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || Dn.transitional, n = t && t.forcedJSONParsing, r = this.responseType === "json";
    if (k.isResponse(e) || k.isReadableStream(e))
      return e;
    if (e && k.isString(e) && (n && !this.responseType || r)) {
      const o = !(t && t.silentJSONParsing) && r;
      try {
        return JSON.parse(e);
      } catch (i) {
        if (o)
          throw i.name === "SyntaxError" ? Z.from(i, Z.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: ze.classes.FormData,
    Blob: ze.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
k.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Dn.headers[e] = {};
});
const Ed = k.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Td = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), n = i.substring(0, o).trim().toLowerCase(), r = i.substring(o + 1).trim(), !(!n || t[n] && Ed[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, la = Symbol("internals");
function Pn(e) {
  return e && String(e).trim().toLowerCase();
}
function mr(e) {
  return e === !1 || e == null ? e : k.isArray(e) ? e.map(mr) : String(e);
}
function Ad(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const Md = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Ho(e, t, n, r, o) {
  if (k.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!k.isString(t)) {
    if (k.isString(r))
      return t.indexOf(r) !== -1;
    if (k.isRegExp(r))
      return r.test(t);
  }
}
function kd(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function jd(e, t) {
  const n = k.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, i, a) {
        return this[r].call(this, t, o, i, a);
      },
      configurable: !0
    });
  });
}
class Ae {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const o = this;
    function i(s, u, l) {
      const f = Pn(u);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const d = k.findKey(o, f);
      (!d || o[d] === void 0 || l === !0 || l === void 0 && o[d] !== !1) && (o[d || u] = mr(s));
    }
    const a = (s, u) => k.forEach(s, (l, f) => i(l, f, u));
    if (k.isPlainObject(t) || t instanceof this.constructor)
      a(t, n);
    else if (k.isString(t) && (t = t.trim()) && !Md(t))
      a(Td(t), n);
    else if (k.isHeaders(t))
      for (const [s, u] of t.entries())
        i(u, s, r);
    else
      t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = Pn(t), t) {
      const r = k.findKey(this, t);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return Ad(o);
        if (k.isFunction(n))
          return n.call(this, o, r);
        if (k.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Pn(t), t) {
      const r = k.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Ho(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let o = !1;
    function i(a) {
      if (a = Pn(a), a) {
        const s = k.findKey(r, a);
        s && (!n || Ho(r, r[s], s, n)) && (delete r[s], o = !0);
      }
    }
    return k.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || Ho(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, r = {};
    return k.forEach(this, (o, i) => {
      const a = k.findKey(r, i);
      if (a) {
        n[a] = mr(o), delete n[i];
        return;
      }
      const s = t ? kd(i) : String(i).trim();
      s !== i && delete n[i], n[s] = mr(o), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return k.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = t && k.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(t) {
    const n = (this[la] = this[la] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function o(i) {
      const a = Pn(i);
      n[a] || (jd(r, i), n[a] = !0);
    }
    return k.isArray(t) ? t.forEach(o) : o(t), this;
  }
}
Ae.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
k.reduceDescriptors(Ae.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
k.freezeMethods(Ae);
function Bo(e, t) {
  const n = this || Dn, r = t || n, o = Ae.from(r.headers);
  let i = r.data;
  return k.forEach(e, function(a) {
    i = a.call(n, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function zs(e) {
  return !!(e && e.__CANCEL__);
}
function $t(e, t, n) {
  Z.call(this, e ?? "canceled", Z.ERR_CANCELED, t, n), this.name = "CanceledError";
}
k.inherits($t, Z, {
  __CANCEL__: !0
});
function Ks(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new Z(
    "Request failed with status code " + n.status,
    [Z.ERR_BAD_REQUEST, Z.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function Cd(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Dd(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(s) {
    const u = Date.now(), l = r[i];
    a || (a = u), n[o] = s, r[o] = u;
    let f = i, d = 0;
    for (; f !== o; )
      d += n[f++], f = f % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), u - a < t)
      return;
    const y = l && u - l;
    return y ? Math.round(d * 1e3 / y) : void 0;
  };
}
function Rd(e, t) {
  let n = 0;
  const r = 1e3 / t;
  let o = null;
  return function() {
    const i = this === !0, a = Date.now();
    if (i || a - n > r)
      return o && (clearTimeout(o), o = null), n = a, e.apply(null, arguments);
    o || (o = setTimeout(() => (o = null, n = Date.now(), e.apply(null, arguments)), r - (a - n)));
  };
}
const Ar = (e, t, n = 3) => {
  let r = 0;
  const o = Dd(50, 250);
  return Rd((i) => {
    const a = i.loaded, s = i.lengthComputable ? i.total : void 0, u = a - r, l = o(u), f = a <= s;
    r = a;
    const d = {
      loaded: a,
      total: s,
      progress: s ? a / s : void 0,
      bytes: u,
      rate: l || void 0,
      estimated: l && s && f ? (s - a) / l : void 0,
      event: i,
      lengthComputable: s != null
    };
    d[t ? "download" : "upload"] = !0, e(d);
  }, n);
}, Nd = ze.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a");
    let n;
    function r(o) {
      let i = o;
      return e && (t.setAttribute("href", i), i = t.href), t.setAttribute("href", i), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return n = r(window.location.href), function(o) {
      const i = k.isString(o) ? r(o) : o;
      return i.protocol === n.protocol && i.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), Ld = ze.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, o, i) {
      const a = [e + "=" + encodeURIComponent(t)];
      k.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), k.isString(r) && a.push("path=" + r), k.isString(o) && a.push("domain=" + o), i === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Id(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Fd(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Gs(e, t) {
  return e && !Id(t) ? Fd(e, t) : t;
}
const ca = (e) => e instanceof Ae ? { ...e } : e;
function bt(e, t) {
  t = t || {};
  const n = {};
  function r(l, f, d) {
    return k.isPlainObject(l) && k.isPlainObject(f) ? k.merge.call({ caseless: d }, l, f) : k.isPlainObject(f) ? k.merge({}, f) : k.isArray(f) ? f.slice() : f;
  }
  function o(l, f, d) {
    if (k.isUndefined(f)) {
      if (!k.isUndefined(l))
        return r(void 0, l, d);
    } else return r(l, f, d);
  }
  function i(l, f) {
    if (!k.isUndefined(f))
      return r(void 0, f);
  }
  function a(l, f) {
    if (k.isUndefined(f)) {
      if (!k.isUndefined(l))
        return r(void 0, l);
    } else return r(void 0, f);
  }
  function s(l, f, d) {
    if (d in t)
      return r(l, f);
    if (d in e)
      return r(void 0, l);
  }
  const u = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: s,
    headers: (l, f) => o(ca(l), ca(f), !0)
  };
  return k.forEach(Object.keys(Object.assign({}, e, t)), function(l) {
    const f = u[l] || o, d = f(e[l], t[l], l);
    k.isUndefined(d) && f !== s || (n[l] = d);
  }), n;
}
const Zs = (e) => {
  const t = bt({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: o, xsrfCookieName: i, headers: a, auth: s } = t;
  t.headers = a = Ae.from(a), t.url = Is(Gs(t.baseURL, t.url), e.params, e.paramsSerializer), s && a.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let u;
  if (k.isFormData(n)) {
    if (ze.hasStandardBrowserEnv || ze.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if ((u = a.getContentType()) !== !1) {
      const [l, ...f] = u ? u.split(";").map((d) => d.trim()).filter(Boolean) : [];
      a.setContentType([l || "multipart/form-data", ...f].join("; "));
    }
  }
  if (ze.hasStandardBrowserEnv && (r && k.isFunction(r) && (r = r(t)), r || r !== !1 && Nd(t.url))) {
    const l = o && i && Ld.read(i);
    l && a.set(o, l);
  }
  return t;
}, Ud = typeof XMLHttpRequest < "u", zd = Ud && function(e) {
  return new Promise(function(t, n) {
    const r = Zs(e);
    let o = r.data;
    const i = Ae.from(r.headers).normalize();
    let { responseType: a } = r, s;
    function u() {
      r.cancelToken && r.cancelToken.unsubscribe(s), r.signal && r.signal.removeEventListener("abort", s);
    }
    let l = new XMLHttpRequest();
    l.open(r.method.toUpperCase(), r.url, !0), l.timeout = r.timeout;
    function f() {
      if (!l)
        return;
      const y = Ae.from(
        "getAllResponseHeaders" in l && l.getAllResponseHeaders()
      ), v = {
        data: !a || a === "text" || a === "json" ? l.responseText : l.response,
        status: l.status,
        statusText: l.statusText,
        headers: y,
        config: e,
        request: l
      };
      Ks(function(p) {
        t(p), u();
      }, function(p) {
        n(p), u();
      }, v), l = null;
    }
    "onloadend" in l ? l.onloadend = f : l.onreadystatechange = function() {
      !l || l.readyState !== 4 || l.status === 0 && !(l.responseURL && l.responseURL.indexOf("file:") === 0) || setTimeout(f);
    }, l.onabort = function() {
      l && (n(new Z("Request aborted", Z.ECONNABORTED, r, l)), l = null);
    }, l.onerror = function() {
      n(new Z("Network Error", Z.ERR_NETWORK, r, l)), l = null;
    }, l.ontimeout = function() {
      let y = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const v = r.transitional || Fs;
      r.timeoutErrorMessage && (y = r.timeoutErrorMessage), n(new Z(
        y,
        v.clarifyTimeoutError ? Z.ETIMEDOUT : Z.ECONNABORTED,
        r,
        l
      )), l = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in l && k.forEach(i.toJSON(), function(y, v) {
      l.setRequestHeader(v, y);
    }), k.isUndefined(r.withCredentials) || (l.withCredentials = !!r.withCredentials), a && a !== "json" && (l.responseType = r.responseType), typeof r.onDownloadProgress == "function" && l.addEventListener("progress", Ar(r.onDownloadProgress, !0)), typeof r.onUploadProgress == "function" && l.upload && l.upload.addEventListener("progress", Ar(r.onUploadProgress)), (r.cancelToken || r.signal) && (s = (y) => {
      l && (n(!y || y.type ? new $t(null, e, l) : y), l.abort(), l = null);
    }, r.cancelToken && r.cancelToken.subscribe(s), r.signal && (r.signal.aborted ? s() : r.signal.addEventListener("abort", s)));
    const d = Cd(r.url);
    if (d && ze.protocols.indexOf(d) === -1) {
      n(new Z("Unsupported protocol " + d + ":", Z.ERR_BAD_REQUEST, e));
      return;
    }
    l.send(o || null);
  });
}, Kd = (e, t) => {
  let n = new AbortController(), r;
  const o = function(u) {
    if (!r) {
      r = !0, a();
      const l = u instanceof Error ? u : this.reason;
      n.abort(l instanceof Z ? l : new $t(l instanceof Error ? l.message : l));
    }
  };
  let i = t && setTimeout(() => {
    o(new Z(`timeout ${t} of ms exceeded`, Z.ETIMEDOUT));
  }, t);
  const a = () => {
    e && (i && clearTimeout(i), i = null, e.forEach((u) => {
      u && (u.removeEventListener ? u.removeEventListener("abort", o) : u.unsubscribe(o));
    }), e = null);
  };
  e.forEach((u) => u && u.addEventListener && u.addEventListener("abort", o));
  const { signal: s } = n;
  return s.unsubscribe = a, [s, () => {
    i && clearTimeout(i), i = null;
  }];
}, Gd = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, o;
  for (; r < n; )
    o = r + t, yield e.slice(r, o), r = o;
}, Zd = async function* (e, t, n) {
  for await (const r of e)
    yield* Gd(ArrayBuffer.isView(r) ? r : await n(String(r)), t);
}, fa = (e, t, n, r, o) => {
  const i = Zd(e, t, o);
  let a = 0;
  return new ReadableStream({
    type: "bytes",
    async pull(s) {
      const { done: u, value: l } = await i.next();
      if (u) {
        s.close(), r();
        return;
      }
      let f = l.byteLength;
      n && n(a += f), s.enqueue(new Uint8Array(l));
    },
    cancel(s) {
      return r(s), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, da = (e, t) => {
  const n = e != null;
  return (r) => setTimeout(() => t({
    lengthComputable: n,
    total: e,
    loaded: r
  }));
}, Zr = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Xs = Zr && typeof ReadableStream == "function", ci = Zr && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Xd = Xs && (() => {
  let e = !1;
  const t = new Request(ze.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
})(), pa = 64 * 1024, fi = Xs && !!(() => {
  try {
    return k.isReadableStream(new Response("").body);
  } catch {
  }
})(), Mr = {
  stream: fi && ((e) => e.body)
};
Zr && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Mr[t] && (Mr[t] = k.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new Z(`Response type '${t}' is not supported`, Z.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const Hd = async (e) => {
  if (e == null)
    return 0;
  if (k.isBlob(e))
    return e.size;
  if (k.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (k.isArrayBufferView(e))
    return e.byteLength;
  if (k.isURLSearchParams(e) && (e = e + ""), k.isString(e))
    return (await ci(e)).byteLength;
}, Bd = async (e, t) => k.toFiniteNumber(e.getContentLength()) ?? Hd(t), Vd = Zr && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: o,
    cancelToken: i,
    timeout: a,
    onDownloadProgress: s,
    onUploadProgress: u,
    responseType: l,
    headers: f,
    withCredentials: d = "same-origin",
    fetchOptions: y
  } = Zs(e);
  l = l ? (l + "").toLowerCase() : "text";
  let [v, p] = o || i || a ? Kd([o, i], a) : [], S, _;
  const g = () => {
    !S && setTimeout(() => {
      v && v.unsubscribe();
    }), S = !0;
  };
  let b;
  try {
    if (u && Xd && n !== "get" && n !== "head" && (b = await Bd(f, r)) !== 0) {
      let x = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), A;
      k.isFormData(r) && (A = x.headers.get("content-type")) && f.setContentType(A), x.body && (r = fa(x.body, pa, da(
        b,
        Ar(u)
      ), null, ci));
    }
    k.isString(d) || (d = d ? "cors" : "omit"), _ = new Request(t, {
      ...y,
      signal: v,
      method: n.toUpperCase(),
      headers: f.normalize().toJSON(),
      body: r,
      duplex: "half",
      withCredentials: d
    });
    let h = await fetch(_);
    const m = fi && (l === "stream" || l === "response");
    if (fi && (s || m)) {
      const x = {};
      ["status", "statusText", "headers"].forEach((N) => {
        x[N] = h[N];
      });
      const A = k.toFiniteNumber(h.headers.get("content-length"));
      h = new Response(
        fa(h.body, pa, s && da(
          A,
          Ar(s, !0)
        ), m && g, ci),
        x
      );
    }
    l = l || "text";
    let P = await Mr[k.findKey(Mr, l) || "text"](h, e);
    return !m && g(), p && p(), await new Promise((x, A) => {
      Ks(x, A, {
        data: P,
        headers: Ae.from(h.headers),
        status: h.status,
        statusText: h.statusText,
        config: e,
        request: _
      });
    });
  } catch (h) {
    throw g(), h && h.name === "TypeError" && /fetch/i.test(h.message) ? Object.assign(
      new Z("Network Error", Z.ERR_NETWORK, e, _),
      {
        cause: h.cause || h
      }
    ) : Z.from(h, h && h.code, e, _);
  }
}), di = {
  http: cd,
  xhr: zd,
  fetch: Vd
};
k.forEach(di, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const ha = (e) => `- ${e}`, Wd = (e) => k.isFunction(e) || e === null || e === !1, Hs = {
  getAdapter: (e) => {
    e = k.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const o = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let a;
      if (r = n, !Wd(n) && (r = di[(a = String(n)).toLowerCase()], r === void 0))
        throw new Z(`Unknown adapter '${a}'`);
      if (r)
        break;
      o[a || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(o).map(
        ([s, u]) => `adapter ${s} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = t ? i.length > 1 ? `since :
` + i.map(ha).join(`
`) : " " + ha(i[0]) : "as no adapter specified";
      throw new Z(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: di
};
function Vo(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new $t(null, e);
}
function va(e) {
  return Vo(e), e.headers = Ae.from(e.headers), e.data = Bo.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Hs.getAdapter(e.adapter || Dn.adapter)(e).then(function(t) {
    return Vo(e), t.data = Bo.call(
      e,
      e.transformResponse,
      t
    ), t.headers = Ae.from(t.headers), t;
  }, function(t) {
    return zs(t) || (Vo(e), t && t.response && (t.response.data = Bo.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = Ae.from(t.response.headers))), Promise.reject(t);
  });
}
const Bs = "1.7.2", Ri = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Ri[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ma = {};
Ri.transitional = function(e, t, n) {
  function r(o, i) {
    return "[Axios v" + Bs + "] Transitional option '" + o + "'" + i + (n ? ". " + n : "");
  }
  return (o, i, a) => {
    if (e === !1)
      throw new Z(
        r(i, " has been removed" + (t ? " in " + t : "")),
        Z.ERR_DEPRECATED
      );
    return t && !ma[i] && (ma[i] = !0, console.warn(
      r(
        i,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(o, i, a) : !0;
  };
};
function Jd(e, t, n) {
  if (typeof e != "object")
    throw new Z("options must be an object", Z.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const i = r[o], a = t[i];
    if (a) {
      const s = e[i], u = s === void 0 || a(s, i, e);
      if (u !== !0)
        throw new Z("option " + i + " must be " + u, Z.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new Z("Unknown option " + i, Z.ERR_BAD_OPTION);
  }
}
const pi = {
  assertOptions: Jd,
  validators: Ri
}, rt = pi.validators;
class vt {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new ua(),
      response: new ua()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const i = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = bt(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: i } = n;
    r !== void 0 && pi.assertOptions(r, {
      silentJSONParsing: rt.transitional(rt.boolean),
      forcedJSONParsing: rt.transitional(rt.boolean),
      clarifyTimeoutError: rt.transitional(rt.boolean)
    }, !1), o != null && (k.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : pi.assertOptions(o, {
      encode: rt.function,
      serialize: rt.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a = i && k.merge(
      i.common,
      i[n.method]
    );
    i && k.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete i[p];
      }
    ), n.headers = Ae.concat(a, i);
    const s = [];
    let u = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(n) === !1 || (u = u && p.synchronous, s.unshift(p.fulfilled, p.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(p) {
      l.push(p.fulfilled, p.rejected);
    });
    let f, d = 0, y;
    if (!u) {
      const p = [va.bind(this), void 0];
      for (p.unshift.apply(p, s), p.push.apply(p, l), y = p.length, f = Promise.resolve(n); d < y; )
        f = f.then(p[d++], p[d++]);
      return f;
    }
    y = s.length;
    let v = n;
    for (d = 0; d < y; ) {
      const p = s[d++], S = s[d++];
      try {
        v = p(v);
      } catch (_) {
        S.call(this, _);
        break;
      }
    }
    try {
      f = va.call(this, v);
    } catch (p) {
      return Promise.reject(p);
    }
    for (d = 0, y = l.length; d < y; )
      f = f.then(l[d++], l[d++]);
    return f;
  }
  getUri(t) {
    t = bt(this.defaults, t);
    const n = Gs(t.baseURL, t.url);
    return Is(n, t.params, t.paramsSerializer);
  }
}
k.forEach(["delete", "get", "head", "options"], function(e) {
  vt.prototype[e] = function(t, n) {
    return this.request(bt(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
k.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(r, o, i) {
      return this.request(bt(i || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: r,
        data: o
      }));
    };
  }
  vt.prototype[e] = t(), vt.prototype[e + "Form"] = t(!0);
});
class Ni {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const a = new Promise((s) => {
        r.subscribe(s), i = s;
      }).then(o);
      return a.cancel = function() {
        r.unsubscribe(i);
      }, a;
    }, t(function(o, i, a) {
      r.reason || (r.reason = new $t(o, i, a), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Ni(function(n) {
        t = n;
      }),
      cancel: t
    };
  }
}
function Yd(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function $d(e) {
  return k.isObject(e) && e.isAxiosError === !0;
}
const hi = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(hi).forEach(([e, t]) => {
  hi[t] = e;
});
function Vs(e) {
  const t = new vt(e), n = Os(vt.prototype.request, t);
  return k.extend(n, vt.prototype, t, { allOwnKeys: !0 }), k.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(r) {
    return Vs(bt(e, r));
  }, n;
}
const fe = Vs(Dn);
fe.Axios = vt;
fe.CanceledError = $t;
fe.CancelToken = Ni;
fe.isCancel = zs;
fe.VERSION = Bs;
fe.toFormData = Gr;
fe.AxiosError = Z;
fe.Cancel = fe.CanceledError;
fe.all = function(e) {
  return Promise.all(e);
};
fe.spread = Yd;
fe.isAxiosError = $d;
fe.mergeConfig = bt;
fe.AxiosHeaders = Ae;
fe.formToJSON = (e) => Us(k.isHTMLForm(e) ? new FormData(e) : e);
fe.getAdapter = Hs.getAdapter;
fe.HttpStatusCode = hi;
fe.default = fe;
var Qd = Error, qd = EvalError, ep = RangeError, tp = ReferenceError, Ws = SyntaxError, Xr = TypeError, np = URIError, rp = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, t = Symbol("test"), n = Object(t);
  if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var r = 42;
  e[t] = r;
  for (t in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var o = Object.getOwnPropertySymbols(e);
  if (o.length !== 1 || o[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var i = Object.getOwnPropertyDescriptor(e, t);
    if (i.value !== r || i.enumerable !== !0)
      return !1;
  }
  return !0;
}, ya = typeof Symbol < "u" && Symbol, op = rp, ip = function() {
  return typeof ya != "function" || typeof Symbol != "function" || typeof ya("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : op();
}, Wo = {
  __proto__: null,
  foo: {}
}, ap = Object, sp = function() {
  return { __proto__: Wo }.foo === Wo.foo && !(Wo instanceof ap);
}, up = "Function.prototype.bind called on incompatible ", lp = Object.prototype.toString, cp = Math.max, fp = "[object Function]", ga = function(e, t) {
  for (var n = [], r = 0; r < e.length; r += 1)
    n[r] = e[r];
  for (var o = 0; o < t.length; o += 1)
    n[o + e.length] = t[o];
  return n;
}, dp = function(e, t) {
  for (var n = [], r = t, o = 0; r < e.length; r += 1, o += 1)
    n[o] = e[r];
  return n;
}, pp = function(e, t) {
  for (var n = "", r = 0; r < e.length; r += 1)
    n += e[r], r + 1 < e.length && (n += t);
  return n;
}, hp = function(e) {
  var t = this;
  if (typeof t != "function" || lp.apply(t) !== fp)
    throw new TypeError(up + t);
  for (var n = dp(arguments, 1), r, o = function() {
    if (this instanceof r) {
      var l = t.apply(
        this,
        ga(n, arguments)
      );
      return Object(l) === l ? l : this;
    }
    return t.apply(
      e,
      ga(n, arguments)
    );
  }, i = cp(0, t.length - n.length), a = [], s = 0; s < i; s++)
    a[s] = "$" + s;
  if (r = Function("binder", "return function (" + pp(a, ",") + "){ return binder.apply(this,arguments); }")(o), t.prototype) {
    var u = function() {
    };
    u.prototype = t.prototype, r.prototype = new u(), u.prototype = null;
  }
  return r;
}, vp = hp, Li = Function.prototype.bind || vp, mp = Function.prototype.call, yp = Object.prototype.hasOwnProperty, gp = Li, bp = gp.call(mp, yp), W, wp = Qd, Sp = qd, Pp = ep, xp = tp, Bt = Ws, Zt = Xr, _p = np, Js = Function, Jo = function(e) {
  try {
    return Js('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, mt = Object.getOwnPropertyDescriptor;
if (mt)
  try {
    mt({}, "");
  } catch {
    mt = null;
  }
var Yo = function() {
  throw new Zt();
}, Op = mt ? function() {
  try {
    return arguments.callee, Yo;
  } catch {
    try {
      return mt(arguments, "callee").get;
    } catch {
      return Yo;
    }
  }
}() : Yo, Ft = ip(), Ep = sp(), de = Object.getPrototypeOf || (Ep ? function(e) {
  return e.__proto__;
} : null), zt = {}, Tp = typeof Uint8Array > "u" || !de ? W : de(Uint8Array), yt = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? W : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? W : ArrayBuffer,
  "%ArrayIteratorPrototype%": Ft && de ? de([][Symbol.iterator]()) : W,
  "%AsyncFromSyncIteratorPrototype%": W,
  "%AsyncFunction%": zt,
  "%AsyncGenerator%": zt,
  "%AsyncGeneratorFunction%": zt,
  "%AsyncIteratorPrototype%": zt,
  "%Atomics%": typeof Atomics > "u" ? W : Atomics,
  "%BigInt%": typeof BigInt > "u" ? W : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? W : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? W : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? W : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": wp,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": Sp,
  "%Float32Array%": typeof Float32Array > "u" ? W : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? W : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? W : FinalizationRegistry,
  "%Function%": Js,
  "%GeneratorFunction%": zt,
  "%Int8Array%": typeof Int8Array > "u" ? W : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? W : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? W : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": Ft && de ? de(de([][Symbol.iterator]())) : W,
  "%JSON%": typeof JSON == "object" ? JSON : W,
  "%Map%": typeof Map > "u" ? W : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !Ft || !de ? W : de((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? W : Promise,
  "%Proxy%": typeof Proxy > "u" ? W : Proxy,
  "%RangeError%": Pp,
  "%ReferenceError%": xp,
  "%Reflect%": typeof Reflect > "u" ? W : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? W : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !Ft || !de ? W : de((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? W : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": Ft && de ? de(""[Symbol.iterator]()) : W,
  "%Symbol%": Ft ? Symbol : W,
  "%SyntaxError%": Bt,
  "%ThrowTypeError%": Op,
  "%TypedArray%": Tp,
  "%TypeError%": Zt,
  "%Uint8Array%": typeof Uint8Array > "u" ? W : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? W : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? W : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? W : Uint32Array,
  "%URIError%": _p,
  "%WeakMap%": typeof WeakMap > "u" ? W : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? W : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? W : WeakSet
};
if (de)
  try {
    null.error;
  } catch (e) {
    var Ap = de(de(e));
    yt["%Error.prototype%"] = Ap;
  }
var Mp = function e(t) {
  var n;
  if (t === "%AsyncFunction%")
    n = Jo("async function () {}");
  else if (t === "%GeneratorFunction%")
    n = Jo("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    n = Jo("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var r = e("%AsyncGeneratorFunction%");
    r && (n = r.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var o = e("%AsyncGenerator%");
    o && de && (n = de(o.prototype));
  }
  return yt[t] = n, n;
}, ba = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Rn = Li, kr = bp, kp = Rn.call(Function.call, Array.prototype.concat), jp = Rn.call(Function.apply, Array.prototype.splice), wa = Rn.call(Function.call, String.prototype.replace), jr = Rn.call(Function.call, String.prototype.slice), Cp = Rn.call(Function.call, RegExp.prototype.exec), Dp = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Rp = /\\(\\)?/g, Np = function(e) {
  var t = jr(e, 0, 1), n = jr(e, -1);
  if (t === "%" && n !== "%")
    throw new Bt("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && t !== "%")
    throw new Bt("invalid intrinsic syntax, expected opening `%`");
  var r = [];
  return wa(e, Dp, function(o, i, a, s) {
    r[r.length] = a ? wa(s, Rp, "$1") : i || o;
  }), r;
}, Lp = function(e, t) {
  var n = e, r;
  if (kr(ba, n) && (r = ba[n], n = "%" + r[0] + "%"), kr(yt, n)) {
    var o = yt[n];
    if (o === zt && (o = Mp(n)), typeof o > "u" && !t)
      throw new Zt("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: r,
      name: n,
      value: o
    };
  }
  throw new Bt("intrinsic " + e + " does not exist!");
}, Qt = function(e, t) {
  if (typeof e != "string" || e.length === 0)
    throw new Zt("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof t != "boolean")
    throw new Zt('"allowMissing" argument must be a boolean');
  if (Cp(/^%?[^%]*%?$/, e) === null)
    throw new Bt("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = Np(e), r = n.length > 0 ? n[0] : "", o = Lp("%" + r + "%", t), i = o.name, a = o.value, s = !1, u = o.alias;
  u && (r = u[0], jp(n, kp([0, 1], u)));
  for (var l = 1, f = !0; l < n.length; l += 1) {
    var d = n[l], y = jr(d, 0, 1), v = jr(d, -1);
    if ((y === '"' || y === "'" || y === "`" || v === '"' || v === "'" || v === "`") && y !== v)
      throw new Bt("property names with quotes must have matching quotes");
    if ((d === "constructor" || !f) && (s = !0), r += "." + d, i = "%" + r + "%", kr(yt, i))
      a = yt[i];
    else if (a != null) {
      if (!(d in a)) {
        if (!t)
          throw new Zt("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (mt && l + 1 >= n.length) {
        var p = mt(a, d);
        f = !!p, f && "get" in p && !("originalValue" in p.get) ? a = p.get : a = a[d];
      } else
        f = kr(a, d), a = a[d];
      f && !s && (yt[i] = a);
    }
  }
  return a;
}, Ys = { exports: {} }, $o, Sa;
function Ii() {
  if (Sa) return $o;
  Sa = 1;
  var e = Qt, t = e("%Object.defineProperty%", !0) || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return $o = t, $o;
}
var Ip = Qt, yr = Ip("%Object.getOwnPropertyDescriptor%", !0);
if (yr)
  try {
    yr([], "length");
  } catch {
    yr = null;
  }
var $s = yr, Pa = Ii(), Fp = Ws, Ut = Xr, xa = $s, Up = function(e, t, n) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new Ut("`obj` must be an object or a function`");
  if (typeof t != "string" && typeof t != "symbol")
    throw new Ut("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new Ut("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new Ut("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new Ut("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new Ut("`loose`, if provided, must be a boolean");
  var r = arguments.length > 3 ? arguments[3] : null, o = arguments.length > 4 ? arguments[4] : null, i = arguments.length > 5 ? arguments[5] : null, a = arguments.length > 6 ? arguments[6] : !1, s = !!xa && xa(e, t);
  if (Pa)
    Pa(e, t, {
      configurable: i === null && s ? s.configurable : !i,
      enumerable: r === null && s ? s.enumerable : !r,
      value: n,
      writable: o === null && s ? s.writable : !o
    });
  else if (a || !r && !o && !i)
    e[t] = n;
  else
    throw new Fp("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, vi = Ii(), Qs = function() {
  return !!vi;
};
Qs.hasArrayLengthDefineBug = function() {
  if (!vi)
    return null;
  try {
    return vi([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var zp = Qs, Kp = Qt, _a = Up, Gp = zp(), Oa = $s, Ea = Xr, Zp = Kp("%Math.floor%"), Xp = function(e, t) {
  if (typeof e != "function")
    throw new Ea("`fn` is not a function");
  if (typeof t != "number" || t < 0 || t > 4294967295 || Zp(t) !== t)
    throw new Ea("`length` must be a positive 32-bit integer");
  var n = arguments.length > 2 && !!arguments[2], r = !0, o = !0;
  if ("length" in e && Oa) {
    var i = Oa(e, "length");
    i && !i.configurable && (r = !1), i && !i.writable && (o = !1);
  }
  return (r || o || !n) && (Gp ? _a(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    t,
    !0,
    !0
  ) : _a(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    t
  )), e;
};
(function(e) {
  var t = Li, n = Qt, r = Xp, o = Xr, i = n("%Function.prototype.apply%"), a = n("%Function.prototype.call%"), s = n("%Reflect.apply%", !0) || t.call(a, i), u = Ii(), l = n("%Math.max%");
  e.exports = function(d) {
    if (typeof d != "function")
      throw new o("a function is required");
    var y = s(t, a, arguments);
    return r(
      y,
      1 + l(0, d.length - (arguments.length - 1)),
      !0
    );
  };
  var f = function() {
    return s(t, i, arguments);
  };
  u ? u(e.exports, "apply", { value: f }) : e.exports.apply = f;
})(Ys);
var Hp = Ys.exports, qs = Qt, eu = Hp, Bp = eu(qs("String.prototype.indexOf")), Vp = function(e, t) {
  var n = qs(e, !!t);
  return typeof n == "function" && Bp(e, ".prototype.") > -1 ? eu(n) : n;
};
const Wp = {}, Jp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wp
}, Symbol.toStringTag, { value: "Module" })), Yp = /* @__PURE__ */ cc(Jp);
var tu = typeof Map == "function" && Map.prototype, Qo = Object.getOwnPropertyDescriptor && tu ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
tu && Qo && typeof Qo.get == "function" && Qo.get;
var nu = typeof Set == "function" && Set.prototype, qo = Object.getOwnPropertyDescriptor && nu ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
nu && qo && typeof qo.get == "function" && qo.get;
var $p = typeof WeakRef == "function" && WeakRef.prototype;
$p && WeakRef.prototype.deref;
var Ta = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Qp = typeof Symbol == "function" && typeof Symbol.iterator == "object", qp = Yp, Aa = qp.custom;
eh(Aa);
function eh(e) {
  if (Qp)
    return e && typeof e == "object" && e instanceof Symbol;
  if (typeof e == "symbol")
    return !0;
  if (!e || typeof e != "object" || !Ta)
    return !1;
  try {
    return Ta.call(e), !0;
  } catch {
  }
  return !1;
}
var ru = Qt, qt = Vp;
ru("%WeakMap%", !0);
ru("%Map%", !0);
qt("WeakMap.prototype.get", !0);
qt("WeakMap.prototype.set", !0);
qt("WeakMap.prototype.has", !0);
qt("Map.prototype.get", !0);
qt("Map.prototype.set", !0);
qt("Map.prototype.has", !0);
var th = String.prototype.replace, nh = /%20/g, ei = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, ou = {
  default: ei.RFC3986,
  formatters: {
    RFC1738: function(e) {
      return th.call(e, nh, "+");
    },
    RFC3986: function(e) {
      return String(e);
    }
  },
  RFC1738: ei.RFC1738,
  RFC3986: ei.RFC3986
}, rh = ou, ti = Object.prototype.hasOwnProperty, ht = Array.isArray, Ve = function() {
  for (var e = [], t = 0; t < 256; ++t)
    e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
  return e;
}(), oh = function(e) {
  for (; e.length > 1; ) {
    var t = e.pop(), n = t.obj[t.prop];
    if (ht(n)) {
      for (var r = [], o = 0; o < n.length; ++o)
        typeof n[o] < "u" && r.push(n[o]);
      t.obj[t.prop] = r;
    }
  }
}, iu = function(e, t) {
  for (var n = t && t.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, r = 0; r < e.length; ++r)
    typeof e[r] < "u" && (n[r] = e[r]);
  return n;
}, ih = function e(t, n, r) {
  if (!n)
    return t;
  if (typeof n != "object") {
    if (ht(t))
      t.push(n);
    else if (t && typeof t == "object")
      (r && (r.plainObjects || r.allowPrototypes) || !ti.call(Object.prototype, n)) && (t[n] = !0);
    else
      return [t, n];
    return t;
  }
  if (!t || typeof t != "object")
    return [t].concat(n);
  var o = t;
  return ht(t) && !ht(n) && (o = iu(t, r)), ht(t) && ht(n) ? (n.forEach(function(i, a) {
    if (ti.call(t, a)) {
      var s = t[a];
      s && typeof s == "object" && i && typeof i == "object" ? t[a] = e(s, i, r) : t.push(i);
    } else
      t[a] = i;
  }), t) : Object.keys(n).reduce(function(i, a) {
    var s = n[a];
    return ti.call(i, a) ? i[a] = e(i[a], s, r) : i[a] = s, i;
  }, o);
}, ah = function(e, t) {
  return Object.keys(t).reduce(function(n, r) {
    return n[r] = t[r], n;
  }, e);
}, sh = function(e, t, n) {
  var r = e.replace(/\+/g, " ");
  if (n === "iso-8859-1")
    return r.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(r);
  } catch {
    return r;
  }
}, uh = function(e, t, n, r, o) {
  if (e.length === 0)
    return e;
  var i = e;
  if (typeof e == "symbol" ? i = Symbol.prototype.toString.call(e) : typeof e != "string" && (i = String(e)), n === "iso-8859-1")
    return escape(i).replace(/%u[0-9a-f]{4}/gi, function(l) {
      return "%26%23" + parseInt(l.slice(2), 16) + "%3B";
    });
  for (var a = "", s = 0; s < i.length; ++s) {
    var u = i.charCodeAt(s);
    if (u === 45 || u === 46 || u === 95 || u === 126 || u >= 48 && u <= 57 || u >= 65 && u <= 90 || u >= 97 && u <= 122 || o === rh.RFC1738 && (u === 40 || u === 41)) {
      a += i.charAt(s);
      continue;
    }
    if (u < 128) {
      a = a + Ve[u];
      continue;
    }
    if (u < 2048) {
      a = a + (Ve[192 | u >> 6] + Ve[128 | u & 63]);
      continue;
    }
    if (u < 55296 || u >= 57344) {
      a = a + (Ve[224 | u >> 12] + Ve[128 | u >> 6 & 63] + Ve[128 | u & 63]);
      continue;
    }
    s += 1, u = 65536 + ((u & 1023) << 10 | i.charCodeAt(s) & 1023), a += Ve[240 | u >> 18] + Ve[128 | u >> 12 & 63] + Ve[128 | u >> 6 & 63] + Ve[128 | u & 63];
  }
  return a;
}, lh = function(e) {
  for (var t = [{ obj: { o: e }, prop: "o" }], n = [], r = 0; r < t.length; ++r)
    for (var o = t[r], i = o.obj[o.prop], a = Object.keys(i), s = 0; s < a.length; ++s) {
      var u = a[s], l = i[u];
      typeof l == "object" && l !== null && n.indexOf(l) === -1 && (t.push({ obj: i, prop: u }), n.push(l));
    }
  return oh(t), e;
}, ch = function(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, fh = function(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, dh = function(e, t) {
  return [].concat(e, t);
}, ph = function(e, t) {
  if (ht(e)) {
    for (var n = [], r = 0; r < e.length; r += 1)
      n.push(t(e[r]));
    return n;
  }
  return t(e);
}, hh = {
  arrayToObject: iu,
  assign: ah,
  combine: dh,
  compact: lh,
  decode: sh,
  encode: uh,
  isBuffer: fh,
  isRegExp: ch,
  maybeMap: ph,
  merge: ih
}, vh = hh, au = ou, mh = Date.prototype.toISOString, Ma = au.default;
vh.encode, au.formatters[Ma];
function yh(e) {
  return e !== null && typeof e == "object";
}
const ka = {
  debug: -1,
  log: 0,
  info: 0,
  warn: 1,
  error: 2
}, ja = [
  "#daa569",
  "#00ffff",
  "#385e0f",
  "#7fffd4",
  "#00c957",
  "#b0e0e6",
  "#4169e1",
  "#6a5acd",
  "#87ceeb",
  "#ffff00",
  "#e3cf57",
  "#ff9912",
  "#eb8e55",
  "#ffe384",
  "#40e0d0",
  "#a39480",
  "#d2691e",
  "#ff7d40",
  "#f0e68c",
  "#bc8f8f",
  "#c76114",
  "#734a12",
  "#5e2612",
  "#0000ff",
  "#3d59ab",
  "#1e90ff",
  "#03a89e",
  "#33a1c9",
  "#a020f0",
  "#a066d3",
  "#da70d6",
  "#dda0dd",
  "#688e23",
  "#2e8b57"
], gh = {
  debug: "#666666",
  log: "#bbbbbb",
  info: "#ffffff",
  warn: "#bbbbbb",
  error: "#bbbbbb"
}, bh = {
  debug: "debug",
  log: "log",
  info: "info",
  warn: "warn",
  error: "error"
}, wh = {
  debug: console.log,
  log: console.log,
  info: console.log,
  warn: console.warn,
  error: console.error
}, fr = {}, xn = (e, t = "warn", n, r) => {
  const o = ka[t] <= ka[e], i = r === "*" || n.includes(r);
  return o && i;
}, Sh = (e) => {
  if (!fr[e]) {
    const t = ja[Object.keys(fr).length % ja.length];
    fr[e] = t;
  }
  return fr[e];
}, Ph = (e, t, n) => {
  const r = Sh(t), o = gh[n], i = e[0];
  let a = `%c[${t}]%c[${bh[n]}]:`;
  i.forEach((u) => {
    yh(u) ? a += "%o" : a += "%s";
  });
  let s = [a, `color: ${r}`, `color: ${o}`];
  return s = s.concat(i), s;
}, _n = (e, t) => (...n) => wh[e].apply(console, Ph(n, t, e)), xh = {
  level: "warn",
  bizName: "*"
};
class _h {
  constructor(t) {
    Ee(this, "bizName"), Ee(this, "targetBizName"), Ee(this, "targetLevel"), t = { ...xh, ...t };
    const n = t;
    this.bizName = t.bizName, this.targetBizName = n.bizName, this.targetLevel = n.level;
  }
  debug(...t) {
    if (xn("debug", this.targetLevel, this.bizName, this.targetBizName))
      return _n("debug", this.bizName)(t);
  }
  log(...t) {
    if (xn("log", this.targetLevel, this.bizName, this.targetBizName))
      return _n("log", this.bizName)(t);
  }
  info(...t) {
    if (xn("info", this.targetLevel, this.bizName, this.targetBizName))
      return _n("info", this.bizName)(t);
  }
  warn(...t) {
    if (xn("warn", this.targetLevel, this.bizName, this.targetBizName))
      return _n("warn", this.bizName)(t);
  }
  error(...t) {
    if (xn("error", this.targetLevel, this.bizName, this.targetBizName))
      return _n("error", this.bizName)(t);
  }
}
const Re = new _h({
  level: "log",
  bizName: "oss"
});
function Oh(e) {
  if (typeof document < "u" && typeof window < "u" && typeof document.createElement == "function")
    return Eh(e);
}
const Ca = /* @__PURE__ */ new Set();
function Eh(e) {
  return new Promise((t, n) => {
    if (typeof e != "string" || !e.length)
      return Re.log({
        name: "MogicUtil",
        message: "Invalid Script Url",
        fileName: e
      }), n();
    if (Ca.has(e))
      return t();
    const r = document.createElement("script");
    r.setAttribute("src", e), r.setAttribute("data-namespace", e), r.onload = () => {
      t();
    }, r.onerror = () => {
      Re.log({
        name: "MogicUtil",
        message: "Script Load Error",
        fileName: e
      }), n();
    }, Ca.add(e), document.body.appendChild(r);
  });
}
function Da(e) {
  return typeof e == "string";
}
const Th = {
  endpoint: "oss-accelerate.aliyuncs.com",
  // instance level timeout for all operations, SDK 默认 1min
  timeout: 2 * 60 * 1e3,
  // 2min
  // retry when request error is net error or timeout, SDK 默认 0
  maxRetryTimes: 2,
  // SDK 默认 5min
  refreshInterval: 30 * 60 * 1e3,
  // 30min
  // 以上是OSS instance的配置
  // 设置并发上传的分片数量;
  parallel: 4,
  // 设置分片大小 0.5M; SDK 默认值为 1 MB，最小值为 100 KB
  partSize: 1024 * 1024,
  // 分片断点 15 MB; SDK 建议 100M
  partLimit: 15 * 1024 * 1024,
  // 简单上传的虚拟进度条
  fakeProgress: !1,
  // 业务指定的SDK地址，通过 script 加载
  sdkUrl: "https://creative-oss.getmogic.com/static/aliyun-oss-sdk-6.17.1.min.js"
}, su = class gr {
  constructor() {
    Ee(this, "ossClient"), Ee(this, "getOssClientPromise"), Ee(this, "credentials", {}), Ee(this, "options"), Ee(this, "checkpoints", {}), Ee(this, "progressListInSimpleMode", []), Ee(this, "progressTimer"), this.options = {};
  }
  setOptions(t = {}) {
    this.options = {
      ...Th,
      ...t
    }, gr.bindNetwork();
  }
  // ---- 初始化OSS客户端 ----
  initAliOSSClient() {
    return new Promise(async (t, n) => {
      var r, o, i, a;
      if (!this.options.getOssAccessKey)
        throw new Error("getOssAccessKey is required");
      try {
        const [s] = await Promise.all([
          this.options.getOssAccessKey(),
          Oh(this.options.sdkUrl)
        ]);
        if (!s)
          throw Re.log({
            name: "UploadOSS",
            message: `Fetch STS Error${JSON.stringify(s)}`
          }), s;
        this.credentials = s || {};
        const { accessKeyId: u, accessKeySecret: l, securityToken: f, bucketName: d, endpoint: y } = s || {};
        this.ossClient = new OSS({
          accessKeyId: u,
          accessKeySecret: l,
          stsToken: f,
          bucket: d,
          timeout: (r = this.options) == null ? void 0 : r.timeout,
          retryMax: (o = this.options) == null ? void 0 : o.maxRetryTimes,
          endpoint: y || ((i = this.options) == null ? void 0 : i.endpoint),
          refreshSTSTokenInterval: (a = this.options) == null ? void 0 : a.refreshInterval,
          refreshSTSToken: async () => {
            if (!this.options.getOssAccessKey)
              throw new Error("getOssAccessKey is required");
            const v = await this.options.getOssAccessKey();
            if (!v) {
              try {
                Re.log({
                  name: "UploadOSS",
                  message: `Refresh STS Error${JSON.stringify(v)}`
                });
              } catch (g) {
                console.log(g);
              }
              return {};
            }
            this.credentials = v || {};
            const { accessKeyId: p, accessKeySecret: S, securityToken: _ } = v || {};
            return { accessKeyId: p, accessKeySecret: S, securityToken: _ };
          }
        }), t();
      } catch (s) {
        console.log(s), this.getOssClientPromise = void 0, n(`Fetch STS Error${JSON.stringify(s)}`);
      }
    });
  }
  async ensureOSSClient() {
    var t;
    if (!((t = this.options) != null && t.sdkUrl))
      return Re.log({
        name: "UploadOSS",
        message: "SDK URL is required"
      }), console.warn("SDK URL is required");
    this.ossClient || (this.getOssClientPromise || (this.getOssClientPromise = this.initAliOSSClient()), await this.getOssClientPromise);
  }
  // ---- 上传回调 ----
  onBeforeLoad(t) {
    typeof t.onBeforeLoad == "function" && t.onBeforeLoad();
  }
  onProgress(t, n) {
    typeof n.onProgress == "function" && n.onProgress(t);
  }
  onComplete(t, n) {
    typeof n.onComplete == "function" && n.onComplete(t);
  }
  onError(t, n) {
    typeof n.onError == "function" && n.onError(t);
  }
  // ---- 前端模拟进度 ----
  add2ProgressList(t) {
    this.progressListInSimpleMode.push({ resource: t, timestamp: Date.now(), fakeSize: 0 });
  }
  removeFromProgressList(t) {
    this.progressListInSimpleMode = this.progressListInSimpleMode.filter((n) => n.resource.id !== t.id);
  }
  // 无脑上传单个文件，内部自动判断是简单、分片
  autoUpload(t) {
    const { file: n } = t;
    console.log(n.size, this.options), n.size > (this.options.partLimit || 0) ? this.partUpload(t) : this.simpleUpload(t);
  }
  uploadFile(t, n, r) {
    return new Promise((o, i) => {
      this.autoUpload({
        file: t,
        customPath: r,
        onComplete: async (a) => {
          o(a.url);
        },
        onProgress: n,
        onError: (a) => {
          i(a);
        }
      });
    });
  }
  // --- case 1 简单上传
  async simpleUpload(t) {
    var n, r, o;
    console.log("simple upload"), Re.log({
      name: "UploadOSS",
      message: "SimpleUploadStart",
      fileName: (n = t.file) == null ? void 0 : n.name
    }), this.onBeforeLoad(t);
    try {
      await this.ensureOSSClient();
    } catch (l) {
      this.onError(l, t);
      return;
    }
    (r = this.options) != null && r.fakeProgress && (this.add2ProgressList(t), this.progressTimer || (this.progressTimer = setInterval(() => {
      if (!this.progressListInSimpleMode.length)
        return this.clearProgressTimer();
      this.progressListInSimpleMode.forEach((l) => {
        l.fakeSize += gr.uploadSpeedBPS * (Date.now() - l.timestamp) / 1024;
        const f = Math.min(99, Math.floor(l.fakeSize / l.resource.file.size * 100));
        this.onProgress(f, l.resource), l.timestamp = Date.now(), f >= 99 && this.removeFromProgressList(l.resource);
      });
    }, 120)));
    const { file: i, customPath: a } = t || {}, s = ((o = this.credentials) == null ? void 0 : o.dir) || "", u = a || this.createFileName(i.name, i == null ? void 0 : i.uid);
    return this.ossClient.put(s + u, i).then(() => {
      const l = { url: `${this.credentials.host}/${s}${u}`, file: i };
      return this.removeFromProgressList(t), this.onComplete(l, t), l;
    }).catch((l) => {
      var f;
      console.log("SimpleUploadError", l, t), this.removeFromProgressList(t);
      try {
        Re.log({
          name: "UploadOSS",
          message: `SimpleUploadError - ${Da(l) ? l : JSON.stringify(l)}`,
          fileName: (f = t.file) == null ? void 0 : f.name
        });
      } catch (d) {
        console.log(d);
      }
      this.onError(l, t);
    });
  }
  // --- case 2 分片上传
  async partUpload(t) {
    var n;
    console.log("part upload"), Re.log({
      name: "UploadOSS",
      message: "PartUploadStart",
      fileName: (n = t.file) == null ? void 0 : n.name
    }), this.onBeforeLoad(t);
    try {
      await this.ensureOSSClient();
    } catch (r) {
      this.onError(r, t);
      return;
    }
    this.startPartUpload(t);
  }
  startPartUpload(t) {
    var n;
    const { file: r, _uniqueName: o, customPath: i } = t, a = ((n = this.credentials) == null ? void 0 : n.dir) || "", s = i || this.createFileName(r.name, r == null ? void 0 : r.uid);
    return t._uniqueName = o || a + s, this.ossClient.multipartUpload(t._uniqueName, r, {
      parallel: this.options.parallel,
      partSize: this.options.partSize,
      progress: (u, l) => {
        this.onProgress(Math.floor(u * 100), t), l && (this.checkpoints[l.uploadId] = l, t._cptUploadId = l.uploadId);
      },
      // 设置MIME
      ...this.options.partMIME ? { mime: this.options.partMIME } : null,
      // 设置断点
      ...t._cptUploadId && this.checkpoints[t._cptUploadId] ? { checkpoint: this.checkpoints[t._cptUploadId] } : null
    }).then(() => {
      const u = { url: `${this.credentials.host}/${a}${s}`, file: r };
      return this.onComplete(u, t), u;
    }).catch(async (u) => {
      var l;
      console.log("PartUploadError", u, t), Re.log({
        name: "UploadOSS",
        message: `PartUploadError - ${Da(u) ? u : JSON.stringify(u)}`,
        fileName: (l = t.file) == null ? void 0 : l.name
      }), this.abortPartUpload(t), this.onError(u, t);
    });
  }
  // case 3 暂停续传
  abortPartUpload(t) {
    var n, r;
    if (!(t != null && t._uniqueName))
      return;
    const o = (n = (t == null ? void 0 : t._cptUploadId) && this.checkpoints[t._cptUploadId]) == null ? void 0 : n.uploadId;
    if (!o) {
      Re.log({
        name: "UploadOSS",
        message: "AbortPartUpload",
        fileName: (r = t.file) == null ? void 0 : r.name
      });
      return;
    }
    try {
      this.ossClient.abortMultipartUpload(t == null ? void 0 : t._uniqueName, o);
    } catch (i) {
      console.log(i);
    }
  }
  createFileName(t, n) {
    return `${n || Date.now() + parseInt(`${Math.random() * 1e6}`, 10)}.${t.substring(t.lastIndexOf(".") + 1)}`;
  }
  destroy() {
    var t;
    Re.log("destroy oss client", this.ossClient), (t = this.ossClient) == null || t.cancel(), this.ossClient = null, this.credentials = {}, this.checkpoints = {}, this.clearProgressTimer();
  }
  clearProgressTimer() {
    this.progressTimer && clearInterval(this.progressTimer), this.progressTimer = void 0, this.progressListInSimpleMode = [];
  }
  // https://googlechrome.github.io/samples/network-information/
  static bindNetwork() {
    const t = navigator == null ? void 0 : navigator.connection;
    if (!(t != null && t.downlink)) {
      Re.log({
        name: "UploadOSS",
        message: "navigation.connection is not supported"
      });
      return;
    }
    t.addEventListener("change", n);
    function n() {
      gr.uploadSpeedBPS = t.downlink * 1024 * 1024 / 8;
    }
    n();
  }
};
Ee(su, "uploadSpeedBPS", 10 * 1024 * 1024);
let Ah = su;
xt() && new Ah();
var Mh = { exports: {} };
(function(e, t) {
  (function(n) {
    e.exports = n();
  })(function(n) {
    var r = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    function o(g, b) {
      var h = g[0], m = g[1], P = g[2], x = g[3];
      h += (m & P | ~m & x) + b[0] - 680876936 | 0, h = (h << 7 | h >>> 25) + m | 0, x += (h & m | ~h & P) + b[1] - 389564586 | 0, x = (x << 12 | x >>> 20) + h | 0, P += (x & h | ~x & m) + b[2] + 606105819 | 0, P = (P << 17 | P >>> 15) + x | 0, m += (P & x | ~P & h) + b[3] - 1044525330 | 0, m = (m << 22 | m >>> 10) + P | 0, h += (m & P | ~m & x) + b[4] - 176418897 | 0, h = (h << 7 | h >>> 25) + m | 0, x += (h & m | ~h & P) + b[5] + 1200080426 | 0, x = (x << 12 | x >>> 20) + h | 0, P += (x & h | ~x & m) + b[6] - 1473231341 | 0, P = (P << 17 | P >>> 15) + x | 0, m += (P & x | ~P & h) + b[7] - 45705983 | 0, m = (m << 22 | m >>> 10) + P | 0, h += (m & P | ~m & x) + b[8] + 1770035416 | 0, h = (h << 7 | h >>> 25) + m | 0, x += (h & m | ~h & P) + b[9] - 1958414417 | 0, x = (x << 12 | x >>> 20) + h | 0, P += (x & h | ~x & m) + b[10] - 42063 | 0, P = (P << 17 | P >>> 15) + x | 0, m += (P & x | ~P & h) + b[11] - 1990404162 | 0, m = (m << 22 | m >>> 10) + P | 0, h += (m & P | ~m & x) + b[12] + 1804603682 | 0, h = (h << 7 | h >>> 25) + m | 0, x += (h & m | ~h & P) + b[13] - 40341101 | 0, x = (x << 12 | x >>> 20) + h | 0, P += (x & h | ~x & m) + b[14] - 1502002290 | 0, P = (P << 17 | P >>> 15) + x | 0, m += (P & x | ~P & h) + b[15] + 1236535329 | 0, m = (m << 22 | m >>> 10) + P | 0, h += (m & x | P & ~x) + b[1] - 165796510 | 0, h = (h << 5 | h >>> 27) + m | 0, x += (h & P | m & ~P) + b[6] - 1069501632 | 0, x = (x << 9 | x >>> 23) + h | 0, P += (x & m | h & ~m) + b[11] + 643717713 | 0, P = (P << 14 | P >>> 18) + x | 0, m += (P & h | x & ~h) + b[0] - 373897302 | 0, m = (m << 20 | m >>> 12) + P | 0, h += (m & x | P & ~x) + b[5] - 701558691 | 0, h = (h << 5 | h >>> 27) + m | 0, x += (h & P | m & ~P) + b[10] + 38016083 | 0, x = (x << 9 | x >>> 23) + h | 0, P += (x & m | h & ~m) + b[15] - 660478335 | 0, P = (P << 14 | P >>> 18) + x | 0, m += (P & h | x & ~h) + b[4] - 405537848 | 0, m = (m << 20 | m >>> 12) + P | 0, h += (m & x | P & ~x) + b[9] + 568446438 | 0, h = (h << 5 | h >>> 27) + m | 0, x += (h & P | m & ~P) + b[14] - 1019803690 | 0, x = (x << 9 | x >>> 23) + h | 0, P += (x & m | h & ~m) + b[3] - 187363961 | 0, P = (P << 14 | P >>> 18) + x | 0, m += (P & h | x & ~h) + b[8] + 1163531501 | 0, m = (m << 20 | m >>> 12) + P | 0, h += (m & x | P & ~x) + b[13] - 1444681467 | 0, h = (h << 5 | h >>> 27) + m | 0, x += (h & P | m & ~P) + b[2] - 51403784 | 0, x = (x << 9 | x >>> 23) + h | 0, P += (x & m | h & ~m) + b[7] + 1735328473 | 0, P = (P << 14 | P >>> 18) + x | 0, m += (P & h | x & ~h) + b[12] - 1926607734 | 0, m = (m << 20 | m >>> 12) + P | 0, h += (m ^ P ^ x) + b[5] - 378558 | 0, h = (h << 4 | h >>> 28) + m | 0, x += (h ^ m ^ P) + b[8] - 2022574463 | 0, x = (x << 11 | x >>> 21) + h | 0, P += (x ^ h ^ m) + b[11] + 1839030562 | 0, P = (P << 16 | P >>> 16) + x | 0, m += (P ^ x ^ h) + b[14] - 35309556 | 0, m = (m << 23 | m >>> 9) + P | 0, h += (m ^ P ^ x) + b[1] - 1530992060 | 0, h = (h << 4 | h >>> 28) + m | 0, x += (h ^ m ^ P) + b[4] + 1272893353 | 0, x = (x << 11 | x >>> 21) + h | 0, P += (x ^ h ^ m) + b[7] - 155497632 | 0, P = (P << 16 | P >>> 16) + x | 0, m += (P ^ x ^ h) + b[10] - 1094730640 | 0, m = (m << 23 | m >>> 9) + P | 0, h += (m ^ P ^ x) + b[13] + 681279174 | 0, h = (h << 4 | h >>> 28) + m | 0, x += (h ^ m ^ P) + b[0] - 358537222 | 0, x = (x << 11 | x >>> 21) + h | 0, P += (x ^ h ^ m) + b[3] - 722521979 | 0, P = (P << 16 | P >>> 16) + x | 0, m += (P ^ x ^ h) + b[6] + 76029189 | 0, m = (m << 23 | m >>> 9) + P | 0, h += (m ^ P ^ x) + b[9] - 640364487 | 0, h = (h << 4 | h >>> 28) + m | 0, x += (h ^ m ^ P) + b[12] - 421815835 | 0, x = (x << 11 | x >>> 21) + h | 0, P += (x ^ h ^ m) + b[15] + 530742520 | 0, P = (P << 16 | P >>> 16) + x | 0, m += (P ^ x ^ h) + b[2] - 995338651 | 0, m = (m << 23 | m >>> 9) + P | 0, h += (P ^ (m | ~x)) + b[0] - 198630844 | 0, h = (h << 6 | h >>> 26) + m | 0, x += (m ^ (h | ~P)) + b[7] + 1126891415 | 0, x = (x << 10 | x >>> 22) + h | 0, P += (h ^ (x | ~m)) + b[14] - 1416354905 | 0, P = (P << 15 | P >>> 17) + x | 0, m += (x ^ (P | ~h)) + b[5] - 57434055 | 0, m = (m << 21 | m >>> 11) + P | 0, h += (P ^ (m | ~x)) + b[12] + 1700485571 | 0, h = (h << 6 | h >>> 26) + m | 0, x += (m ^ (h | ~P)) + b[3] - 1894986606 | 0, x = (x << 10 | x >>> 22) + h | 0, P += (h ^ (x | ~m)) + b[10] - 1051523 | 0, P = (P << 15 | P >>> 17) + x | 0, m += (x ^ (P | ~h)) + b[1] - 2054922799 | 0, m = (m << 21 | m >>> 11) + P | 0, h += (P ^ (m | ~x)) + b[8] + 1873313359 | 0, h = (h << 6 | h >>> 26) + m | 0, x += (m ^ (h | ~P)) + b[15] - 30611744 | 0, x = (x << 10 | x >>> 22) + h | 0, P += (h ^ (x | ~m)) + b[6] - 1560198380 | 0, P = (P << 15 | P >>> 17) + x | 0, m += (x ^ (P | ~h)) + b[13] + 1309151649 | 0, m = (m << 21 | m >>> 11) + P | 0, h += (P ^ (m | ~x)) + b[4] - 145523070 | 0, h = (h << 6 | h >>> 26) + m | 0, x += (m ^ (h | ~P)) + b[11] - 1120210379 | 0, x = (x << 10 | x >>> 22) + h | 0, P += (h ^ (x | ~m)) + b[2] + 718787259 | 0, P = (P << 15 | P >>> 17) + x | 0, m += (x ^ (P | ~h)) + b[9] - 343485551 | 0, m = (m << 21 | m >>> 11) + P | 0, g[0] = h + g[0] | 0, g[1] = m + g[1] | 0, g[2] = P + g[2] | 0, g[3] = x + g[3] | 0;
    }
    function i(g) {
      var b = [], h;
      for (h = 0; h < 64; h += 4)
        b[h >> 2] = g.charCodeAt(h) + (g.charCodeAt(h + 1) << 8) + (g.charCodeAt(h + 2) << 16) + (g.charCodeAt(h + 3) << 24);
      return b;
    }
    function a(g) {
      var b = [], h;
      for (h = 0; h < 64; h += 4)
        b[h >> 2] = g[h] + (g[h + 1] << 8) + (g[h + 2] << 16) + (g[h + 3] << 24);
      return b;
    }
    function s(g) {
      var b = g.length, h = [1732584193, -271733879, -1732584194, 271733878], m, P, x, A, N, D;
      for (m = 64; m <= b; m += 64)
        o(h, i(g.substring(m - 64, m)));
      for (g = g.substring(m - 64), P = g.length, x = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], m = 0; m < P; m += 1)
        x[m >> 2] |= g.charCodeAt(m) << (m % 4 << 3);
      if (x[m >> 2] |= 128 << (m % 4 << 3), m > 55)
        for (o(h, x), m = 0; m < 16; m += 1)
          x[m] = 0;
      return A = b * 8, A = A.toString(16).match(/(.*?)(.{0,8})$/), N = parseInt(A[2], 16), D = parseInt(A[1], 16) || 0, x[14] = N, x[15] = D, o(h, x), h;
    }
    function u(g) {
      var b = g.length, h = [1732584193, -271733879, -1732584194, 271733878], m, P, x, A, N, D;
      for (m = 64; m <= b; m += 64)
        o(h, a(g.subarray(m - 64, m)));
      for (g = m - 64 < b ? g.subarray(m - 64) : new Uint8Array(0), P = g.length, x = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], m = 0; m < P; m += 1)
        x[m >> 2] |= g[m] << (m % 4 << 3);
      if (x[m >> 2] |= 128 << (m % 4 << 3), m > 55)
        for (o(h, x), m = 0; m < 16; m += 1)
          x[m] = 0;
      return A = b * 8, A = A.toString(16).match(/(.*?)(.{0,8})$/), N = parseInt(A[2], 16), D = parseInt(A[1], 16) || 0, x[14] = N, x[15] = D, o(h, x), h;
    }
    function l(g) {
      var b = "", h;
      for (h = 0; h < 4; h += 1)
        b += r[g >> h * 8 + 4 & 15] + r[g >> h * 8 & 15];
      return b;
    }
    function f(g) {
      var b;
      for (b = 0; b < g.length; b += 1)
        g[b] = l(g[b]);
      return g.join("");
    }
    f(s("hello")), typeof ArrayBuffer < "u" && !ArrayBuffer.prototype.slice && function() {
      function g(b, h) {
        return b = b | 0 || 0, b < 0 ? Math.max(b + h, 0) : Math.min(b, h);
      }
      ArrayBuffer.prototype.slice = function(b, h) {
        var m = this.byteLength, P = g(b, m), x = m, A, N, D, M;
        return h !== n && (x = g(h, m)), P > x ? new ArrayBuffer(0) : (A = x - P, N = new ArrayBuffer(A), D = new Uint8Array(N), M = new Uint8Array(this, P, A), D.set(M), N);
      };
    }();
    function d(g) {
      return /[\u0080-\uFFFF]/.test(g) && (g = unescape(encodeURIComponent(g))), g;
    }
    function y(g, b) {
      var h = g.length, m = new ArrayBuffer(h), P = new Uint8Array(m), x;
      for (x = 0; x < h; x += 1)
        P[x] = g.charCodeAt(x);
      return b ? P : m;
    }
    function v(g) {
      return String.fromCharCode.apply(null, new Uint8Array(g));
    }
    function p(g, b, h) {
      var m = new Uint8Array(g.byteLength + b.byteLength);
      return m.set(new Uint8Array(g)), m.set(new Uint8Array(b), g.byteLength), m;
    }
    function S(g) {
      var b = [], h = g.length, m;
      for (m = 0; m < h - 1; m += 2)
        b.push(parseInt(g.substr(m, 2), 16));
      return String.fromCharCode.apply(String, b);
    }
    function _() {
      this.reset();
    }
    return _.prototype.append = function(g) {
      return this.appendBinary(d(g)), this;
    }, _.prototype.appendBinary = function(g) {
      this._buff += g, this._length += g.length;
      var b = this._buff.length, h;
      for (h = 64; h <= b; h += 64)
        o(this._hash, i(this._buff.substring(h - 64, h)));
      return this._buff = this._buff.substring(h - 64), this;
    }, _.prototype.end = function(g) {
      var b = this._buff, h = b.length, m, P = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], x;
      for (m = 0; m < h; m += 1)
        P[m >> 2] |= b.charCodeAt(m) << (m % 4 << 3);
      return this._finish(P, h), x = f(this._hash), g && (x = S(x)), this.reset(), x;
    }, _.prototype.reset = function() {
      return this._buff = "", this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
    }, _.prototype.getState = function() {
      return {
        buff: this._buff,
        length: this._length,
        hash: this._hash.slice()
      };
    }, _.prototype.setState = function(g) {
      return this._buff = g.buff, this._length = g.length, this._hash = g.hash, this;
    }, _.prototype.destroy = function() {
      delete this._hash, delete this._buff, delete this._length;
    }, _.prototype._finish = function(g, b) {
      var h = b, m, P, x;
      if (g[h >> 2] |= 128 << (h % 4 << 3), h > 55)
        for (o(this._hash, g), h = 0; h < 16; h += 1)
          g[h] = 0;
      m = this._length * 8, m = m.toString(16).match(/(.*?)(.{0,8})$/), P = parseInt(m[2], 16), x = parseInt(m[1], 16) || 0, g[14] = P, g[15] = x, o(this._hash, g);
    }, _.hash = function(g, b) {
      return _.hashBinary(d(g), b);
    }, _.hashBinary = function(g, b) {
      var h = s(g), m = f(h);
      return b ? S(m) : m;
    }, _.ArrayBuffer = function() {
      this.reset();
    }, _.ArrayBuffer.prototype.append = function(g) {
      var b = p(this._buff.buffer, g), h = b.length, m;
      for (this._length += g.byteLength, m = 64; m <= h; m += 64)
        o(this._hash, a(b.subarray(m - 64, m)));
      return this._buff = m - 64 < h ? new Uint8Array(b.buffer.slice(m - 64)) : new Uint8Array(0), this;
    }, _.ArrayBuffer.prototype.end = function(g) {
      var b = this._buff, h = b.length, m = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], P, x;
      for (P = 0; P < h; P += 1)
        m[P >> 2] |= b[P] << (P % 4 << 3);
      return this._finish(m, h), x = f(this._hash), g && (x = S(x)), this.reset(), x;
    }, _.ArrayBuffer.prototype.reset = function() {
      return this._buff = new Uint8Array(0), this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
    }, _.ArrayBuffer.prototype.getState = function() {
      var g = _.prototype.getState.call(this);
      return g.buff = v(g.buff), g;
    }, _.ArrayBuffer.prototype.setState = function(g) {
      return g.buff = y(g.buff, !0), _.prototype.setState.call(this, g);
    }, _.ArrayBuffer.prototype.destroy = _.prototype.destroy, _.ArrayBuffer.prototype._finish = _.prototype._finish, _.ArrayBuffer.hash = function(g, b) {
      var h = u(new Uint8Array(g)), m = f(h);
      return b ? S(m) : m;
    }, _;
  });
})(Mh);
const kh = "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", jh = (e) => Uint8Array.from(atob(e), (t) => t.charCodeAt(0));
typeof window < "u" && window.Blob && new Blob([jh(kh)], { type: "text/javascript;charset=utf-8" });
function Ch() {
  const e = navigator.userAgent;
  return e.match(/compatible/i) || e.match(/Windows/i) ? "windows" : e.match(/Macintosh/i) || e.match(/MacIntel/i) ? "macOS" : e.match(/iphone/i) || e.match(/Ipad/i) ? "ios" : e.match(/android/i) ? "android" : "unknown OS";
}
function Dh() {
  const e = navigator.userAgent, t = [{
    name: "chrome",
    it: e.indexOf("Chrome") > -1 || e.indexOf("CriOS") > -1
  }, {
    name: "firefox",
    it: e.indexOf("Firefox") > -1
  }, {
    name: "safari",
    it: e.indexOf("Safari") > -1 && e.indexOf("Chrome") === -1
  }, {
    name: "opera",
    it: e.indexOf("Opera") > -1 || e.indexOf("OPR") > -1
  }, {
    name: "edge",
    it: e.indexOf("Edge") > -1
  }, {
    name: "ie11",
    it: e.indexOf("Trident") > -1 && e.indexOf("rv:11.0") > -1
  }, {
    name: "ie",
    it: e.indexOf("compatible") > -1 && e.indexOf("MSIE") > -1
  }, {
    name: "wechat",
    it: /MicroMessenger/i.test(e)
  }];
  for (let n = 0; n < t.length; n++)
    if (t[n].it)
      return t[n].name;
  return e;
}
function Rh() {
  return window.screen.width + "x" + window.screen.height;
}
function mi(e) {
  return typeof e == "function";
}
function Nh(e) {
  if (!Array.isArray(e))
    throw new Error("plugins must be an array");
  if (e != null && e.some((t) => !mi(t)))
    throw new Error("plugins must be all functions");
  return (t, n, r) => {
    let o = -1;
    const i = async (a, s) => {
      if (a == o)
        throw new Error("next() called multiple times");
      if (a == e.length)
        return r(s);
      o = a;
      const u = e[a];
      await u(t, s, (l) => {
        i(a + 1, l);
      });
    };
    i(0, n);
  };
}
function Lh() {
  return "1.0.7";
}
function dr(e, t) {
  var n, r;
  const o = new XMLHttpRequest();
  o.open("POST", e), o.setRequestHeader("content-type", "application/json"), (n = t == null ? void 0 : t.user) != null && n.token && o.setRequestHeader("X-Access-Token", (r = t == null ? void 0 : t.user) == null ? void 0 : r.token), o.onreadystatechange = () => {
    o.readyState === XMLHttpRequest.DONE && o.status;
  }, o.onerror = (i) => {
    console.warn("mogic-tracker", i);
  }, o.send(JSON.stringify(t));
}
function Ih(e, t) {
  const n = (t == null ? void 0 : t.env) || "dev";
  let r = "back.getmogic.com";
  n == "beta" ? r = "c" + r : n == "dev" && (r = "k" + r), t != null && t.useNew ? t != null && t.customHost ? dr(`${t == null ? void 0 : t.customHost}/creativeSaas/burialPoint/burialLog`, e) : dr(`https://${r}/creativeSaas/burialPoint/burialLog`, e) : t != null && t.customHost ? dr(`${t == null ? void 0 : t.customHost}/creativeSaas/burialPoint/recordLog`, e) : dr(`https://${r}/creativeSaas/burialPoint/recordLog`, e);
}
var En = /* @__PURE__ */ ((e) => (e.PAGE_SHOW = "pageShow", e.BEHAVIOR = "behavior", e))(En || {}), Fh = Object.defineProperty, Uh = (e, t, n) => t in e ? Fh(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ra = (e, t, n) => (Uh(e, typeof t != "symbol" ? t + "" : t, n), n);
class zh {
  constructor(t) {
    Ra(this, "history"), Ra(this, "opts"), this.history = [], this.opts = {
      maxLength: 2,
      ...t
    };
  }
  record(t) {
    const { title: n, referrer: r } = document, { hash: o, href: i } = window.location, a = /#.*$/;
    let [s, u = ""] = o.split("?") || [];
    s = s.replace(/#/, "");
    const l = i.replace(a, ""), f = u == null ? void 0 : u.split("&").reduce((y, v) => {
      const [p, S] = v.split("=");
      return y[p] = S, y;
    }, /* @__PURE__ */ Object.create(null)), d = {
      title: n,
      url: i,
      hostname: l,
      hash: o,
      query: f,
      queryStr: u,
      path: s
    };
    r && (d.referrer = r), this.add({
      ...d,
      ...t
    });
  }
  add(t) {
    this.history.push(t), this.history.slice(-1 * this.opts.maxLength);
  }
  get last() {
    var t;
    return (t = this.history) != null && t.length ? this.history[this.history.length - 1] : null;
  }
  destroy() {
    this.history = [];
  }
}
var Kh = Object.defineProperty, Gh = (e, t, n) => t in e ? Kh(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Na = (e, t, n) => (Gh(e, typeof t != "symbol" ? t + "" : t, n), n);
function Zh() {
  class e extends HTMLElement {
    constructor() {
      super(), Na(this, "_shadowRoot"), Na(this, "container"), this._shadowRoot = this.attachShadow({ mode: "open" }), this._shadowRoot.appendChild(this.template()), this.container = this._shadowRoot.querySelector("#track-list"), this._shadowRoot.querySelector(".track-me-close").addEventListener(
        "click",
        () => {
          this._shadowRoot.querySelector(".track-me").classList.toggle("hidden");
        },
        !1
      );
    }
    get list() {
      try {
        return JSON.parse(this.getAttribute("data-list"));
      } catch {
      }
    }
    static get observedAttributes() {
      return ["data-list"];
    }
    attributeChangedCallback() {
      this.render();
    }
    addLog(n) {
      const r = this.list || [];
      r.unshift(n), this.setAttribute("data-list", JSON.stringify(r));
    }
    template() {
      const n = document.createElement("template");
      return n.innerHTML = `
        <style>
        .track-me {
          position: fixed;
          z-index: 99999;
          bottom: 0;
          left: 0;
          background: #9ce5c494;
          font-size: 12px;
          padding-right: 5px;
          padding-top: 20px;
        }
        .track-me.hidden {
          transform: translateX(-100%);
        }
        .track-me p {
          padding: 0;
          margin: 0;
        }
        .track-me ul {
          list-style: none;
          padding: 0 8px;
          margin: 0;
          min-width: 240px;
          max-height: 240px;
          overflow-y: scroll;
        }
        .track-me ul::-webkit-scrollbar {
          width: 5px;
          display: block;
        }
        .track-me ul::-webkit-scrollbar-thumb {
          background: rgba(30, 29, 53, 0.11);
          border-radius: 60px;
        }
        .track-me .track-row {
          padding: 6px 4px;
          border-bottom: 1px solid #ffffffa8;
          display: flex;
          justify-content: space-between;
        }
        .track-me .track-row:hover {
          background: #8fecc2;
        }
        .track-me .track-row.error { color: #ed0707; }
        .track-me .track-row.deprecated { color: #bc20ef; }
        .track-me .track-time {
          margin-left: 10px;
        }
        .track-me .track-me-close {
          position: absolute;
          top: 0;
          right: -26px;
          width: 10px;
          background: #d9d9d9;
          padding: 4px 8px;
        }
        </style>
        <div class="track-me">
          <ul id="track-list"></ul>
          <span class="track-me-close">收起</span>
        </div>
      `, n.content.cloneNode(!0);
    }
    formatTime(n) {
      const r = new Date(n);
      return [r.getHours(), r.getMinutes(), r.getSeconds()].map((o) => ("" + o).padStart(2, "0")).join(":");
    }
    render() {
      const n = (this.list || []).map(
        (r) => `
        <li class="track-row ${r.deprecated ? "deprecated" : ""} ${r.valid ? "" : "error"}">
          <div>
            <p>${r.spmId}</p>
            <p>${r.extParam || ""}</p>
          </div>
          <span class="track-time">${this.formatTime(r.timestamp)}</span>
        </li>`
      ).join("");
      this.container.innerHTML = n;
    }
  }
  return e;
}
async function Xh(e) {
  return (await fetch(
    "https://mogic-logger-server.dev.getmogic.com/track/validate",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(e)
    }
  )).json();
}
let On;
const Hh = async (e, t, n) => {
  customElements.get("track-me") || customElements.define("track-me", Zh()), e.options.debug && !On && (On = document.createElement("track-me"), document.body.appendChild(On));
  const {
    type: r,
    eventId: o,
    event_id: i,
    eventFrom: a,
    timestamp: s,
    reportTimestamp: u,
    page: l
  } = t || {}, f = (l == null ? void 0 : l.pageId) || t.pageId || "", [d = "", y = ""] = f == null ? void 0 : f.split(".");
  let v = !0;
  if (e.options.validate)
    try {
      const p = e.options.validate ? await Xh({ appId: d, eventId: o || i }) : await Promise.resolve({ data: !0 });
      v = !!(p != null && p.data);
    } catch {
    }
  On == null || On.addLog({
    spmId: [
      r,
      [d, y, o || i, a].filter(Boolean).join(".")
    ].filter(Boolean).join(" | "),
    // extParam: JSON.stringify(params),
    timestamp: s || u,
    valid: v,
    // 新旧sdk提示
    deprecated: !l
  }), (!e.options.validate || v) && n(t);
};
var Bh = Object.defineProperty, Vh = (e, t, n) => t in e ? Bh(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, pr = (e, t, n) => (Vh(e, typeof t != "symbol" ? t + "" : t, n), n);
class Wh {
  constructor(t) {
    pr(this, "options"), pr(this, "common"), pr(this, "pageStack"), pr(this, "_transform");
    const n = {
      useNew: !0,
      // 默认使用新埋点结构
      ...t
    };
    this.initCommon(n), this.pageStack = new zh(), this.options = n;
    const r = (n == null ? void 0 : n.plugins) || [];
    (n != null && n.debug || n != null && n.validate) && r.unshift(Hh), this._transform = Nh(r);
  }
  initCommon(t) {
    const { appId: n, appName: r, appVersion: o } = t || {};
    this.common = {
      os: Ch(),
      // 系统
      ua: Dh(),
      // 浏览器
      sr: Rh(),
      // 屏幕分辨率
      appId: n,
      appName: r,
      appVersion: o
    };
  }
  // page 目前也兼容新旧两套版本
  page(t, n = null) {
    this.pageStack.record(t), t != null && t.isNew ? this._report({
      type: En.PAGE_SHOW,
      isNew: !0
    }) : this._report({
      params: n,
      type: En.PAGE_SHOW
    });
  }
  track(t, n = null) {
    typeof t == "string" ? this._report({
      type: En.BEHAVIOR,
      event_id: t,
      params: n
    }) : this._report({
      type: En.BEHAVIOR,
      eventId: t.eventId,
      eventFrom: t.eventFrom,
      eventTargets: t.eventTargets,
      isNew: !0
    });
  }
  async _report(t) {
    var n, r, o;
    if (!t.type)
      return;
    const i = this.pageStack.last, a = [this.common.appId, i == null ? void 0 : i.pageId].filter(Boolean).join("."), s = {
      common: this.common,
      // 兼容一下
      user: mi((n = this.options) == null ? void 0 : n.userInfo) ? (r = this.options) == null ? void 0 : r.userInfo() : (o = this.options) == null ? void 0 : o.userInfo,
      type: t.type,
      // 旧版本
      ...t.event_id ? { event_id: t.event_id } : null,
      // 新版本
      ...t.eventId ? { eventId: t.eventId } : null,
      ...t.eventFrom ? { eventFrom: t.eventFrom } : null
    };
    t.isNew ? (s.sdkVersion = Lh(), s.page = {
      pageId: a,
      urlParams: (i == null ? void 0 : i.queryStr) || "",
      ...i == null ? void 0 : i.extend
    }, s.events = t.eventTargets || [], s.reportTimestamp = Date.now()) : (s.pageId = a, s.params = t.params, s.timestamp = Date.now()), this._transform(this, s, (u) => {
      var l;
      const { customRequest: f, env: d, useNew: y } = this.options || {};
      if (u && mi(f)) {
        f(u);
        return;
      }
      Ih(u, {
        env: d,
        useNew: y && t.isNew,
        customHost: (l = this.options) == null ? void 0 : l.customHost
      });
    });
  }
  destroy() {
    var t;
    (t = this.pageStack) == null || t.destroy();
  }
}
typeof window < "u" && window.mogicTrackerConfig && (window.mogicTracker = new Wh(window.mogicTrackerConfig));
const g0 = (e, t) => {
  const n = O(!1), r = async (...o) => {
    if (!n.value)
      try {
        n.value = !0, await Sf(e)(...o);
      } finally {
        n.value = !1;
      }
  };
  return t != null && t.immediate && (t.args ? r(...t.args) : r()), [r, n];
};
function Jh(e) {
  const t = O([]);
  return C({
    get: () => t.value,
    set(r) {
      if (e) {
        const o = r.reduce((i, a) => i.set(a[e], a), /* @__PURE__ */ new Map());
        t.value = [...o.values()];
      } else
        t.value = r;
    }
  });
}
const b0 = (e, t) => {
  const n = {
    pageIndex: 1,
    pageSize: (t == null ? void 0 : t.pageSize) || 15,
    totalPage: -1
  }, r = ae({ ...n }), o = O(!1), i = Jh(t == null ? void 0 : t.key), a = C(() => !i.value.length), s = C(() => r.totalPage === -1 || r.totalPage >= r.pageIndex), u = new _f();
  let l = !1;
  const f = async (...v) => {
    if (!s.value || !l && o.value) return;
    l = !1;
    const { pageIndex: p, pageSize: S } = r, _ = { pageIndex: p, pageSize: S, cancelAdd: (...g) => u.add(...g) };
    try {
      o.value = !0;
      const g = await u.add(e(_, ...v));
      g && (g.list && (t != null && t.isInReverseOrder ? (g.list = g.list.reverse(), i.value = [...g.list, ...i.value]) : i.value = r.pageIndex === 1 ? g.list : [...i.value, ...g.list]), r.pageIndex++, r.totalPage = g.totalPage), o.value = !1;
    } catch (g) {
      if (_s(g)) return;
      if (o.value = !1, bf.isFunction(t == null ? void 0 : t.failedCallback)) {
        const b = t.failedCallback(_);
        b && (i.value = [...i.value, ...b.list || []], r.totalPage = b.totalPage);
      } else
        throw g;
    }
  };
  function d(v = !0, ...p) {
    if (!(t != null && t.unclearRefreshing) && (i.value = []), Object.assign(r, n), u.cancelAll(), v)
      return l = !0, f(...p);
    o.value = !1;
  }
  const y = (...v) => d(!0, ...v);
  return t != null && t.immediate && (t.args ? f(...t.args) : f()), { pagination: r, loading: o, list: i, refreshList: d, refresh: y, getList: f, empty: a, hasMore: s };
}, w0 = (e, t) => {
  const { height: n, width: r } = rc(), { width: o, height: i } = ts(t == null ? void 0 : t.box), a = C(() => t != null && t.box ? o.value : Lt(t.maxWidth) ?? Lt(r) - Lt(t.marginX)), s = C(() => t != null && t.box ? i.value : Lt(t.maxHeight) ?? Lt(n) - Lt(t.marginY)), u = O(0), l = O(0);
  I(
    [a, s, Fa(e)],
    ([d, y, v]) => {
      if (!v) return;
      const p = Math.min(d, y * v), S = Math.min(y, d / v);
      u.value = p, l.value = S;
    },
    { immediate: !0 }
  );
  const f = C(() => ({ width: `${u.value}rem`, height: `${l.value}rem` }));
  return { width: u, height: l, style: f };
};
function S0(e, t) {
  const n = (t == null ? void 0 : t.defaultValue) === void 0 ? O() : O(t.defaultValue), r = t.init ? n : Kt(e, n);
  return t.init && yi(e, n), r;
}
function P0(e, t, n) {
  const { init: r, ...o } = n || {}, i = typeof t == "function" ? C(t, o) : C(t, o), a = n.init ? i : Kt(e, i);
  return n.init && yi(e, i), a;
}
function x0(e) {
  const t = ae(qi(e));
  return [t, () => {
    Object.assign(t, qi(e));
  }];
}
export {
  Ml as DefaultMagicKeysAliasMap,
  $a as StorageSerializers,
  e0 as TransitionPresets,
  sv as assert,
  Qv as asyncComputed,
  vv as autoResetRef,
  bm as breakpointsAntDesign,
  ym as breakpointsBootstrapV5,
  Pm as breakpointsMasterCss,
  xm as breakpointsPrimeFlex,
  wm as breakpointsQuasar,
  Sm as breakpointsSematic,
  mm as breakpointsTailwind,
  gm as breakpointsVuetify,
  Dr as bypassFilter,
  ku as camelize,
  Ro as clamp,
  Lr as cloneFnJSON,
  Qv as computedAsync,
  Qh as computedEager,
  qv as computedInject,
  za as computedWithControl,
  Ba as containsProp,
  za as controlledComputed,
  bv as controlledRef,
  Te as createEventHook,
  Ym as createFetch,
  Vt as createFilterWrapper,
  qh as createGlobalState,
  ev as createInjectionState,
  y0 as createProgressGuard,
  Su as createReactiveFn,
  em as createReusableTemplate,
  tv as createSharedComposable,
  ju as createSingletonPromise,
  tm as createTemplatePromise,
  nm as createUnrefFn,
  Zi as customStorageEventName,
  Si as debounceFilter,
  mv as debouncedRef,
  Hv as debouncedWatch,
  Me as defaultDocument,
  rm as defaultLocation,
  Ce as defaultNavigator,
  U as defaultWindow,
  cv as directiveHooks,
  Qh as eagerComputed,
  Jl as executeTransition,
  bu as extendRef,
  Vu as formatDate,
  Bl as formatTimeAgo,
  nv as get,
  Nr as getLifeCycleTarget,
  _i as getSSRHandler,
  Eu as hasOwn,
  fv as hyphenate,
  Ha as identity,
  _r as ignorableWatch,
  Cu as increaseWithUnit,
  gu as injectLocal,
  dv as invoke,
  xe as isClient,
  _u as isDef,
  rv as isDefined,
  oi as isIOS,
  Cr as isObject,
  xu as isWorker,
  wu as makeDestructurable,
  ry as mapGamepadToXbox360Controller,
  re as noop,
  Wu as normalizeDate,
  Ga as notNullish,
  uv as now,
  Nu as objectEntries,
  Ru as objectOmit,
  Du as objectPick,
  om as onClickOutside,
  im as onKeyDown,
  am as onKeyPressed,
  xi as onKeyStroke,
  sm as onKeyUp,
  um as onLongPress,
  lm as onStartTyping,
  Za as pausableFilter,
  Pr as pausableWatch,
  Sr as promiseTimeout,
  yu as provideLocal,
  lv as rand,
  Su as reactify,
  iv as reactifyObject,
  Ka as reactiveComputed,
  av as reactiveOmit,
  hv as reactivePick,
  vv as refAutoReset,
  mv as refDebounced,
  yv as refDefault,
  gv as refThrottled,
  Lu as refWithControl,
  pv as resolveRef,
  ov as resolveUnref,
  wv as set,
  jm as setSSRHandler,
  zi as syncRef,
  Sv as syncRefs,
  cm as templateRef,
  Rr as throttleFilter,
  gv as throttledRef,
  Jv as throttledWatch,
  Ht as timestamp,
  Pu as toReactive,
  ve as toRef,
  Wa as toRefs,
  T as toValue,
  Pv as tryOnBeforeMount,
  Iu as tryOnBeforeUnmount,
  me as tryOnMounted,
  V as tryOnScopeDispose,
  Fu as tryOnUnmounted,
  Y as unrefElement,
  xr as until,
  rl as useActiveElement,
  fm as useAnimate,
  xv as useArrayDifference,
  _v as useArrayEvery,
  Ov as useArrayFilter,
  Ev as useArrayFind,
  Tv as useArrayFindIndex,
  Av as useArrayFindLast,
  Mv as useArrayIncludes,
  kv as useArrayJoin,
  jv as useArrayMap,
  Cv as useArrayReduce,
  Dv as useArraySome,
  Rv as useArrayUnique,
  dm as useAsyncQueue,
  al as useAsyncState,
  pm as useBase64,
  hm as useBattery,
  vm as useBluetooth,
  _m as useBreakpoints,
  Om as useBroadcastChannel,
  Em as useBrowserLocation,
  Tm as useCached,
  Am as useClipboard,
  Mm as useClipboardItems,
  km as useCloned,
  cl as useColorMode,
  Cm as useConfirmDialog,
  Nv as useCounter,
  sr as useCssVar,
  fl as useCurrentElement,
  Dm as useCycleList,
  Rm as useDark,
  Lv as useDateFormat,
  mv as useDebounce,
  Pi as useDebounceFn,
  Nm as useDebouncedRefHistory,
  Lm as useDeviceMotion,
  ml as useDeviceOrientation,
  Im as useDevicePixelRatio,
  Fm as useDevicesList,
  Um as useDisplayMedia,
  zm as useDocumentVisibility,
  Km as useDraggable,
  Gm as useDropZone,
  Zm as useElementBounding,
  Xm as useElementByPoint,
  Hm as useElementHover,
  ts as useElementSize,
  gl as useElementVisibility,
  Bm as useEventBus,
  R as useEventListener,
  Vm as useEventSource,
  Wm as useEyeDropper,
  Jm as useFavicon,
  Sl as useFetch,
  $m as useFileDialog,
  Qm as useFileSystemAccess,
  qm as useFocus,
  ey as useFocusWithin,
  ty as useFps,
  ny as useFullscreen,
  oy as useGamepad,
  iy as useGeolocation,
  b0 as useGetList,
  ay as useIdle,
  sy as useImage,
  uy as useInfiniteScroll,
  P0 as useInjectComputed,
  S0 as useInjectRef,
  yl as useIntersectionObserver,
  Iv as useInterval,
  St as useIntervalFn,
  ly as useKeyModifier,
  Fv as useLastChanged,
  cy as useLocalStorage,
  g0 as useLockCallback,
  fy as useMagicKeys,
  vl as useManualRefHistory,
  Jh as useMapList,
  dy as useMediaControls,
  ke as useMediaQuery,
  py as useMemoize,
  hy as useMemory,
  ol as useMounted,
  Dl as useMouse,
  Rl as useMouseInElement,
  vy as useMousePressed,
  Ei as useMutationObserver,
  my as useNavigatorLanguage,
  Nl as useNetwork,
  Ll as useNow,
  yy as useObjectUrl,
  gy as useOffsetPagination,
  by as useOnline,
  wy as usePageLeave,
  Sy as useParallax,
  Py as useParentElement,
  xy as usePerformanceObserver,
  ai as usePermission,
  _y as usePointer,
  Oy as usePointerLock,
  Ey as usePointerSwipe,
  Ty as usePreferredColorScheme,
  Ay as usePreferredContrast,
  Qa as usePreferredDark,
  My as usePreferredLanguages,
  ky as usePreferredReducedMotion,
  jy as usePrevious,
  Wt as useRafFn,
  w0 as useRatioSize,
  es as useRefHistory,
  x0 as useResetReactive,
  Ti as useResizeObserver,
  h0 as useRouteHash,
  v0 as useRouteParams,
  m0 as useRouteQuery,
  Cy as useScreenOrientation,
  Dy as useScreenSafeArea,
  Ry as useScriptTag,
  Tl as useScroll,
  Ny as useScrollLock,
  Ly as useSessionStorage,
  Iy as useShare,
  Fy as useSorted,
  Uy as useSpeechRecognition,
  zy as useSpeechSynthesis,
  Ky as useStepper,
  Oi as useStorage,
  Gy as useStorageAsync,
  Zy as useStyleTag,
  $ as useSupported,
  Xy as useSwipe,
  Hy as useTemplateRefsList,
  By as useTextDirection,
  Vy as useTextSelection,
  Wy as useTextareaAutosize,
  gv as useThrottle,
  Va as useThrottleFn,
  Jy as useThrottledRefHistory,
  Yy as useTimeAgo,
  Uv as useTimeout,
  jn as useTimeoutFn,
  $y as useTimeoutPoll,
  Qy as useTimestamp,
  qy as useTitle,
  zv as useToNumber,
  Kv as useToString,
  Gv as useToggle,
  t0 as useTransition,
  n0 as useUrlSearchParams,
  r0 as useUserMedia,
  Yl as useVModel,
  o0 as useVModels,
  i0 as useVibrate,
  a0 as useVirtualList,
  s0 as useWakeLock,
  u0 as useWebNotification,
  l0 as useWebSocket,
  c0 as useWebWorker,
  f0 as useWebWorkerFn,
  d0 as useWindowFocus,
  p0 as useWindowScroll,
  rc as useWindowSize,
  Zv as watchArray,
  Xv as watchAtMost,
  Hv as watchDebounced,
  Bv as watchDeep,
  _r as watchIgnorable,
  Vv as watchImmediate,
  Wv as watchOnce,
  Pr as watchPausable,
  Jv as watchThrottled,
  Yv as watchTriggerable,
  kn as watchWithFilter,
  $v as whenever
};
